angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/demo.html',
    '<ion-view class="patient-info">\n' +
    '  <ion-header-bar class="bar-texture">\n' +
    '    <div class="buttons left-buttons">\n' +
    '      <span>\n' +
    '      <button class="button button-icon button-clear ion-navicon ripple" ng-click="toggleLeft()"></button>\n' +
    '      </span>\n' +
    '    </div>\n' +
    '    <h1 class="title title-left">Demo Settings</h1>\n' +
    '    <div class="buttons right-buttons user-name-section">\n' +
    '      <network-status-checker></network-status-checker>\n' +
    '      <p id="username-label" class="button button-clear">{{getUserName()}}</p>\n' +
    '      <!--<button class="button button-icon ion-gear-a" ng-click="popover.show($event)"></button>-->\n' +
    '      <button class="button button-icon ion-log-out ripple" ng-click="logout()" ng-disabled="!vm.isOnline()"></button>\n' +
    '    </div>\n' +
    '\n' +
    '  </ion-header-bar>\n' +
    '  <ion-content>\n' +
    '    <div class="padding">\n' +
    '      <div class="list card">\n' +
    '        <a href="javascript:void(0)" class="item no-padding" ng-click="createExam()">\n' +
    '          <div class="item ripple item-icon-left">\n' +
    '            <i class="icon ion-card"></i>\n' +
    '            Create new exam\n' +
    '          </div>          \n' +
    '        </a>\n' +
    '\n' +
    '        <a href="javascript:void(0)" class="item no-padding" ng-click="insertDemoData()">\n' +
    '          <div class="item ripple item-icon-left">\n' +
    '            <i class="icon ion-card"></i>\n' +
    '            Do demo\n' +
    '          </div>          \n' +
    '        </a>\n' +
    '\n' +
    '        <a class="item item-icon-left" ng-click="deleteAllWorklists()"\n' +
    '           ng-if="techpadSettings.IsShowDeleteAllWorklistsButton">\n' +
    '          <i class="icon ion-trash-a"></i>\n' +
    '          Clean studies list\n' +
    '        </a>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '</ion-view>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/diagram.html',
    '<ion-view title="Diagram" class="findings-page">\n' +
    '  <ion-content padding="true" scroll="false">\n' +
    '    <h4>\n' +
    '      Editing diagram for selected patient\n' +
    '    </h4>\n' +
    '    <button ng-click="vm.startSaving()" class="button button-positive" ng-hide="vm.loading">Save Changes</button>\n' +
    '    <button class="button button-positive button-clear icon ion-loading-c" ng-show="vm.loading"></button>\n' +
    '\n' +
    '    <div class="row findings-container">\n' +
    '      <div id="findingsEditorContainer" drop-target=\'true\' on-drop=\'vm.dropped\'>\n' +
    '\n' +
    '        <div id="findingsEditor" diagram-editor problems="vm.problemsList" selected="vm.selectedElement" zoom="vm.zoom"\n' +
    '             get-mode="vm.getMode" add-problem="vm.addProblem" draw-scar="vm.drawScar" save-action=\'vm.save\'\n' +
    '             skip-auto-save=\'true\' problem-settings="\'vm.techpadConfig.settings.DiagramSettings\'">\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="right-panel">\n' +
    '        <div class="panel-item hint-alert">\n' +
    '          <span ng-show="vm.mode==\'s\'">Use your finger to draw</span>\n' +
    '          <span ng-show="vm.mode!=\'\' && vm.mode!=\'s\'">Tap on image to add</span>\n' +
    '          <span ng-show="vm.mode==\'\'">Select or drag to image</span>\n' +
    '        </div>\n' +
    '        <div class="list">\n' +
    '          <div class="panel-item item-icon-left" ng-class="{ active: vm.mode == \'s\' }" ng-click="vm.turnMode(\'s\')">\n' +
    '            <div class="item-content">\n' +
    '              <i class="icon ion-scar"></i>\n' +
    '              <span>{{vm.problemCodes[\'s\']}}</span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="panel-item item-icon-left" ng-repeat="el in vm.problems"\n' +
    '               ng-class="{ active: vm.mode == el.value }"\n' +
    '               ng-click="vm.turnMode(el.value)" draggable="true">\n' +
    '            <div class="item-content">\n' +
    '              <i class="icon {{el.icon}}"></i>\n' +
    '              <span>{{vm.problemCodes[el.value]}}&nbsp;&nbsp;&nbsp;</span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '          <button type="button" ng-hide="vm.problemsList.length == 0"\n' +
    '                  class="button button-stable button-block button-small" ng-click=\'vm.startClearing()\'>Clear diagram\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <hr class="comments-header-hr"/>\n' +
    '    <h3 class="comments-header">Comments</h3>\n' +
    '    <div class="row">\n' +
    '      <div class="col-33 padding" ng-show="vm.selectedElement">\n' +
    '        <textarea class="findings-comment-area" ng-model="vm.commentText" ng-focus="showDone = true"\n' +
    '                  ng-blur="showDone = false"></textarea>\n' +
    '        <p>\n' +
    '          <button class="button button-outline button-positive button-add-comment" ng-click=\'vm.addComment()\'\n' +
    '                  ng-disabled="!vm.commentChanged()">\n' +
    '            Update\n' +
    '          </button>\n' +
    '          <button class="button button-outline button-default button-add-comment" ng-click="vm.revertComment()"\n' +
    '                  ng-disabled="!vm.commentChanged()">\n' +
    '            Cancel\n' +
    '          </button>\n' +
    '        </p>\n' +
    '      </div>\n' +
    '\n' +
    '      <div ng-class="{ \'col-66\': vm.selectedElement, \'col-100\': !vm.selectedElement }">\n' +
    '        <div class="padding comment-item" ng-class="{ \'col-50\': vm.selectedElement, \'col-33\': !vm.selectedElement }"\n' +
    '             ng-repeat="problem in vm.problemsList track by $index" ng-show="problem.Comments != null">\n' +
    '          <b>{{problem.Type}} ({{problem.index}})</b> - {{problem.Comments}}\n' +
    '          <button class="button button-icon icon pull-right button-delete ion-ios-close-empty"\n' +
    '                  ng-click="vm.removeComment(problem)"></button>\n' +
    '          <br/>\n' +
    '          <hr/>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '</ion-view>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/editDiagram.html',
    '<ion-view class="patient-info">\n' +
    '  <ion-header-bar class="bar-texture">\n' +
    '    <h1 class="title title-left">\n' +
    '      <div class="title-wrapper">\n' +
    '        <div class="name-wrapper">\n' +
    '          <div ng-if="vm.patient.LastName || vm.patient.FirstName" data-fittext data-fittext-min="18"\n' +
    '               data-fittext-max="40">\n' +
    '            {{ vm.patient.LastName }}, {{ vm.patient.FirstName}}\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="dob-wrapper">\n' +
    '          <small>{{ vm.patient.DateOfBirth | date: \'MMM d, y\' }}</small>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </h1>\n' +
    '    <div class="buttons right-buttons">\n' +
    '      <network-status-checker></network-status-checker>\n' +
    '    </div>\n' +
    '  </ion-header-bar>\n' +
    '\n' +
    '  <ion-content ng-class="{ \'has-footer\': !vm.hideBottomBar(), \'full-screen\': vm.isFullScreen, \'wpf\' : !vm.patient }"\n' +
    '               scroll="false">\n' +
    '    <div class="findings-page">\n' +
    '      <div class="findings-container" ng-if="vm.finishLoading">\n' +
    '        <mv-diagram-editor class="findings-page"\n' +
    '                           [sex]="vm.patient.Sex"\n' +
    '                           [(diagram-editor)]="vm.diagramEditor"\n' +
    '                           (diagram-editor-change)="vm.onDiagramEditorReady($event)"\n' +
    '                           [(problems)]="vm.problemsList"\n' +
    '                           (problems-change)="vm.onProblemsChanged($event)"\n' +
    '                           [view-only]="vm.isViewOnly"\n' +
    '                           [is-online]="vm.isOnline()"\n' +
    '                           [problem-settings]="vm.techpadConfig.settings.DiagramSettings"\n' +
    '                           [on-error]="vm.onDiagramError"\n' +
    '                           [on-confirming]="vm.showConfirmationMessage"\n' +
    '                           [diagram-image]="vm.diagramImage"\n' +
    '                           [old-diagram-description]="vm.DiagramDescription"\n' +
    '                           [show-save-button]="true"\n' +
    '                           (save-action)="vm.prepareSaveDiagram()"\n' +
    '                           [(svg-infor)]="vm.svg"\n' +
    '                           [old-mode]="!vm.techpadConfig.settings.NewDiagramFeatureEnabled">\n' +
    '        </mv-diagram-editor>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '</ion-view>\n' +
    '<div class="app-version-right-bottom">\n' +
    '  <app-version></app-version>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/home.html',
    '<ion-view title="Home">\n' +
    '  <ion-header-bar class="bar-texture">\n' +
    '    <div class="buttons left-buttons">\n' +
    '      <span>\n' +
    '        <button class="button button-icon button-clear ion-arrow-left-c" ng-click="vm.goToWorklist()" ng-disabled="!vm.isOnline()"></button>\n' +
    '      </span>\n' +
    '    </div>\n' +
    '    <h1 class="title title-left">\n' +
    '      {{ vm.patient.FirstName}} {{ vm.patient.LastName }}\n' +
    '      <small>&nbsp; {{ vm.patient.DateOfBirth | date: \'MMM d, y\' }}</small>\n' +
    '      <small class="patient-notification" ng-show="!!vm.patient.Clip && !!vm.patient.Clip.Flag"\n' +
    '             ng-click="vm.showPatClipPopup()">\n' +
    '        <i class="icon ion-alert-circled"></i>{{vm.patient.Clip.Flag}}\n' +
    '      </small>\n' +
    '    </h1>\n' +
    '    <div class="buttons right-buttons user-name-section">\n' +
    '      <p id="username-label" class="button button-clear user-name">{{getUserName()}}</p>\n' +
    '      <!--<button class="button button-icon ion-gear-a" ng-click="popover.show($event)"></button>-->\n' +
    '      <button id="logout-btn" class="button button-icon ion-log-out" ng-click="logout()" ng-disabled="!vm.isOnline()"></button>\n' +
    '    </div>\n' +
    '  </ion-header-bar>\n' +
    '  <ion-content>\n' +
    '    <h3>Coming soon.</h3>\n' +
    '  </ion-content>\n' +
    '</ion-view>\n' +
    '\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/login.html',
    '<ion-view title="Techpad">\n' +
    '  <ion-content padding="true" class="login-page-container" scroll="false">\n' +
    '    <div class="login-page">\n' +
    '      <div class="text-center">\n' +
    '        <img src="images/magview-logo.png" class="logo w-75 image-responsive padding-top pb-15" />\n' +
    '        <br>\n' +
    '      </div>\n' +
    '      <div class="list">\n' +
    '        <div class="item item-input vertical-input">\n' +
    '          <div class="input-label">Hospital Code</div>\n' +
    '          <div class="item item-input-inset w-100">\n' +
    '            <div class="item-input-wrapper">\n' +
    '              <input type="text" disabled="disabled" ng-disabled="true" ng-model="vm.hospitalNameWithStatus"\n' +
    '                class="server-status input-border hospital-code-input {{vm.status}}" />\n' +
    '            </div>\n' +
    '            <button class="button button-small ripple icon border-less ion-edit" ng-click="vm.changeHospital()">\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div ng-if="vm.checkingHospitalCode">\n' +
    '          <p class="text-center">Checking hospital code...</p>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="item vertical-input">\n' +
    '          <div class="input-label fw-500">Username</div>\n' +
    '          <input type="text" placeholder="Enter Username" ng-model="vm.username" on-enter="vm.login()" class="input-border">\n' +
    '        </div>\n' +
    '        <div class="item vertical-input item-input-password">\n' +
    '          <div class="input-label fw-500">Password</div>\n' +
    '          <input type="password" ng-model="vm.password" placeholder="********" on-enter="vm.login()" class="input-border">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div>\n' +
    '        <div class="item item-input">\n' +
    '          <button class="button button-block button-dark sign-in-button" ng-disabled="vm.isOffline" ng-click="vm.login()">\n' +
    '            <div class="login-button-container ripple">\n' +
    '              Sign-In\n' +
    '            </div>\n' +
    '          </button>\n' +
    '          <button class="button button-small refresh-button ripple" ng-click="vm.reloadApplication()">\n' +
    '            <i class="fa fa-redo-alt"></i>\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <p class="text-center assertive">\n' +
    '          {{vm.message}}\n' +
    '        </p>\n' +
    '        <p class="text-center" ng-show="vm.loading">\n' +
    '          Loading...\n' +
    '        </p>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="app-version-right-bottom">\n' +
    '      <app-version></app-version>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '</ion-view>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/options.html',
    '<ion-view class="patient-info" ng-class="{ \'darkmode-clear\': techpadOptions.DarkMode}">\n' +
    '  <ion-header-bar class="bar-texture">\n' +
    '    <div class="buttons left-buttons">\n' +
    '      <span>\n' +
    '        <button class="button button-icon button-clear ion-navicon ripple" r-color="#FFFFFF"\n' +
    '          ng-click="toggleLeft()"></button>\n' +
    '      </span>\n' +
    '    </div>\n' +
    '    <h1 class="title title-left">Options</h1>\n' +
    '    <div class="buttons right-buttons user-name-section">\n' +
    '      <button id="chat-btn" class="button button-icon ripple chat-bubble-button"\n' +
    '        ng-if="$root.techpadSettings.IsShowChatMenuItem">\n' +
    '        <chat-bubble-component ng-if="$root.techpadSettings.IsShowChatMenuItem"></chat-bubble-component>\n' +
    '      </button>\n' +
    '      <network-status-checker></network-status-checker>\n' +
    '      <p id="username-label" class="button button-clear">{{getUserName()}}</p>\n' +
    '      <button id="logout-btn" class="button button-icon ion-log-out" ng-click="logout()"\n' +
    '        ng-disabled="!isOnline()"></button>\n' +
    '    </div>\n' +
    '\n' +
    '  </ion-header-bar>\n' +
    '  <ion-content>\n' +
    '    <div class="padding">\n' +
    '      <div class="alert alert-secondary" role="alert">\n' +
    '        Please note that these settings will not affect other technologists and will only apply to the current logged in\n' +
    '        user.\n' +
    '      </div>\n' +
    '      <ul class="list options-list">\n' +
    '        <li class="item item-toggle" tappable>\n' +
    '          Enable Dark Mode\n' +
    '          <label class="toggle toggle-positive" tappable>\n' +
    '            <input type="checkbox" ng-model="techpadOptions.DarkMode" tappable ng-change="saveOptions()">\n' +
    '            <div class="track">\n' +
    '              <div class="handle"></div>\n' +
    '            </div>\n' +
    '          </label>\n' +
    '        </li>\n' +
    '        <li class="item item-toggle" tappable>\n' +
    '          Disable permission to change messages on study record on worklist\n' +
    '          <label class="toggle toggle-positive" tappable>\n' +
    '            <input type="checkbox" ng-model="techpadOptions.ListMessageReadOnly" tappable ng-change="saveOptions()">\n' +
    '            <div class="track">\n' +
    '              <div class="handle"></div>\n' +
    '            </div>\n' +
    '          </label>\n' +
    '        </li>\n' +
    '      </ul>\n' +
    '      \n' +
    '      <div class="alert alert-secondary" role="alert">\n' +
    '        Please note that these settings will affect only this device.\n' +
    '      </div>\n' +
    '      <ul class="list options-list">\n' +
    '        <li class="item clear-cache-container" tappable>\n' +
    '          <div style="white-space: normal;">\n' +
    '            Clicking this button will clear the cache and refresh the application on this device. This will require you to re-enter the Hospital Code and log in with your credentials again. Do you wish to proceed?\n' +
    '          </div>\n' +
    '          <label class="clear-cache-toggle toggle toggle-positive" tappable>\n' +
    '            <button class="clear-cache-button button button-block button-assertive ripple m-y-0" r-color="#FFFFFF" tappable ng-click="cleanUpData()">\n' +
    '              Clear Application Cache\n' +
    '            </button>\n' +
    '          </label>\n' +
    '        </li>\n' +
    '      </ul>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '  <div class="app-version-right-bottom app-version-overflow">\n' +
    '    <app-version></app-version>\n' +
    '  </div>\n' +
    '</ion-view>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/otherStudyDetails.html',
    '<ion-view class="patient-info other-study-details" ng-class="{ \'darkmode-clear\': vm.darkMode}">\n' +
    '  <ion-header-bar class="bar-texture">\n' +
    '    <div class="buttons left-buttons">\n' +
    '      <span>\n' +
    '        <button class="button button-icon button-clear ion-arrow-left-c ripple" ng-click="vm.goBack()"></button>\n' +
    '      </span>\n' +
    '    </div>\n' +
    '    <h1 class="title title-left">\n' +
    '      {{ vm.patient.FirstName}} {{ vm.patient.LastName }}\n' +
    '      <small>&nbsp; {{ vm.patient.DOB | date: \'MMM d, y\' }}</small>\n' +
    '    </h1>\n' +
    '    <div class="buttons right-buttons user-name-section">\n' +
    '      <button id="refresh-btn" class="button button-icon button-refresh ion-refresh ripple"\n' +
    '        ng-click="vm.safeRefresh();"></button>\n' +
    '      <network-status-checker></network-status-checker>\n' +
    '      <p id="username-label" class="button button-clear user-name">{{getUserName()}}</p>\n' +
    '      <button id="logout-btn" class="button button-icon ion-log-out ripple" ng-click="logout()"\n' +
    '        ng-disabled="!vm.isOnline()"></button>\n' +
    '    </div>\n' +
    '  </ion-header-bar>\n' +
    '  <div class="item top-bar no-padding m-t-75">\n' +
    '    <div class="patient-short-info">Patient ID: {{!vm.techpadSettings.UseAlternateUserIdentifier ? vm.patient.Ssn :\n' +
    '      vm.patient.ExternalId}}</div>\n' +
    '\n' +
    '    <button class="button button-balanced button-outline btn-save button-ripple"\n' +
    '      ng-disabled="!vm.modelChanged() || vm.loading || !vm.isOnline()" ng-click="vm.save()">\n' +
    '      <div class="ripple">\n' +
    '        Save\n' +
    '      </div>\n' +
    '    </button>\n' +
    '\n' +
    '    <button class="button button-assertive button-outline button-delete-study button-ripple" ng-click="vm.deleteStudy()"\n' +
    '      ng-disabled="!vm.currentStudy || !vm.isOnline()">\n' +
    '      <div class="ripple">\n' +
    '        Delete\n' +
    '      </div>\n' +
    '    </button>\n' +
    '    <button class="button button-balanced button-clear icon ion-loading-c spinner" ng-show="vm.loading">\n' +
    '      <ion-spinner></ion-spinner>\n' +
    '    </button>\n' +
    '    <div class="status padding" ng-show="vm.saved">Changes saved successfully</div>\n' +
    '  </div>\n' +
    '  <div class="card form-page row">\n' +
    '    <div class="col-33 left-panel">\n' +
    '      <label class="item tab-header item-transparent">\n' +
    '        <b>Outside Studies</b>\n' +
    '      </label>\n' +
    '      <ion-list class="studies-list">\n' +
    '        <ion-item ng-click="vm.createStudy()" class="create-outside-study">\n' +
    '          <div class="ripple">\n' +
    '            + Create New\n' +
    '          </div>\n' +
    '        </ion-item>\n' +
    '      </ion-list>\n' +
    '      <ion-scroll ng-if="vm.isIOSDevice" zooming="false" direction="y" class="scrolling-list outside-study-scroll"\n' +
    '        overflow-scroll="false">\n' +
    '        <ng-include src="\'views/templates/outsideStudyScrollTemplate.html\'"></ng-include>\n' +
    '      </ion-scroll>\n' +
    '      <div ng-if="!vm.isIOSDevice" class="scroll-y-auto scroll-outside-studies outside-study-scroll">\n' +
    '        <ng-include src="\'views/templates/outsideStudyScrollTemplate.html\'"></ng-include>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-66 right-panel" ng-show="!!vm.currentStudy">\n' +
    '      <ion-scroll ng-if="vm.isIOSDevice" zooming="false" direction="y" class="scrolling-list outside-study-scroll"\n' +
    '        overflow-scroll="false">\n' +
    '        <ng-include src="\'views/templates/outsideStudyDetailsScrollTemplate.html\'"></ng-include>\n' +
    '      </ion-scroll>\n' +
    '      <div ng-if="!vm.isIOSDevice" class="scroll-y scroll-outside-study-info outside-study-scroll">\n' +
    '        <ng-include src="\'views/templates/outsideStudyDetailsScrollTemplate.html\'"></ng-include>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="app-version-right-bottom app-version-overflow">\n' +
    '    <app-version></app-version>\n' +
    '  </div>\n' +
    '</ion-view>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patient.html',
    '<ion-view class="patient-info exam-page"\n' +
    '          can-swipe-back="false"\n' +
    '          ng-class="{ \'darkmode-clear\': vm.darkMode}">\n' +
    '  <ion-header-bar class="bar-texture">\n' +
    '    <div class="buttons left-buttons">\n' +
    '      <span>\n' +
    '        <button class="button button-icon button-clear ion-arrow-left-c ripple"\n' +
    '                r-color="#FFFFFF"\n' +
    '                ng-click="vm.goBack()"\n' +
    '                ng-disabled="!vm.isOnline()"></button>\n' +
    '      </span>\n' +
    '    </div>\n' +
    '    <h1 class="title title-left emulator-title">\n' +
    '      <div class="title-wrapper emulator">\n' +
    '        <div class="name-wrapper">\n' +
    '          <div ng-if="vm.patient.LastName || vm.patient.FirstName"\n' +
    '               data-fittext\n' +
    '               data-fittext-min="18"\n' +
    '               data-fittext-max="22"\n' +
    '               ng-click="vm.openPatientDetails()"\n' +
    '               class="pointer patient-title-container">\n' +
    '            {{ vm.patient.LastName }}, {{ vm.patient.FirstName}}\n' +
    '          </div>\n' +
    '          <small class="ribbon-age-container">\n' +
    '            DOB: {{ vm.patient.DateOfBirth | date: \'MMM d, y\' }}\n' +
    '          </small>\n' +
    '          <small class="ribbon-age-container">\n' +
    '            Age: {{vm.getPatientsAge()}}\n' +
    '          </small>\n' +
    '        </div>\n' +
    '        <div class="buttons right-buttons user-name-section">\n' +
    '          <button id="refresh-btn"\n' +
    '                  class="button button-icon ion-refresh button-refresh "\n' +
    '                  r-color="#FFFFFF"\n' +
    '                  ng-disabled="!vm.isOnline()"\n' +
    '                  ng-click="vm.refresh()"\n' +
    '                  disable-animation></button>\n' +
    '          <button ng-if="$root.techpadSettings.IsShowChatMenuItem"\n' +
    '                  id="chat-btn"\n' +
    '                  class="button button-icon ripple chat-bubble-button">\n' +
    '            <chat-bubble-component ng-if="$root.techpadSettings.IsShowChatMenuItem"></chat-bubble-component>\n' +
    '          </button>\n' +
    '          <network-status-checker></network-status-checker>\n' +
    '          <p id="username-btn"\n' +
    '             class="button button-clear">{{getUserName()}}</p>\n' +
    '          <button id="logout-btn"\n' +
    '                  class="button button-icon ion-log-out"\n' +
    '                  ng-click="logout(vm.onDestroy)"\n' +
    '                  ng-disabled="!vm.isOnline()"></button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </h1>\n' +
    '\n' +
    '  </ion-header-bar>\n' +
    '  <ion-content ng-class="{ \'has-footer\': !vm.hideBottomBar(), \n' +
    '                           \'full-screen\': vm.isFullScreen }"\n' +
    '               scroll="false">\n' +
    '    <div ng-show="vm.patient"\n' +
    '         class="h-100">\n' +
    '      <div class="item top-bar no-padding">\n' +
    '        <div class="patient-short-info">\n' +
    '          <div class="patient-short-info-text">\n' +
    '            <div class="mw-150px">\n' +
    '              <b>Patient ID:</b>\n' +
    '              {{!vm.techpadConfig.settings.UseAlternateUserIdentifier ? vm.patient.Ssn : vm.patient.ExternalId}} \n' +
    '              <span ng-if="vm.isLinked">(LINKED)</span>\n' +
    '            </div>\n' +
    '            <div class="ref-phy-container"\n' +
    '                 ng-if="vm.patient.RefPhyFirstName || vm.patient.RefPhyLastName">\n' +
    '              <b>Referring Physician:</b>\n' +
    '              {{ vm.patient.RefPhyLastName }}, {{ vm.patient.RefPhyFirstName}}\n' +
    '            </div>\n' +
    '            <div ng-show=\'!!vm.patient.DetailsMessage\'\n' +
    '                 class="patient-message">\n' +
    '              {{vm.patient.DetailsMessage}}\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="patient-short-info-text">\n' +
    '            <div ng-click="vm.techpadConfig.settings.IsShowBarcodeForAccessionNumber && vm.getBarcode(vm.patient.Study.Accession)"\n' +
    '                 class="mw-150px">\n' +
    '              <b>Accession: </b>\n' +
    '              {{vm.patient.Study.Accession}}\n' +
    '            </div>\n' +
    '            <div class="patient-notification"\n' +
    '                 ng-click="vm.showPatClipPopup()">\n' +
    '              {{vm.patient.Clip.Flag ? vm.patient.Clip.Flag : \'Open Clipboard\'}}\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <button ng-hide="vm.isSurveyHistoryTab()"\n' +
    '                class="button button-balanced button-outline btn-save"\n' +
    '                r-color="#FFFFFF"               \n' +
    '                ng-disabled="vm.isViewOnly || !vm.isChanged() || !vm.isOnline() || vm.saving"\n' +
    '                ng-click="vm.saveChanges()">\n' +
    '          <div>\n' +
    '            &nbsp;&nbsp;Save&nbsp;&nbsp;\n' +
    '          </div>\n' +
    '        </button>\n' +
    '        <div ng-show="vm.isViewOnly || vm.isSurveyHistoryTab()"\n' +
    '             class="history_tab_padding"></div>\n' +
    '        <div ng-if="!vm.isSurveyHistoryTab"\n' +
    '             ng-show="vm.saved"\n' +
    '             class="status padding status-message">\n' +
    '          Changes saved successfully\n' +
    '        </div>\n' +
    '        <div ng-if="!vm.isSurveyHistoryTab"\n' +
    '             ng-show="vm.saveFailed"\n' +
    '             class="status padding status-message">\n' +
    '          Changes save failed\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <ul class="tabs list tabs-striped"\n' +
    '          ng-class="{\'tyrer-cuzick-tab-selected\': vm.tab == vm.tabs.TyrerCuzick }">\n' +
    '        <li class="tab-item"\n' +
    '            ng-class="{\n' +
    '              active: vm.tab == vm.tabs.Exam,\n' +
    '              disabled: !vm.isTabAvailable(vm.tabs.Exam),\n' +
    '              \'all-tabs-enabled\': vm.areAllTabsEnabled() && vm.isIOSDevice,\n' +
    '              \'with-images\': vm.techpadConfig.settings.IsShowImagesTab\n' +
    '            }"\n' +
    '            ng-click="vm.changeTab(vm.tabs.Exam)">\n' +
    '          <div class="ripple">\n' +
    '            {{vm.getExamTabAlias(\'Exam\')}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li class="tab-item"\n' +
    '            ng-class="{\n' +
    '              active: vm.tab == vm.tabs.Demographic,\n' +
    '              disabled: !vm.isTabAvailable(vm.tabs.Demographic),\n' +
    '              \'all-tabs-enabled\': vm.areAllTabsEnabled() && vm.isIOSDevice,\n' +
    '              \'with-images\': vm.techpadConfig.settings.IsShowImagesTab\n' +
    '            }"\n' +
    '            ng-click="vm.changeTab(vm.tabs.Demographic)">\n' +
    '          <div class="ripple">\n' +
    '            {{vm.getExamTabAlias(\'Demographic\')}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li class="tab-item"\n' +
    '            ng-class="{\n' +
    '              active: vm.tab == vm.tabs.History,\n' +
    '              disabled: !vm.isTabAvailable(vm.tabs.History),\n' +
    '              \'all-tabs-enabled\': vm.areAllTabsEnabled() && vm.isIOSDevice,\n' +
    '              \'with-images\': vm.techpadConfig.settings.IsShowImagesTab\n' +
    '            }"\n' +
    '            ng-click="vm.changeTab(vm.tabs.History)">\n' +
    '          <div class="ripple">\n' +
    '            {{vm.getExamTabAlias(\'History\')}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li ng-if="vm.techpadConfig.settings.IsShowPriorStudiesTabInExamMode"\n' +
    '            class="tab-item"\n' +
    '            ng-class="{\n' +
    '              active: vm.tab == vm.tabs.PriorStudies,\n' +
    '              disabled: !vm.isTabAvailable(vm.tabs.PriorStudies),\n' +
    '              \'all-tabs-enabled\': vm.areAllTabsEnabled() && vm.isIOSDevice,\n' +
    '              \'with-images\': vm.techpadConfig.settings.IsShowImagesTab\n' +
    '            }"\n' +
    '            ng-click="vm.changeTab(vm.tabs.PriorStudies)">\n' +
    '          <div class="ripple">\n' +
    '            {{vm.getExamTabAlias(\'Prior Studies\')}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li ng-if="vm.techpadConfig.settings.IsShowImagesTab"\n' +
    '            class="tab-item"\n' +
    '            ng-class="{\n' +
    '              active: vm.tab == vm.tabs.Images,\n' +
    '              disabled:!vm.isTabAvailable(vm.tabs.Images),\n' +
    '              \'all-tabs-enabled\': vm.areAllTabsEnabled() && vm.isIOSDevice,\n' +
    '              \'with-images\': vm.techpadConfig.settings.IsShowImagesTab\n' +
    '            }"\n' +
    '            ng-click="vm.changeTab(vm.tabs.Images)">\n' +
    '          <div class="ripple">\n' +
    '            {{vm.getExamTabAlias(\'Images\')}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li class="tab-item"\n' +
    '            ng-class="{\n' +
    '              active: vm.tab == vm.tabs.Diagram,\n' +
    '              disabled:!vm.isTabAvailable(vm.tabs.Diagram),\n' +
    '              \'all-tabs-enabled\': vm.areAllTabsEnabled() && vm.isIOSDevice,\n' +
    '              \'with-images\': vm.techpadConfig.settings.IsShowImagesTab\n' +
    '            }"\n' +
    '            ng-click="vm.changeTab(vm.tabs.Diagram)">\n' +
    '          <div class="ripple">\n' +
    '            {{vm.getExamTabAlias(\'Diagram\')}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li id="comments-li"\n' +
    '            class="tab-item"\n' +
    '            ng-class="{\n' +
    '              active: vm.tab == vm.tabs.Comments,\n' +
    '              \'all-tabs-enabled\': vm.areAllTabsEnabled() && vm.isIOSDevice,\n' +
    '              \'with-images\': vm.techpadConfig.settings.IsShowImagesTab\n' +
    '            }"\n' +
    '            ng-click="vm.changeTab(vm.tabs.Comments)">\n' +
    '          <div class="ripple">\n' +
    '            {{vm.getExamTabAlias(\'Comments\')}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li id="risk-li"\n' +
    '            class="tab-item"\n' +
    '            ng-class="{\n' +
    '              active: vm.tab == vm.tabs.RiskAssessments,\n' +
    '              \'all-tabs-enabled\': vm.areAllTabsEnabled() && vm.isIOSDevice,\n' +
    '              \'with-images\': vm.techpadConfig.settings.IsShowImagesTab,\n' +
    '              \'disable-pointer-events disabled-tab\': vm.patient.IsRiskOptOut\n' +
    '            }"\n' +
    '            ng-click="vm.changeTab(vm.tabs.RiskAssessments)">\n' +
    '          <div class="ripple"\n' +
    '               ng-class="{\'red-colored bold\': vm.checkIfHighlightForNccnGcQualified()}">\n' +
    '            {{vm.getExamTabAlias(vm.examConstants.EXAM_RISK_TAB)}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li id="follow-up-li"\n' +
    '            class="tab-item"\n' +
    '            ng-class="{\n' +
    '              active: vm.tab == vm.tabs.FollowUps,\n' +
    '              disabled:!vm.isTabAvailable(vm.tabs.FollowUps),\n' +
    '              \'all-tabs-enabled\': vm.areAllTabsEnabled() && vm.isIOSDevice,\n' +
    '              \'with-images\': vm.techpadConfig.settings.IsShowImagesTab\n' +
    '            }"\n' +
    '            ng-click="vm.changeTab(vm.tabs.FollowUps)">\n' +
    '          <div class="ripple">\n' +
    '            {{vm.getExamTabAlias(\'Follow-up\')}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li id="documents-li"\n' +
    '            class="tab-item"\n' +
    '            ng-class="{\n' +
    '              active: vm.tab == vm.tabs.Documents,\n' +
    '              disabled:!vm.isTabAvailable(vm.tabs.Documents),\n' +
    '              \'all-tabs-enabled\': vm.areAllTabsEnabled() && vm.isIOSDevice,\n' +
    '              \'with-images\': vm.techpadConfig.settings.IsShowImagesTab\n' +
    '            }"\n' +
    '            ng-click="vm.changeTab(vm.tabs.Documents)">\n' +
    '          <div class="ripple">\n' +
    '            {{vm.getExamTabAlias(\'Documents\')}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li class="tab-item"\n' +
    '            ng-if="vm.techpadConfig.settings.FamilyTreeEnabled"\n' +
    '            ng-class="{\n' +
    '              active: vm.tab == vm.tabs.TyrerCuzick,\n' +
    '              disabled:!vm.isTabAvailable(vm.tabs.TyrerCuzick),\n' +
    '              \'all-tabs-enabled\': vm.areAllTabsEnabled() && vm.isIOSDevice,\n' +
    '              \'with-images\': vm.techpadConfig.settings.IsShowImagesTab\n' +
    '            }"\n' +
    '            ng-click="vm.changeTab(vm.tabs.TyrerCuzick)">\n' +
    '          <div class="ripple">\n' +
    '            {{vm.getExamTabAlias(\'Family Tree\')}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '      </ul>\n' +
    '      <div ng-if="$root.techpadSettings.IsShowPriorStudiesTabInExamMode"\n' +
    '          ng-show="vm.tab == vm.tabs.PriorStudies"\n' +
    '          class="card card-transparent comments-page form-page">\n' +
    '          <ng-include src="\'views/patientExam/priorStudies.html\'"></ng-include>\n' +
    '      </div>\n' +
    '      <div ng-show="vm.tab == vm.tabs.Exam"\n' +
    '           class="card form-page exam-tab-form-page"\n' +
    '           ng-include="\'views/patientExam/examTab.html\'">\n' +
    '      </div>\n' +
    '      <div ng-show="vm.tab == vm.tabs.Demographic"\n' +
    '           class="card form-page demographic-tab-form-page">\n' +
    '        <ng-include src="\'views/patientExam/demographicTab.html\'"></ng-include>\n' +
    '      </div>\n' +
    '      <div ng-show="vm.tab == vm.tabs.History"\n' +
    '           class="card card-transparent findings-page">\n' +
    '        <ng-include src="\'views/patientExam/historyTab.html\'"></ng-include>\n' +
    '      </div>\n' +
    '      <div ng-if="vm.tab == vm.tabs.Images"\n' +
    '           class="card card-transparent images-page">\n' +
    '        <ng-include src="\'views/patientExam/imagesTab.html\'"></ng-include>\n' +
    '      </div>\n' +
    '      <div ng-if="vm.tab == vm.tabs.RiskAssessments"\n' +
    '           class="card form-page">\n' +
    '        <ng-include src="\'views/patientExam/riskAssessments.html\'"></ng-include>\n' +
    '      </div>\n' +
    '      <div ng-if="!vm.hideDiagram"\n' +
    '           ng-hide="vm.tab != vm.tabs.Diagram"           \n' +
    '           class="diagram-page">\n' +
    '        <div class="findings-page">\n' +
    '          <div class="findings-container">\n' +
    '            <mv-diagram-editor class="findings-page"\n' +
    '                               [sex]="vm.patient.Sex"\n' +
    '                               [(diagram-editor)]="vm.diagramEditor"\n' +
    '                               (diagram-editor-change)="vm.onDiagramEditorReady($event)"\n' +
    '                               [(problems)]="vm.problemsList"\n' +
    '                               (problems-change)="vm.onProblemsChanged($event)"\n' +
    '                               [view-only]="vm.isViewOnly || vm.shouldDisableControls()"\n' +
    '                               [problem-settings]="vm.techpadConfig.settings.DiagramSettings"\n' +
    '                               [on-error]="vm.onDiagramError"\n' +
    '                               [show-message]="vm.showMessage"\n' +
    '                               [on-confirming]="vm.showConfirmationMessage"\n' +
    '                               [diagram-image]="vm.diagramImage"\n' +
    '                               [old-diagram-description]="vm.DiagramDescription"\n' +
    '                               [(svg-infor)]="vm.svg"\n' +
    '                               [old-mode]="!vm.techpadConfig.settings.NewDiagramFeatureEnabled"\n' +
    '                               [show-old-mode-warning]="vm.techpadConfig.settings.IsShowDiagramOldModeWarning"\n' +
    '                               [old-mode-warning]="vm.techpadConfig.settings.DiagramOldModeWarning">\n' +
    '            </mv-diagram-editor>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div ng-if="vm.tab == vm.tabs.Comments"\n' +
    '           class="card card-transparent comments-page form-page">\n' +
    '        <ng-include src="\'views/patientExam/commentsTab.html\'"></ng-include>\n' +
    '      </div>\n' +
    '      <div ng-if="vm.tab == vm.tabs.FollowUps"\n' +
    '           class="card card-transparent comments-page follow-ups-page documents-page form-page">\n' +
    '        <ng-include src="\'views/patientExam/followUpTab.html\'"></ng-include>\n' +
    '      </div>\n' +
    '      <div ng-show="vm.tab == vm.tabs.Documents"\n' +
    '           class="card card-transparent comments-page documents-page form-page">\n' +
    '        <ng-include src="\'views/patientExam/documentsTab.html\'"></ng-include>\n' +
    '      </div>\n' +
    '      <div ng-if="vm.tab == vm.tabs.TyrerCuzick"\n' +
    '           class="card card-transparent comments-page form-page survey-card tyrer-cuzick-card">\n' +
    '        <ng-include src="\'views/patientExam/tyrerCuzickTab.html\'"></ng-include>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '  <div ng-hide="vm.hideBottomBar()"\n' +
    '       class="bar bar-footer bar-light row exam-page-bar-footer">\n' +
    '    <div class="col-67">\n' +
    '      <div class="pull-left button-group">\n' +
    '        <button ng-hide="vm.shouldHideStartExam()"\n' +
    '                class="button button-clear pull-left ripple"\n' +
    '                disable-animation\n' +
    '                ng-click="vm.startExam();"                \n' +
    '                ng-disabled="vm.shouldDisableStartExam()">\n' +
    '          <span>\n' +
    '            {{ vm.isExamStarted() ? \'Resume\' : \'Start\' }} Exam\n' +
    '          </span>\n' +
    '          <i class="icon circle-icon icon-big ion-play"></i>\n' +
    '        </button>\n' +
    '        <button ng-hide="vm.shouldHidePauseExam()"\n' +
    '                class="button button-clear pull-left ripple"\n' +
    '                disable-animation\n' +
    '                ng-click="vm.pauseExam();"                \n' +
    '                ng-disabled="vm.shouldDisablePauseExam()">\n' +
    '          <span>Pause Exam</span>\n' +
    '          <i class="icon circle-icon icon-big ion-pause"></i>\n' +
    '        </button>\n' +
    '        <button ng-hide="vm.shouldHideEndExam()"\n' +
    '                class="button button-clear pull-left ripple"\n' +
    '                ng-click="vm.endExam()"                \n' +
    '                ng-disabled="vm.shouldDisableEndExam()">\n' +
    '          <span>End Exam</span>\n' +
    '          <i class="icon circle-icon icon-big ion-stop"></i>\n' +
    '        </button>\n' +
    '      </div>\n' +
    '      <div ng-show="vm.shouldHideStartExam() && vm.shouldHideEndExam()"\n' +
    '           class="pull-left">\n' +
    '        <h2>\n' +
    '          <span ng-show="!!vm.patientCopy.ExamBeginTime">\n' +
    '            Begin: {{ vm.patientCopy.ExamBeginTime }}\n' +
    '          </span>\n' +
    '          <span ng-show="!!vm.patientCopy.ExamEndTime"\n' +
    '                class="m-l-30">\n' +
    '            End: {{ vm.patientCopy.ExamEndTime }}\n' +
    '          </span>\n' +
    '        </h2>\n' +
    '      </div>\n' +
    '      <div ng-if="vm.patientCopy.Status && (!vm.shouldHideStartExam() || !vm.shouldHideEndExam())"\n' +
    '           class="text-center">\n' +
    '        <h2 ng-if="vm.patientCopy.Status != vm.worklistStatuses.ExamInProgress">\n' +
    '          {{vm.getDuration()}}\n' +
    '        </h2>\n' +
    '        <h2 ng-if="vm.patientCopy.Status == vm.worklistStatuses.ExamInProgress">\n' +
    '          <timer max-time-unit="\'hour\'"\n' +
    '                 start-time="vm.getDuration(true)">\n' +
    '            {{hhours}}:{{mminutes}}:{{sseconds}}\n' +
    '          </timer>\n' +
    '        </h2>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-33 text-center">\n' +
    '      <button class="button button-clear ripple"\n' +
    '              ng-click="vm.finishExam()"\n' +
    '              ng-disabled="vm.shouldDisableCompleteExam()">\n' +
    '        <span>Mark As Completed</span>\n' +
    '        <i class="icon circle-icon icon-big ion-eye"></i>\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="app-version-right-bottom app-version-overflow">\n' +
    '    <app-version></app-version>\n' +
    '  </div>\n' +
    '</ion-view>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientDetailsInitial.html',
    '<ion-view class="patient-info" ng-class="{ \'darkmode-clear\': vm.darkMode}">\n' +
    '  <ion-header-bar class="bar-texture">\n' +
    '    <div class="buttons left-buttons">\n' +
    '      <span>\n' +
    '        <button class="button button-icon button-clear ion-arrow-left-c ripple" ng-click="vm.goBack()"></button>\n' +
    '      </span>\n' +
    '    </div>\n' +
    '    <h1 class="title title-left">Patient Details</h1>\n' +
    '    <div class="buttons user-name-section">\n' +
    '      <network-status-checker></network-status-checker>\n' +
    '      <p id="username-label" class="button button-clear">{{getUserName()}}</p>\n' +
    '      <button id="logout-btn" class="button button-icon ion-log-out ripple" ng-click="logout()"\n' +
    '        ng-disabled="!vm.isOnline()"></button>\n' +
    '    </div>\n' +
    '  </ion-header-bar>\n' +
    '  <div class="scroll mt-75 main-content">\n' +
    '    <div class="item top-bar no-padding patient-info-item">\n' +
    '      <div class="patient-short-info">\n' +
    '        <p>\n' +
    '          <b>Patient ID:</b> {{!vm.techpadSettings.UseAlternateUserIdentifier ? vm.patient.Ssn : vm.patient.ExternalId}}\n' +
    '        </p>\n' +
    '\n' +
    '      </div>\n' +
    '      <div class="patient-notification" ng-if="!!vm.ClipboardFlagTitle" ng-click="vm.showPatClipPopup()">\n' +
    '        <i class="icon ion-alert-circled"></i>{{vm.ClipboardFlagTitle}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <ul class="tabs list tabs-striped">\n' +
    '      <li class="tab-item ripple" ng-class="{active: vm.tab == vm.tabs.Patient}"\n' +
    '        ng-click="vm.changeTab(vm.tabs.Patient)">\n' +
    '        Patient\n' +
    '      </li>\n' +
    '      <li class="tab-item ripple" ng-class="{active: vm.tab == vm.tabs.Studies}"\n' +
    '        ng-click="vm.changeTab(vm.tabs.Studies)">\n' +
    '        Studies\n' +
    '      </li>\n' +
    '    </ul>\n' +
    '    <div class="card form-page" ng-show="vm.tab == vm.tabs.Patient">\n' +
    '      <ng-include src="\'views/patientDetails/patientDetails.html\'"></ng-include>\n' +
    '    </div>\n' +
    '    <div class="card form-page" ng-show="vm.tab == vm.tabs.Studies">\n' +
    '      <ng-include src="\'views/patientDetails/studies.html\'"></ng-include>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="app-version-right-bottom">\n' +
    '    <app-version></app-version>\n' +
    '  </div>\n' +
    '</ion-view>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientsList.html',
    '<ion-view ng-class="{ \'darkmode-clear\': vm.darkMode}">\n' +
    '  <ion-header-bar class="bar-texture">\n' +
    '    <div class="buttons left-buttons">\n' +
    '      <span>\n' +
    '        <button class="button button-icon button-clear ion-navicon ripple" ng-click="toggleLeft()"></button>\n' +
    '      </span>\n' +
    '    </div>\n' +
    '    <h1 class="title title-left">Patients</h1>\n' +
    '    <div class="buttons right-buttons user-name-section">\n' +
    '      <button class="button button-icon ripple chat-bubble-button" ng-if="$root.techpadSettings.IsShowChatMenuItem">\n' +
    '        <chat-bubble-component ng-if="$root.techpadSettings.IsShowChatMenuItem"></chat-bubble-component>\n' +
    '      </button>\n' +
    '      <network-status-checker></network-status-checker>\n' +
    '      <p id="username-label" class="button button-clear">{{getUserName()}}</p>\n' +
    '      <button id="logout-btn" class="button button-icon ion-log-out" ng-click="logout()"\n' +
    '        ng-disabled="!isOnline()"></button>\n' +
    '    </div>\n' +
    '  </ion-header-bar>\n' +
    '  <div class="bar bar-subheader patients-search">\n' +
    '    <div class="row">\n' +
    '      <div class="col col-22" ng-show="!vm.isAdvancedSearch" ng-if="techpadSettings.IsPatientsCreationAbilityEnabled">\n' +
    '        <a class="item item button button-block button-calm inline-button ripple" r-color="#FFFFFF"\n' +
    '          ui-sref="root.patient_details" ng-disabled="!isOnline()">\n' +
    '          Create Patient\n' +
    '        </a>\n' +
    '      </div>\n' +
    '      <div class="col col-min">\n' +
    '        <button class="button button-balanced inline-button icon-only ripple" r-color="#FFFFFF"\n' +
    '          ng-click="vm.toggleAdvancedSearch()" ng-disabled="!isOnline()"\n' +
    '          ng-class="{\'ion-plus\': !vm.isAdvancedSearch, \'ion-minus\': vm.isAdvancedSearch}"></button>\n' +
    '      </div>\n' +
    '      <div class="col" ng-show="!vm.isAdvancedSearch">\n' +
    '        <label class="item item-input ripple" r-color="#FFFFFF">\n' +
    '          <input type="text" placeholder="Search" ng-model="vm.filter.simpleSearch"\n' +
    '            ng-keypress="vm.searchOnKeyPress($event)">\n' +
    '        </label>\n' +
    '      </div>\n' +
    '      <div class="col" ng-show="vm.isAdvancedSearch">\n' +
    '        <label class="item item-input">\n' +
    '          <input type="text" placeholder="MRN" ng-model="vm.filter.ssn" ng-keypress="vm.searchOnKeyPress($event)">\n' +
    '        </label>\n' +
    '      </div>\n' +
    '      <div class="col" ng-show="vm.isAdvancedSearch">\n' +
    '        <label class="item item-input">\n' +
    '          <input type="text" placeholder="First Name" ng-model="vm.filter.firstName"\n' +
    '            ng-keypress="vm.searchOnKeyPress($event)">\n' +
    '        </label>\n' +
    '      </div>\n' +
    '      <div class="col" ng-show="vm.isAdvancedSearch">\n' +
    '        <label class="item item-input">\n' +
    '          <input type="text" placeholder="Last Name" ng-model="vm.filter.lastName"\n' +
    '            ng-keypress="vm.searchOnKeyPress($event)">\n' +
    '        </label>\n' +
    '      </div>\n' +
    '      <div class="col relative" ng-show="vm.isAdvancedSearch">\n' +
    '        <label class="item item-input col-75">\n' +
    '          <input type="text" placeholder="DOB" class="dob-filter-input"\n' +
    '            ng-change="vm.filter.dob = vm.formatDOBValue(vm.filter.dob)" ng-model="vm.filter.dob">\n' +
    '          </input>\n' +
    '        </label>\n' +
    '        <button class="button-icon icon button-change-date ion-calendar filter-datepicker"\n' +
    '          ng-click="vm.changeDate()"></button>\n' +
    '      </div>\n' +
    '      <div class="col col-search">\n' +
    '        <button class="button button-block button-balanced inline-button button-search-patients" r-color="#FFFFFF"\n' +
    '          ng-disabled="!isOnline()" ng-click="vm.search()">\n' +
    '          <div class="ripple">\n' +
    '            Search\n' +
    '          </div>\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <ion-scroll ng-if="vm.isIOSDevice" zooming="false" direction="y" class="scroll-y has-subheader-ion-scroll"\n' +
    '    overflow-scroll="false">\n' +
    '    <ng-include src="\'views/templates/patientListScrollTemplate.html\'"></ng-include>\n' +
    '  </ion-scroll>\n' +
    '  <div ng-if="!vm.isIOSDevice" class="has-subheader scroll-y patient-list-scroll">\n' +
    '    <ng-include src="\'views/templates/patientListScrollTemplate.html\'"></ng-include>\n' +
    '  </div>\n' +
    '</ion-view>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/root.html',
    '<ion-side-menus ng-if="!hideContent">\n' +
    '\n' +
    '  <ion-side-menu-content drag-content="isDragMenuEnabled()">\n' +
    '    <ion-nav-bar class="bar-texture main-bar" align-title="left" ng-hide="true">\n' +
    '    </ion-nav-bar>\n' +
    '    <ion-nav-buttons side="left">\n' +
    '      <button class="button button-icon button-clear ion-navicon" ng-show="authService.loggedIn && !isNotHome()" ng-click="toggleLeft()">\n' +
    '      </button>\n' +
    '    </ion-nav-buttons>\n' +
    '    <ion-nav-buttons side="right">\n' +
    '\n' +
    '      <button class="button button-clear">{{getUserName()}}</button>\n' +
    '      <button class="button button-icon ion-log-out" ng-click="logout()" ng-disabled="!vm.isOnline()"></button>\n' +
    '    </ion-nav-buttons>\n' +
    '    <ion-nav-view name="menuContent"></ion-nav-view>\n' +
    '  </ion-side-menu-content>\n' +
    '\n' +
    '  <ion-side-menu side="left">\n' +
    '    <div class="item item-image bar-texture">\n' +
    '      <img src="images/magview-logo2.png" class="logo image-responsive p-x-30" />\n' +
    '    </div>\n' +
    '    <ion-content class="main-menu" scroll="true">\n' +
    '      <ul class="list ">\n' +
    '        <a ui-sref="root.scheduled" class="item" menu-close ui-sref-active="active" ng-show="techpadSettings.IsShowScheduledMenuItem">\n' +
    '          <ripple>\n' +
    '            <i class="icon circle-icon ion-ios-calendar-outline" id="scheduled-menu"></i>\n' +
    '            <span>SCHEDULED</span>\n' +
    '          </ripple>\n' +
    '        </a>\n' +
    '\n' +
    '        <a ui-sref="root.worklist" id="worklist-menu" class="item" menu-close ui-sref-active="active">\n' +
    '          <ripple>\n' +
    '            <i class="icon circle-icon ion-navicon"></i>\n' +
    '            <span>{{!techpadSettings.IsDashboardMode ? \'WORKLIST\' : \'DASHBOARD\'}}</span>\n' +
    '          </ripple>\n' +
    '        </a>\n' +
    '\n' +
    '        <a ui-sref="root.worklist_mypatients" id="my-patients-menu" class="item" menu-close ui-sref-active="active">\n' +
    '          <ripple>\n' +
    '            <i class="icon circle-icon ion-checkmark-round"></i>\n' +
    '            <span>MY PATIENTS</span>\n' +
    '          </ripple>\n' +
    '        </a>\n' +
    '\n' +
    '        <a ui-sref="root.demo" id="demo-menu" class="item" menu-close ui-sref-active="active" ng-show="techpadSettings.IsShowDemoMenuItem">\n' +
    '          <ripple>\n' +
    '            <i class="icon circle-icon ion-navicon"></i>\n' +
    '            <span>DEMO</span>\n' +
    '          </ripple>\n' +
    '        </a>\n' +
    '\n' +
    '        <a ui-sref="root.options" id="options-menu" class="item" menu-close ui-sref-active="active">\n' +
    '          <ripple>\n' +
    '            <i class="icon circle-icon ion-navicon"></i>\n' +
    '            <span>OPTIONS</span>\n' +
    '          </ripple>\n' +
    '        </a>\n' +
    '\n' +
    '        <a ui-sref="root.patients" id="patients-menu" class="item" menu-close ui-sref-active="active" ng-show="techpadSettings.IsShowPatientsMenuItem">\n' +
    '          <ripple>\n' +
    '            <i class="icon circle-icon ion-navicon"></i>\n' +
    '            <span>PATIENTS</span>\n' +
    '          </ripple>\n' +
    '        </a>\n' +
    '\n' +
    '        <a ui-sref="root.chat-master" id="chat-menu" class="item" menu-close ui-sref-active="active" ng-show="techpadSettings.IsShowChatMenuItem">\n' +
    '          <ripple>\n' +
    '            <i class="icon circle-icon wide-icon far fa-comments"></i>\n' +
    '            <span>CHAT</span>\n' +
    '          </ripple>\n' +
    '        </a>\n' +
    '\n' +
    '        <a ui-sref="root.speedtest" id="speed-test-menu" class="item" menu-close ui-sref-active="active" ng-show="techpadSettings.ShowSpeedTestTab">\n' +
    '          <ripple>\n' +
    '            <i class="icon circle-icon ion-ios-world"></i>\n' +
    '            <span>SPEED TEST</span>\n' +
    '          </ripple>\n' +
    '        </a>\n' +
    '      </ul>\n' +
    '      <p class="text-center">\n' +
    '        <app-version></app-version>\n' +
    '        <br>\n' +
    '      </p>\n' +
    '    </ion-content>\n' +
    '  </ion-side-menu>\n' +
    '\n' +
    '</ion-side-menus>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/speedtest.html',
    '<ion-view>\n' +
    '    <ion-header-bar class="bar-texture">\n' +
    '        <div class="buttons left-buttons">\n' +
    '            <span>\n' +
    '                <button class="button button-icon button-clear ion-navicon ripple" ng-click="toggleLeft()"></button>\n' +
    '            </span>\n' +
    '        </div>\n' +
    '        <h1 class="title title-left">SpeedTest</h1>\n' +
    '        <div class="buttons right-buttons user-name-section">\n' +
    '            <network-status-checker></network-status-checker>\n' +
    '            <p id="username-label" class="button button-clear">{{getUserName()}}</p>\n' +
    '            <button id="logout-btn" class="button button-icon ion-log-out ripple" ng-click="logout()" ng-disabled="!vm.isOnline()"></button>\n' +
    '        </div>\n' +
    '    </ion-header-bar>\n' +
    '    <ion-content>\n' +
    '        <div class="row">\n' +
    '            <div class="alert-info">&#9432 All requests are showing average value for 10 requests</div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <button class="item button button-block button-calm inline-button ripple ripple-cont col" ng-click="getNetworkStats()">\n' +
    '                <span ng-if="latency==0">Run Network Connection Test</span>\n' +
    '                <span ng-if="latency!=0">Re-Run Network Connection Test</span>\n' +
    '            </button>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="card list col-33 p-5">\n' +
    '                <div class="item item-divider">\n' +
    '                    Latency\n' +
    '                </div>\n' +
    '                <div class="item item-text-wrap">\n' +
    '                    <span class="network-test-result">{{latency}} ms</span>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="card list col-33 p-5">\n' +
    '                <div class="item item-divider">\n' +
    '                    Download Bandwidth\n' +
    '                </div>\n' +
    '                <div class="item item-text-wrap">\n' +
    '                    <span class="network-test-result">{{downloadBandwidth}}/sec</span>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="card list col-33 p-5">\n' +
    '                <div class="item item-divider">\n' +
    '                    Upload Bandwidth\n' +
    '                </div>\n' +
    '                <div class="item item-text-wrap">\n' +
    '                    <span class="network-test-result">{{uploadBandwidth}}/sec</span>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="alert-info">&#9432 All Benchmark are showing average value for 10 requests</div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <button class="item button button-block button-calm inline-button ripple ripple-cont col" ng-click="runBenchmarkTesting()">\n' +
    '                <span ng-if="!benchmarkTestRan">Run Benchmark Test</span>\n' +
    '                <span ng-if="benchmarkTestRan">Re-Run Benchmark Test</span>\n' +
    '            </button>\n' +
    '        </div>\n' +
    '        <div class="row" ng-if="benchmarkTestRan">\n' +
    '            <div class="col table">\n' +
    '                <div class="item item-button-center">\n' +
    '                    <h2>Total Time</h2>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-33 table">\n' +
    '                <div class="item item-button-center">\n' +
    '                    <h2>Method Name</h2>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col table">\n' +
    '                <div class="item item-button-center">\n' +
    '                    <h2>Max Execution Time</h2>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col table">\n' +
    '                <div class="item item-button-center">\n' +
    '                    <h2>Min Execution Time</h2>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col table">\n' +
    '                <div class="item item-button-center">\n' +
    '                    <h2>Average</h2>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row" ng-repeat="item in metricsList">\n' +
    '            <div class="col table">\n' +
    '                <div class="item item-button-center">\n' +
    '                    <h3>{{item.SpentTime}}</h3>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-33 table">\n' +
    '                <div class="item item-button-center">\n' +
    '                    <h3>{{item.Name}}</h3>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col table">\n' +
    '                <div class="item item-button-center">\n' +
    '                    <h3>{{item.Max}}</h3>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col table">\n' +
    '                <div class="item item-button-center">\n' +
    '                    <h3>{{item.Min }}</h3>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col table">\n' +
    '                <div class="item item-button-center">\n' +
    '                    <h3>{{item.Median}}</h3>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row" ng-if="benchmarkTestRan">\n' +
    '            <div class="col">\n' +
    '                <div class="col table">\n' +
    '                    <div class="item item-button-center">\n' +
    '                        <h2>Server Information</h2>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>Property</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>Value</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h3>Base Url</h3>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h3>{{systemInfo.BaseUrl}}</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>Host Name</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>{{systemInfo.HostName}}</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>IP</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>{{systemInfo.Ip}}</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>OS Architecture</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>{{systemInfo.OsArchitecture}}</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>Processor</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>{{systemInfo.ProcessorName}}</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>RAM usage by Portal</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>{{systemInfo.PortalRamUsage}} Gb</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>Total RAM usage</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>{{systemInfo.TotalRamUsage}} Gb</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>Operating System</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>{{systemInfo.SystemCaption}}</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>Free Drive Space</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>{{systemInfo.FreeDriveSpace}} Gb</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col" ng-if="benchmarkTestRan">\n' +
    '                <div class="col table">\n' +
    '                    <div class="item item-button-center">\n' +
    '                        <h2>Client Information</h2>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>Property</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>Value</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>Client Device OS</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>{{clientOs}}</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>Browser</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="col-50 table table-cell">\n' +
    '                        <div class="item item-button-center">\n' +
    '                            <h2>{{clientBrowser}}</h2>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </ion-content>\n' +
    '</ion-view>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/studyDetails.html',
    '<ion-view class="patient-info" ng-class="{ \'darkmode-clear\': vm.darkMode}">\n' +
    '  <ion-header-bar class="bar-texture">\n' +
    '    <div class="buttons left-buttons">\n' +
    '      <span>\n' +
    '        <button class="button button-icon button-clear ion-arrow-left-c ripple" ng-click="vm.goBack()"></button>\n' +
    '      </span>\n' +
    '      <span>\n' +
    '      </span>\n' +
    '    </div>\n' +
    '    <h1 class="title title-left">Study Details</h1>\n' +
    '    <div class="buttons user-name-section">\n' +
    '      <network-status-checker></network-status-checker>\n' +
    '      <p class="button button-clear">{{getUserName()}}</p>\n' +
    '      <button class="button button-icon ion-log-out ripple" ng-click="logout()" ng-disabled="!vm.isOnline()"></button>\n' +
    '    </div>\n' +
    '  </ion-header-bar>\n' +
    '  <div class="relative has-header study-details-container">\n' +
    '    <div class="form-buttons study-details">\n' +
    '      <button class="button button-outline button-balanced button-ripple"\n' +
    '        ng-disabled="!vm.isOnline || !vm.checkIfStudyChanged()" ng-click="vm.save()">\n' +
    '        <div class="ripple">\n' +
    '          Save\n' +
    '        </div>\n' +
    '      </button>\n' +
    '    </div>\n' +
    '    <div class="card form-page study-details">\n' +
    '      <form>\n' +
    '        <div class="row">\n' +
    '          <div class="col-40">\n' +
    '            <label class="item tab-header item-transparent">\n' +
    '              <b class="ripple-cont">Study Date</b>\n' +
    '              <hr />\n' +
    '            </label>\n' +
    '            <div class="item item-text-wrap item-transparent">\n' +
    '              {{vm.study.StudyDate | date:\'MM/dd/yyyy\'}}\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-26">\n' +
    '\n' +
    '          </div>\n' +
    '          <div class="col-33">\n' +
    '            <label class="item tab-header item-transparent">\n' +
    '              <b>Exam</b>\n' +
    '              <hr />\n' +
    '            </label>\n' +
    '            <div class="item item-text-wrap item-transparent left-align">\n' +
    '              <button class="button button-outline button-royal button-ripple" ng-show="vm.study.SDate"\n' +
    '                ng-disabled="!vm.isOnline()" ng-click="vm.addToWorklist()">\n' +
    '                <div class="ripple">\n' +
    '                  Add to Worklist\n' +
    '                </div>\n' +
    '              </button>\n' +
    '              <h1 class="pin-number" ng-if="vm.study.Pin">PIN: {{vm.study.Pin}}</h1>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row second-row second-dropdown-container">\n' +
    '          <div class="col-40">\n' +
    '            <div class="item tab-header details-list-header item-transparent item-dropdown-header"\n' +
    '              ng-if="techpadSettings.IsStudyModificationAbilityEnabled">\n' +
    '              <div class="dropdown-display">\n' +
    '                <span class="placeholder text-bold">\n' +
    '                  Location\n' +
    '                </span>\n' +
    '                <div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '                <dropdown-menu placeholder="" bold-placeholder="true" always-placeholder="true" list="vm.locations"\n' +
    '                  select-mode="true" property="Value" key="Key" icon="ion-ios-arrow-right" dropdown-height="205"\n' +
    '                  on-selection-change="vm.changeStudyDetailsLocation($type)"></dropdown-menu>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div ng-if="!techpadSettings.IsStudyModificationAbilityEnabled">\n' +
    '              <label class="item tab-header item-transparent">\n' +
    '                <b class="ripple-cont">Location</b>\n' +
    '                <hr class="full-width" />\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="item item-text-wrap item-transparent">\n' +
    '              {{vm.getLabel(vm.study.Location, vm.locations)}}\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-26">\n' +
    '\n' +
    '          </div>\n' +
    '          <div class="col-33" ng-if="!techpadSettings.HideSkipAndStartButtons">\n' +
    '            <label class="item tab-header item-transparent">\n' +
    '              <b>Tablet Survey</b>\n' +
    '              <hr />\n' +
    '            </label>\n' +
    '            <div class="item item-text-wrap item-transparent left-align">\n' +
    '              <button class="button button-outline button-positive button-ripple" ng-show="vm.study.SDate"\n' +
    '                ng-disabled="!vm.isOnline()" ng-click="vm.skipSurveyAndStartExam()">\n' +
    '                <div class="ripple">\n' +
    '                  Skip Survey\n' +
    '                </div>\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row second-row second-dropdown-container">\n' +
    '          <div class="col-40">\n' +
    '            <div class="item tab-header details-list-header item-transparent item-dropdown-header"\n' +
    '              ng-if="techpadSettings.IsStudyModificationAbilityEnabled">\n' +
    '              <div class="dropdown-display">\n' +
    '                <span class="placeholder text-bold">\n' +
    '                  Procedures\n' +
    '                </span>\n' +
    '                <div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '                <dropdown-menu placeholder="" bold-placeholder="true" always-placeholder="true" list="vm.procedures"\n' +
    '                  select-mode="true" property="Value" key="Key" icon="ion-ios-plus-empty" dropdown-height="205"\n' +
    '                  on-selection-change="vm.addProcedure($type)"></dropdown-menu>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div ng-if="!techpadSettings.IsStudyModificationAbilityEnabled">\n' +
    '              <label class="item tab-header item-transparent">\n' +
    '                <b class="ripple-cont">Procedures</b>\n' +
    '                <hr class="full-width" />\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="item item-transparent">\n' +
    '              <div class="row">\n' +
    '                <div class="col-40"><b>Name</b></div>\n' +
    '                <div class="col-45"><b>Side</b></div>\n' +
    '              </div>\n' +
    '              <ion-scroll ng-if="vm.isIOSDevice" zooming="false" direction="y" class="scroll-y procedures-list"\n' +
    '                overflow-scroll="false">\n' +
    '                <ng-include src="\'views/templates/studyDetailsTemplate.html\'"></ng-include>\n' +
    '              </ion-scroll>\n' +
    '              <div ng-if="!vm.isIOSDevice" class="scroll-y procedures-list">\n' +
    '                <ng-include src="\'views/templates/studyDetailsTemplate.html\'"></ng-include>\n' +
    '              </div>\n' +
    '              <div class="container-with-padding">\n' +
    '                &nbsp;\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col-26"></div>\n' +
    '          <div class="col-33">\n' +
    '            <label class="item tab-header item-transparent">\n' +
    '              <b>Exam View Only</b>\n' +
    '              <hr />\n' +
    '            </label>\n' +
    '            <div class="item item-text-wrap item-transparent left-align">\n' +
    '              <button class="button button-stable white-background button-ripple" ng-show="vm.study.SDate"\n' +
    '                ng-disabled="!vm.isOnline()" ng-click="vm.viewOnlyExam()">\n' +
    '                <div class="ripple">\n' +
    '                  View Only\n' +
    '                </div>\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="app-version-right-bottom">\n' +
    '    <app-version></app-version>\n' +
    '  </div>\n' +
    '</ion-view>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/chatModule/conversation-list.html',
    '<ion-view class="patient-info other-study-details" ng-class="{ \'darkmode-clear\': vm.darkMode}">\n' +
    '  <ion-header-bar class="bar-texture">\n' +
    '    <div class="buttons left-buttons">\n' +
    '      <span>\n' +
    '        <button class="button button-icon button-clear ion-arrow-left-c ripple" ng-click="vm.goBack()"></button>\n' +
    '      </span>\n' +
    '    </div>\n' +
    '    <h1 class="title title-left">\n' +
    '      Chat\n' +
    '      <small></small>\n' +
    '    </h1>\n' +
    '    <div class="buttons right-buttons user-name-section">\n' +
    '      <button id="refresh-btn" class="button button-icon button-refresh ion-refresh ripple" ng-click="vm.safeRefresh();"></button>\n' +
    '      \n' +
    '      <!-- <chat-bubble-component ng-if="$root.techpadSettings.IsShowChatMenuItem"></chat-bubble-component> -->\n' +
    '      <button id="chat-btn" class="button button-icon ripple chat-bubble-button" ng-if="$root.techpadSettings.IsShowChatMenuItem">\n' +
    '        <chat-bubble-component ng-if="$root.techpadSettings.IsShowChatMenuItem"></chat-bubble-component>\n' +
    '      </button>\n' +
    '      <network-status-checker></network-status-checker>\n' +
    '      <p id="username-btn" class="button button-clear user-name">{{getUserName()}}</p>\n' +
    '      <button class="button button-icon ion-log-out ripple" ng-click="logout()" ng-disabled="!isOnline()"></button>\n' +
    '    </div>\n' +
    '  </ion-header-bar>\n' +
    '  <div class="card form-page row chat-component" ng-if="!vm.forceReload">\n' +
    '    <chat-module-component [conversationId]="vm.conversationId" ></chat-module-component>\n' +
    '  </div>\n' +
    '</ion-view>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientDetails/patientDetails.html',
    '<div class="patient-detail-form-header">        \n' +
    '    <button class="button button-outline button-balanced ripple" \n' +
    '            ng-click="vm.save(vm.skipRedirecting)"\n' +
    '            ng-disabled="!vm.isOnline() || vm.isViewOnly || !vm.checkForChanges()">Save\n' +
    '    </button> \n' +
    '    <button class="button button-outline button-balanced ripple" \n' +
    '            ng-if="vm.ssn"\n' +
    '            disable-animation\n' +
    '            ng-click="vm.clipboardClicked();">Clipboard\n' +
    '    </button>       \n' +
    '  </div>\n' +
    '</div>\n' +
    '<ion-scroll ng-if="vm.isIOSDevice" zooming="false" direction="y" class="tab-scroll-without-footer">\n' +
    '  <ng-include src="\'views/templates/patientDetailsScrollTempate.html\'"></ng-include>\n' +
    '</ion-scroll>\n' +
    '<div ng-if="!vm.isIOSDevice" class="scroll-y-auto tab-scroll-without-footer scroll">\n' +
    '  <ng-include src="\'views/templates/patientDetailsScrollTempate.html\'"></ng-include>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientDetails/studies.html',
    '<div class="row w-100 studies-headers ">\n' +
    '  <table class="follow-ups-header w-100">\n' +
    '    <thead class="studies-header">\n' +
    '      <tr class="row">\n' +
    '        <th class="col w-120">Date</th>\n' +
    '        <th class="col w-25p">Location</th>\n' +
    '        <th class="col w-40p">Description</th>\n' +
    '        <th class="col w-30p">Tech</th>\n' +
    '        <th class="col w-120">Assessment</th>\n' +
    '        <th class="col w-130">Status</th>\n' +
    '        <th class="col"></th>\n' +
    '      </tr>\n' +
    '    </thead>\n' +
    '  </table>\n' +
    '</div>\n' +
    '\n' +
    '<ion-scroll ng-if="vm.isIOSDevice" zooming="false" direction="y" class="comments patient-detail-study-list study-content"\n' +
    '  overflow-scroll="false">\n' +
    '  <ng-include src="\'views/templates/studiesScrollTempate.html\'"></ng-include>\n' +
    '</ion-scroll>\n' +
    '<div ng-if="!vm.isIOSDevice" class="scroll-y comments patient-detail-study-list study-content">\n' +
    '  <ng-include src="\'views/templates/studiesScrollTempate.html\'"></ng-include>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientExam/commentsTab.html',
    '<div class="comments h-100">\n' +
    '  <div class="row">\n' +
    '    <div class="col-66"></div>\n' +
    '    <div class="col-33">\n' +
    '      <button class="button button-refresh pull-right button-dark" ng-click="vm.refreshComments()"\n' +
    '        ng-disabled="!vm.isOnline()">\n' +
    '        <i class="button-icon ion-refresh"></i>&nbsp; Refresh Comments\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <ion-scroll ng-if="vm.isIOSDevice" zooming="false" direction="y" class="scroll-y comments-wrapper"\n' +
    '    overflow-scroll="false">\n' +
    '    <ng-include src="\'views/templates/commentsTabScrollTemplate.html\'"></ng-include>\n' +
    '  </ion-scroll>\n' +
    '  <div ng-if="!vm.isIOSDevice" class="scroll-y comments-wrapper">\n' +
    '    <ng-include src="\'views/templates/commentsTabScrollTemplate.html\'"></ng-include>\n' +
    '  </div>\n' +
    '  <div class="container-with-padding"></div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientExam/demographicTab.html',
    '<div zooming="false"\n' +
    '     direction="y"\n' +
    '     class="h-100 scroll-y demographic-tab-scroll container-with-padding"\n' +
    '     overflow-scroll="false">\n' +
    '  <ng-include src="\'views/templates/demographicTabTemplate.html\'"></ng-include>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientExam/detailsTab.html',
    '<div class="col-50"\n' +
    '     ng-show="vm.patient.Study.VisitReason != \'S\' || (vm.patient.AllowSProb && vm.patient.Study.VisitReason == \'S\')">\n' +
    '  <label class="item tab-header details-list-header item-transparent">\n' +
    '    <b class="field-header">Problems</b>\n' +
    '    <br/>\n' +
    '    <div class="validationMessage" ng-if="vm.showValidationErrors && !vm.isProblemsValid">\n' +
    '      <div>Required.</div>\n' +
    '    </div>\n' +
    '    <hr/>\n' +
    '  </label>\n' +
    '  <div class="item item-transparent">\n' +
    '    <div class="row">\n' +
    '      <div class="col-40"><b>Name</b></div>\n' +
    '      <div class="col-20"><b>Unsp.</b></div>\n' +
    '      <div class="col-20"><b>Left</b></div>\n' +
    '      <div class="col-20"><b>Right</b></div>\n' +
    '    </div>\n' +
    '    <ion-scroll zooming="false" direction="y" overflow-scroll="false">\n' +
    '      <div class="row" ng-repeat="v in vm.problems">\n' +
    '        <div class="col-40 name-label problem-name-label" ng-class="{\'separator\':vm.isSeparator(v)}">\n' +
    '          <label simple-popover="{{ v.Value }}">{{ v.Value }}</label>\n' +
    '        </div>\n' +
    '        <div class="col-20" ng-hide="vm.isSeparator(v)">\n' +
    '          <label class="checkbox">\n' +
    '            <input type="checkbox" ng-model="v.IsUnspecified" ng-change="vm.updateProblemUnspecified(v)"\n' +
    '                   ng-disabled="vm.isViewOnly || vm.shouldDisableControls()">\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col-20" ng-hide="vm.isSeparator(v)">\n' +
    '          <label class="checkbox">\n' +
    '            <input type="checkbox" ng-model="v.IsLeft" ng-change="vm.updateProblemSide(v)"\n' +
    '                   ng-disabled="vm.isViewOnly || vm.shouldDisableControls()">\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col-20" ng-hide="vm.isSeparator(v)">\n' +
    '          <label class="checkbox">\n' +
    '            <input type="checkbox" ng-model="v.IsRight" ng-change="vm.updateProblemSide(v)"\n' +
    '                   ng-disabled="vm.isViewOnly || vm.shouldDisableControls()">\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </ion-scroll>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<div class="col-50">\n' +
    '  <div class="item tab-header details-list-header item-transparent item-dropdown-header"\n' +
    '       ng-if="!vm.isViewOnly && !vm.shouldDisableControls()">\n' +
    '    <dropdown-menu\n' +
    '      placeholder="Views Obtained" list="vm.views" property="Value" key="Key" icon="ion-plus"\n' +
    '      on-change="vm.addView"></dropdown-menu>\n' +
    '    <div class="validationMessage" ng-if="vm.showValidationErrors && !vm.isViewsValid">\n' +
    '      <div>Required.</div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <label class="item tab-header details-list-header item-transparent"\n' +
    '         ng-if="vm.isViewOnly || vm.shouldDisableControls()">\n' +
    '    <b class="field-header">Views Obtained</b>\n' +
    '    <br/>\n' +
    '    <hr/>\n' +
    '  </label>\n' +
    '  <div class="item item-transparent">\n' +
    '    <div class="row">\n' +
    '      <div class="col-33"><b>Name</b></div>\n' +
    '      <div class="col-33"><b>Side</b></div>\n' +
    '      <div class="col-25"><b>Type</b></div>\n' +
    '    </div>\n' +
    '    <ion-scroll zooming="false" direction="y" overflow-scroll="false">\n' +
    '      <div class="row views-row" ng-repeat="p in vm.patient.Study.Views">\n' +
    '        <div class="col-33 table-label">\n' +
    '          <label simple-popover="{{vm.getLabel(p.Code, vm.views)}}">{{vm.getLabel(p.Code, vm.views)}}</label>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-33" ng-if="!vm.isViewOnly && !vm.shouldDisableControls()">\n' +
    '          <dropdown class="dropdown-small"\n' +
    '                    placeholder="Select your option" list="vm.sides" property="Value" key="Key"\n' +
    '                    selected="p.Side"></dropdown>\n' +
    '        </div>\n' +
    '        <div class="col-33" ng-if="vm.isViewOnly || vm.shouldDisableControls()">\n' +
    '          <label>\n' +
    '            {{vm.getLabel(p.Side, vm.sides)}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-25" ng-if="!vm.isViewOnly && !vm.shouldDisableControls()">\n' +
    '          <dropdown class="dropdown-small"\n' +
    '                    placeholder="Select your option" list="vm.viewsTypes" property="Value" key="Key"\n' +
    '                    selected="p.Type"></dropdown>\n' +
    '        </div>\n' +
    '        <div class="col-25" ng-if="vm.isViewOnly || vm.shouldDisableControls()">\n' +
    '          <label>\n' +
    '            {{vm.getLabel(p.Type, vm.viewsTypes)}}\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '          <button class="button button-delete button-clear icon ion-ios-close-empty"\n' +
    '                  ng-click="vm.removeView(p)"\n' +
    '                  ng-if="!vm.isViewOnly && !vm.shouldDisableControls()"></button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </ion-scroll>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientExam/documentsTab.html',
    '<div class="document-tab h-100">\n' +
    '  <div class="item" ng-if="!vm.documentsLoaded">\n' +
    '    <ion-spinner></ion-spinner>\n' +
    '    <b>Loading...</b>\n' +
    '  </div>\n' +
    '  <div class="row h-100" ng-if="vm.documentsLoaded">\n' +
    '    <div class="col-15">\n' +
    '\n' +
    '      <table class="document-buttons-table">\n' +
    '        <tbody>\n' +
    '          <tr class="item row tab-header item-transparent dark">\n' +
    '            <td>\n' +
    '              <button class="button button-stable ripple ripple-cont" r-color="#FFFFFF"\n' +
    '                ng-class="{\'pressed\': vm.isShowContactsTypes}" ng-click="vm.toggleContactsTypes()">\n' +
    '                <div class="ripple-content">\n' +
    '                  &nbsp;&nbsp;Contacts&nbsp;&nbsp;\n' +
    '                </div>\n' +
    '                <div class="ink-content"></div>\n' +
    '              </button>\n' +
    '            </td>\n' +
    '          </tr>\n' +
    '          <tr class="item row tab-header item-transparent dark">\n' +
    '            <td>\n' +
    '              <button class="button button-stable ripple ripple-cont" r-color="#FFFFFF"\n' +
    '                ng-class="{\'pressed\': vm.isShowDocumentsTypes}" ng-click="vm.toggleDocumentTypes()">\n' +
    '                <div class="ripple-content">\n' +
    '                  &nbsp;&nbsp;Documents&nbsp;&nbsp;\n' +
    '                </div>\n' +
    '                <div class="ink-content"></div>\n' +
    '              </button>\n' +
    '            </td>\n' +
    '          </tr>\n' +
    '          <tr class="item row tab-header item-transparent dark">\n' +
    '            <td>\n' +
    '              <button class="button button-stable ripple ripple-cont" r-color="#FFFFFF"\n' +
    '                ng-class="{\'pressed\': vm.isShowLettersTypes}" ng-click="vm.toggleLettersTypes()">\n' +
    '                <div class="ripple-content">\n' +
    '                  &nbsp;&nbsp;Letters&nbsp;&nbsp;\n' +
    '                </div>\n' +
    '                <div class="ink-content"></div>\n' +
    '              </button>\n' +
    '            </td>\n' +
    '          </tr>\n' +
    '        </tbody>\n' +
    '      </table>\n' +
    '    </div>\n' +
    '    <div class="col-85">\n' +
    '      <div class="row">\n' +
    '        <div class="col col-100 text-right">\n' +
    '          <button class="button button-dark" ng-disabled="!isOnline() || vm.isViewOnly" ng-click="vm.addContactDocument()" ng-if="vm.techpadConfig.settings.IsContactDocumentsCreationAbilityEnabled">\n' +
    '            Add Contact\n' +
    '          </button>\n' +
    '          <button class="button button-dark" ng-disabled="!isOnline() || vm.isViewOnly" ng-click="vm.addDocument()" ng-if="vm.techpadConfig.settings.IsDocumentsCreationAbilityEnabled">\n' +
    '            Add Pdf Document\n' +
    '          </button>\n' +
    '          <button ng-if="vm.techpadConfig.settings.EnableUploadFilesOnDocumentsTab" ng-disabled="!isOnline()"\n' +
    '                  class="button button-positive button-patient-import"\n' +
    '                  ng-click="vm.patientImportDocumentPC($event)">\n' +
    '            <div class="import-icon"></div>&nbsp; &nbsp; Import\n' +
    '          </button>\n' +
    '          <button class="button button-refresh button-dark" ng-disabled="!isOnline()" ng-click="vm.refreshPatientDocuments()">\n' +
    '            <i class="button-icon ion-refresh"></i>&nbsp; Refresh Documents\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <table class="documents-table">\n' +
    '        <thead>\n' +
    '          <tr class="row">\n' +
    '            <th class="col col-15">Date</th>\n' +
    '            <th class="col col-20">Type</th>\n' +
    '            <th class="col col-65">Description</th>\n' +
    '          </tr>\n' +
    '        </thead>\n' +
    '      </table>\n' +
    '      <ion-scroll ng-if="vm.isIOSDevice" zooming="false" direction="y" class="documents scroll document-scroll-container"\n' +
    '        overflow-scroll="false">\n' +
    '        <ng-include src="\'views/templates/documentsTabScrollTemplate.html\'"></ng-include>\n' +
    '      </ion-scroll>\n' +
    '      <div ng-if="!vm.isIOSDevice" class="scroll-y documents">\n' +
    '        <ng-include src="\'views/templates/documentsTabScrollTemplate.html\'"></ng-include>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientExam/examTab.html',
    '<div zooming="false" \n' +
    '     direction="y"\n' +
    '     class="h-100 scroll-y exam-tab-scroll container-with-padding" \n' +
    '     overflow-scroll="false">\n' +
    '  <ng-include src="\'views/templates/examTabTemplate.html\'"></ng-include>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientExam/followUpTab.html',
    '<div class="row">\n' +
    '  <div class="col col-50 relative">\n' +
    '    <label class="checkbox pull-left">\n' +
    '      <input type="checkbox" ng-model="vm.showResolvedFollowup" ng-change="vm.resizeScrollArea()" />\n' +
    '    </label>\n' +
    '    <label class="show-resolved-label pull-left">Show Resolved</label>\n' +
    '  </div>\n' +
    '  <div class="col col-50 text-right">\n' +
    '    <button class="button button-dark" ng-disabled="(vm.isViewOnly && !vm.isMyPatientMode) || !vm.isOnline()" ng-click="vm.addFollowUp()">\n' +
    '      Add New Follow-up\n' +
    '    </button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<div class="row">\n' +
    '  <table class="follow-ups-header">\n' +
    '    <thead>\n' +
    '      <tr class="row">\n' +
    '        <th class="col col-20">Study Date</th>\n' +
    '        <th class="col col-20">Follow-up Date</th>\n' +
    '        <th class="col col-45">Type</th>\n' +
    '        <th class="col col-15">Status</th>\n' +
    '      </tr>\n' +
    '    </thead>\n' +
    '  </table>\n' +
    '</div>\n' +
    '<ion-scroll ng-if="vm.isIOSDevice" zooming="false" direction="y" class="followups" overflow-scroll="false">\n' +
    '  <ng-include src="\'views/templates/followUpTabScrollTemplate.html\'"></ng-include>\n' +
    '</ion-scroll>\n' +
    '<div ng-if="!vm.isIOSDevice" class="followups scroll-y">\n' +
    '  <ng-include src="\'views/templates/followUpTabScrollTemplate.html\'"></ng-include>\n' +
    '</div>\n' +
    '</ion-item>\n' +
    '</ion-list>\n' +
    '<div class="pad-14">\n' +
    '  &nbsp;\n' +
    '</div>\n' +
    '</ion-scroll>\n' +
    '<div class="row">\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientExam/historyTab.html',
    '<div class="survey-history-tab card form-page">\n' +
    '  <div class="row" ng-if="vm.historyConfig.rightHistoryConfig.length > 0 && !vm.isViewOnly">\n' +
    '    <div class="col-100">\n' +
    '      <div class="right-history-item-all-none">\n' +
    '        <button class="button button-dark m-b-10" ng-if="!vm.isViewOnly" ng-click="vm.SetAllNone()">\n' +
    '          No Others - select all None\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row history-tab-columns">\n' +
    '    <div ng-if="vm.isIOSDevice" class="col-50 m-l-10 history-tab-scroll-container"\n' +
    '      ng-repeat="col in vm.historyConfig.rightHistoryConfig">\n' +
    '      <ion-scroll zooming="false" direction="y" overflow-scroll="false" overflow-scroll="false">\n' +
    '        <ng-include src="\'views/templates/historyTabScrollTemplate.html\'"></ng-include>\n' +
    '      </ion-scroll>\n' +
    '    </div>\n' +
    '    <div ng-if="!vm.isIOSDevice" class="col-50 m-l-10 scroll-y history-tab-scroll-container"\n' +
    '      ng-repeat="col in vm.historyConfig.rightHistoryConfig">\n' +
    '      <ng-include src="\'views/templates/historyTabScrollTemplate.html\'"></ng-include>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientExam/imagesTab.html',
    '<ion-scroll zooming="false" direction="y" overflow-scroll="false">\n' +
    '  <div class="image-wrapper">\n' +
    '    <img src="images/real-images/image-1.png" ng-click="vm.showImagePreview(\'image-1\')"/>\n' +
    '    <img src="images/real-images/image-2.png" ng-click="vm.showImagePreview(\'image-2\')"/>\n' +
    '    <img src="images/real-images/image-3.png" ng-click="vm.showImagePreview(\'image-3\')"/>\n' +
    '    <img src="images/real-images/image-4.png" ng-click="vm.showImagePreview(\'image-4\')"/>\n' +
    '  </div>\n' +
    '</ion-scroll>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientExam/priorStudies.html',
    '<div class="row w-100 prior-studies-headers">\n' +
    '  <table class="follow-ups-header w-100">\n' +
    '    <thead class="studies-header">\n' +
    '      <tr class="row">\n' +
    '        <th class="col w-120">Date</th>\n' +
    '        <th class="col w-25p">Location</th>\n' +
    '        <th class="col w-40p">Description</th>\n' +
    '        <th class="col w-30p">Tech</th>\n' +
    '        <th class="col w-120">Assessment</th>\n' +
    '        <th class="col w-130">Status</th>\n' +
    '        <th class="col"></th>\n' +
    '      </tr>\n' +
    '    </thead>\n' +
    '  </table>\n' +
    '</div>\n' +
    '<ion-scroll ng-if="vm.isIOSDevice" zooming="false" direction="y" class="study-content" overflow-scroll="false">\n' +
    '  <ng-include src="\'views/templates/studiesTabScrollTemplate.html\'"></ng-include>\n' +
    '</ion-scroll>\n' +
    '<div ng-if="!vm.isIOSDevice" class="study-content scroll-y">\n' +
    '  <ng-include src="\'views/templates/studiesTabScrollTemplate.html\'"></ng-include>\n' +
    '</div>\n' +
    '</ion-item>\n' +
    '</ion-list>\n' +
    '<div class="pad-14">\n' +
    '  &nbsp;\n' +
    '</div>\n' +
    '</ion-scroll>\n' +
    '<div class="row">\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientExam/riskAssessments.html',
    '<div class="row" ng-if="!techpadSettings.NccnPat">\n' +
    '  <div class="col-66"></div>\n' +
    '  <div class="col-33">\n' +
    '    <button class="button button-refresh pull-right button-dark" ng-click="vm.recalculateRisks()"\n' +
    '      ng-disabled="vm.shouldDisableRecalculateRisks()">\n' +
    '      <i class="button-icon ion-refresh"></i>&nbsp; Update\n' +
    '    </button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<div class="row wider-scroll-area risk-tab-scroll-area" ng-class="{\'with-NCCN\':techpadSettings.NccnPat}">\n' +
    '  <div ng-if="vm.isIOSDevice" class="col-50 m-l-10 scroll-y risk-tab-scroll-container" ng-class="{\'with-NCCN\':techpadSettings.NccnPat}"\n' +
    '       ng-repeat="col in vm.riskTabColumns">\n' +
    '    <ng-include src="\'views/templates/riskTabScrollTemplate.html\'"></ng-include>\n' +
    '  </div>\n' +
    '  <div ng-if="!vm.isIOSDevice" class="col-50 m-l-10 scroll-y risk-tab-scroll-container" ng-class="{\'with-NCCN\':techpadSettings.NccnPat}"\n' +
    '       ng-repeat="col in vm.riskTabColumns">\n' +
    '    <ng-include src="\'views/templates/riskTabScrollTemplate.html\'"></ng-include>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/patientExam/tyrerCuzickTab.html',
    '<!--<link rel="stylesheet" href="Client/dist/font-awesome/css/font-awesome.css" />-->\n' +
    '<link rel="stylesheet" ng-href="{{vm.currenntMagViewUrl}}/survey/TechPadTheme" ng-if="vm.canLoadSurveyTheme" />\n' +
    '\n' +
    '<div class="tyrer-cuzick-tab-wrapper" ng-if="vm.canLoadTyrerCuzickContent">\n' +
    '    <survey-component [(survey-identity)]="vm.surveyIdentity" [(view-only)]="vm.isViewOnly"\n' +
    '        (on-survey-saved)="vm.onSurveySaved();"></survey-component>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/accessionBarcodeDialog.html',
    '<div class="modal modal-form">\n' +
    '    <header class="bar bar-header bar-dark">\n' +
    '        <h3 class="title">\n' +
    '            Accession barcode for \'{{model.data.accession}}\'\n' +
    '        </h3>\n' +
    '    </header>\n' +
    '\n' +
    '    <content has-header="true" class="padding">\n' +
    '        <div class="inner-content">\n' +
    '          <div class="item item-transparent text-center">\n' +
    '            <img data-ng-src="{{model.data.barcodeImage}}" alt="barcode">\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </content>\n' +
    '\n' +
    '      <footer class="bar bar-footer">\n' +
    '        <div class="row">\n' +
    '          <div class="col">\n' +
    '            <button class="button button-light button-cancel button-block" ng-click="model.close();">CANCEL</button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </footer>\n' +
    '\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/addReferringPhysicianDialogModel.html',
    '<div class="modal modal-form  model-referring-physician-add">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      Add Referring Physician\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content ng-if="model.isIOSDevice" has-header="true" class="padding content">\n' +
    '    <ng-include src="\'views/templates/addRefferingPhysicianDialogModelTemplate.html\'"></ng-include>\n' +
    '  </content>\n' +
    '  <div ng-if="!model.isIOSDevice" has-header="true" class="padding content"> \n' +
    '    <ng-include src="\'views/templates/addRefferingPhysicianDialogModelTemplate.html\'"></ng-include>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/addRefferingPhysicianDialogModelScrollTemplate.html',
    '<div class="row">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">RP ID:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <input ng-model="model.rp.RefNum">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row m-t-15">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">Last Name:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-15 m-l-15 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <input ng-model="model.rp.LastName">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">First Name:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-15 m-l-15 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <input ng-model="model.rp.FirstName">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">Suffix:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-15 m-l-15 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <input ng-model="model.rp.Suffix">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row m-t-15">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">Center:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <input ng-model="model.rp.Center">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row m-t-15">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">Street:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <input ng-model="model.rp.Street" placeholder="Street">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row m-t-15">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">State:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 reffering-physician-input">\n' +
    '        <dropdown-menu placeholder="State" list="model.statesList" select-mode="true" property="name" key="code"\n' +
    '            dropdown-height="225" show-caret="true" selected="model.rp.State" hide-other-dropdown="true"\n' +
    '            class="modal-dropdown" on-selection-change="model.changeState($type)" ng-if="!model.isViewOnly">\n' +
    '        </dropdown-menu>\n' +
    '        <label class="item item-input short" ng-if="model.isViewOnly">\n' +
    '            <input class="checkbox-label" ng-disabled="model.isViewOnly" type="text"\n' +
    '                ng-value="model.getStateName(model.rp.State)" />\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row m-t-15">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">City:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 ">\n' +
    '        <dropdown-menu placeholder="City" list="model.citiesList" select-mode="true" property="Name" key="Name"\n' +
    '            dropdown-height="225" show-caret="true" selected="model.rp.City" hide-other-dropdown="true"\n' +
    '            class="modal-dropdown" on-selection-change="model.changeCity($type)" ng-if="!model.isViewOnly"\n' +
    '            disabled="!model.rp.State"></dropdown-menu>\n' +
    '        <label class="item item-input short" ng-if="model.isViewOnly">\n' +
    '            <input class="checkbox-label" ng-disabled="model.isViewOnly" type="text" ng-value="model.rp.City" />\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row m-t-15">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">Zip:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 ">\n' +
    '        <dropdown-menu placeholder="Zip" list="model.zipCodesList" select-mode="true" property="code" key="code"\n' +
    '            dropdown-height="225" show-caret="true" selected="model.rp.Zip" hide-other-dropdown="true"\n' +
    '            class="modal-dropdown" ng-if="!model.isViewOnly && model.rp.State && model.rp.City"></dropdown-menu>\n' +
    '        <label class="item item-input short zip-code-label" ng-show="model.isViewOnly || !model.rp.State || !model.rp.City">\n' +
    '            <input type="text" placeholder="Zip" maxlength="5" ng-change="model.fillStateCity()" ng-model="model.rp.Zip"\n' +
    '                oninput="this.value=this.value.replace(/[^0-9]/g,\'\');" ng-disabled="model.isViewOnly" />\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row m-t-15">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">Specialty:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <input ng-model="model.rp.Specialty">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row m-t-15">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">Phone:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-17 m-l-10 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <input ng-model="model.rp.Phone" ng-change="model.rp.Phone = model.formatPhoneValue(model.rp.Phone)">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">Alt Phone:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-17 m-l-10 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <input ng-model="model.rp.OtherPhone"\n' +
    '                ng-change="model.rp.OtherPhone = model.formatPhoneValue(model.rp.OtherPhone)">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">Fax Phone:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-17 m-l-10 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <input ng-model="model.rp.Fax" ng-change="model.rp.Fax = model.formatPhoneValue(model.rp.Fax)">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row m-t-15">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">Fax reports:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-50 m-l-15 reffering-physician-input">\n' +
    '        <label class="checkbox pull-left">\n' +
    '            <input type="checkbox" ng-model="model.rp.FaxReport">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row m-t-15">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">RP Letter Type:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 reffering-physician-input">\n' +
    '        <dropdown-menu list="model.letterTypes" select-mode="true" display-property="Desc" property="Desc" key="Code"\n' +
    '            selected="model.rp.RpLetterType" show-caret="true" dropdown-height="156" class="modal-dropdown"\n' +
    '            hide-other-dropdown="true">\n' +
    '        </dropdown-menu>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row m-t-15">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">Patient Letter Type:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 reffering-physician-input">\n' +
    '        <dropdown-menu list="model.letterTypes" select-mode="true" display-property="Desc" property="Desc" key="Code"\n' +
    '            selected="model.rp.PatientLetterType" show-caret="true" dropdown-height="156" class="modal-dropdown"\n' +
    '            hide-other-dropdown="true">\n' +
    '        </dropdown-menu>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row m-t-15">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">Recall Letter Type:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 reffering-physician-input">\n' +
    '        <dropdown-menu list="model.letterTypes" select-mode="true" display-property="Desc" property="Desc" key="Code"\n' +
    '            selected="model.rp.RecallLetterType" show-caret="true" dropdown-height="156" class="modal-dropdown"\n' +
    '            hide-other-dropdown="true">\n' +
    '        </dropdown-menu>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row" ng-if="model.showUdf1">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">RP UDF1:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <input ng-model="model.rp.Udf1">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row" ng-if="model.showUdf2">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold">RP UDF2:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <input ng-model="model.rp.Udf2">\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row">\n' +
    '    <div class="col-15 text-right section-title">\n' +
    '        <label class="bold top-10">Notes:</label>\n' +
    '    </div>\n' +
    '    <div class="col col-85 m-l-15 reffering-physician-input">\n' +
    '        <label class="item item-input short">\n' +
    '            <textarea ng-model="model.rp.Notes" class="text-input" rows="3"></textarea>\n' +
    '        </label>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/addRefferingPhysicianDialogModelTemplate.html',
    '<div class="inner-content">\n' +
    '    <ion-scroll ng-if="model.isIOSDevice" class="dynamic-filter examTypes" overflow-scroll="false" style="height: 530px;">\n' +
    '        <ng-include src="\'views/templates/addRefferingPhysicianDialogModelScrollTemplate.html\'"></ng-include>\n' +
    '    </ion-scroll>\n' +
    '    <div ng-if="!model.isIOSDevice" class="scroll-y scroll add-referring-physician-scroll">\n' +
    '        <ng-include src="\'views/templates/addRefferingPhysicianDialogModelScrollTemplate.html\'"></ng-include>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row m-t-25">\n' +
    '        <div class="col-20"></div>\n' +
    '        <div class="col-33 padding-horizontal">\n' +
    '            <button class="button button-positive button-block" ng-disabled="model.isViewOnly"\n' +
    '                ng-click="model.saveReferringPhysician();">\n' +
    '                Save\n' +
    '            </button>\n' +
    '        </div>\n' +
    '        <div class="col-33 padding-left">\n' +
    '            <button class="button button-stable button-block back-btn" ng-click="model.closeWindow();">\n' +
    '                Cancel\n' +
    '            </button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/angularCropper.html',
    '<div class="angular-cropper">\n' +
    '  <img ng-on-load="onImageLoaded($event)"\n' +
    '       ng-src="{{fileURL}}">\n' +
    '</div>\n' +
    '<div class="row m-t-15 cropper-buttons">\n' +
    '  <div>\n' +
    '    <button class="button button-positive button-block"\n' +
    '            ng-disabled="selectionMode === 0"\n' +
    '            ng-click="changeMode(0)">\n' +
    '      Crop\n' +
    '    </button>\n' +
    '  </div>\n' +
    '  <div>\n' +
    '    <button class="button button-positive button-block back-btn"\n' +
    '            ng-disabled="selectionMode === 1"\n' +
    '            ng-click="changeMode(1)">\n' +
    '      Resize\n' +
    '    </button>\n' +
    '  </div>\n' +
    '  <div class="item item-input rotate-input">\n' +
    '    <div class="ion-ios-refresh-outline"></div>\n' +
    '    <div>\n' +
    '      <input type="{{settings.isIOS ? \'text\' : \'number\'}}"\n' +
    '             allow-negative="true"\n' +
    '             only-int="{{settings.isIOS}}"\n' +
    '             numbers-only\n' +
    '             ng-keypress="onKeyPressed($event)"\n' +
    '             ng-model="rotate">\n' +
    '    </div>\n' +
    '    <div>\n' +
    '      <div class="fa fa-caret-up rotate-btn rotate-up"></div>\n' +
    '      <div class="fa fa-caret-down rotate-btn rotate-down"></div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/clipboardDialog.html',
    '<div class="modal modal-form modal-clipboard">\n' +
    '    <header class="bar bar-header bar-dark">\n' +
    '      <h3 class="title">\n' +
    '          {{model.title}}\n' +
    '      </h3>\n' +
    '    </header>\n' +
    '    <content has-header="true">\n' +
    '      <div class="inner-content">\n' +
    '        <div class="row m-t-15">\n' +
    '          <div class="col-25 text-right section-title">\n' +
    '            <label class="bold">Flag:</label>\n' +
    '          </div>\n' +
    '          <div class="col col-75">\n' +
    '            <div class="item item-input input-dropdown-container">\n' +
    '              <input-dropdown class="w-100"\n' +
    '                              list="model.cannedNotes"\n' +
    '                              model="model.data"\n' +
    '                              property="Name"\n' +
    '                              propertyvalue="Value"\n' +
    '                              modelproperty="Flag"\n' +
    '                              disableenter="false"\n' +
    '                              containerclass="m-t-10"></input-dropdown>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row m-t-15">\n' +
    '          <div class="col-25 text-right section-title">\n' +
    '            <label class="bold top-10">Patient Notes:</label>\n' +
    '          </div>\n' +
    '          <div class="col col-75">\n' +
    '            <div class="patient-notes scroll">\n' +
    '                <table>\n' +
    '                  <tr ng-repeat="itemNote in model.data.PatientNotes | filter:{ Clip: model.patientNotesFilter.keyword}"\n' +
    '                      ng-click="model.patientNoteSelected(itemNote)"\n' +
    '                      ng-class="{\'active\': model.selectedPatientNote.Id === itemNote.Id}">\n' +
    '                    <td>{{itemNote.ADate | date: \'MM/dd/yyyy\'}}</td>\n' +
    '                    <td>{{itemNote.Clip}}</td>\n' +
    '                  </tr>\n' +
    '                </table>\n' +
    '            </div>\n' +
    '            <div class="patient-notes-tools text-right">\n' +
    '                <button class="button button-assertive"\n' +
    '                        ng-disabled="!model.selectedPatientNote || model.isViewOnly || !model.patClipPref.AllowModifyPatClipNote"\n' +
    '                        ng-click="model.deletePatClipNoteItem();">\n' +
    '                        Delete\n' +
    '                </button>\n' +
    '                <button class="button button-positive"\n' +
    '                        ng-disabled="!model.selectedPatientNote || model.isViewOnly || !model.patClipPref.AllowModifyPatClipNote"\n' +
    '                        ng-click="model.modifyPatClipNoteItem();">\n' +
    '                        Modify\n' +
    '                </button>\n' +
    '                <button class="button button-stable"\n' +
    '                        ng-disabled="model.isViewOnly"\n' +
    '                        ng-click="model.addPatClipNoteItem();">\n' +
    '                        Add\n' +
    '                </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row m-t-15">\n' +
    '          <div class="col col-25 text-right section-title">\n' +
    '            <label class="bold top-10">Patient Clipboard:</label>\n' +
    '          </div>\n' +
    '          <div class="col col-75">\n' +
    '              <textarea width="100%" class="text-input editable-textarea" ng-model="model.data.Clip" rows="5" ng-disabled="model.isViewOnly"></textarea>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row m-t-15">\n' +
    '          <div class="col col-25 text-right section-title">\n' +
    '            <label class="bold">Search:</label>\n' +
    '          </div>\n' +
    '          <div class="col col-25">\n' +
    '              <label class="item item-input">\n' +
    '                <input class="m-t-10" ng-keyup="model.searchInputKeyup();"ng-model="model.patientNotesFilter.keyword">\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          <div class="col col-25 text-right section-title">\n' +
    '              <label class="bold">Expiration Date:</label>\n' +
    '          </div>\n' +
    '          <div class="col col-20 relative" class="col-25">\n' +
    '              <label class="item item-input">\n' +
    '                <input class="m-t-10" value="{{model.data.ExpDate | date: \'MM/dd/yyyy\'}}" disabled="disabled">\n' +
    '              </label>\n' +
    '          </div>\n' +
    '          <div class="col col-5 relative">\n' +
    '              <button type="button" class="icon ion-calendar date-element" ng-click="model.changeDate()"></button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row m-t-25">\n' +
    '            <div class="col-20"></div>\n' +
    '            <div class="col-33 padding-horizontal">\n' +
    '              <button class="button button-positive button-block"\n' +
    '                      ng-disabled="model.isViewOnly"\n' +
    '                      ng-click="model.savePatClip();">\n' +
    '                Save\n' +
    '              </button>\n' +
    '            </div>\n' +
    '            <div class="col-33 padding-left">\n' +
    '              <button class="button button-stable button-block back-btn"\n' +
    '                      ng-click="model.closeWindow();">\n' +
    '                Cancel\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '      </div>\n' +
    '    </content>\n' +
    '  </div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/clipboardNoteDialog.html',
    '<div class="modal modal-form modal-clipboard-note">\n' +
    '    <header class="bar bar-header bar-dark">\n' +
    '      <h3 class="title">\n' +
    '        {{model.title}}\n' +
    '      </h3>\n' +
    '    </header>\n' +
    '    <content has-header="true">\n' +
    '      <div class="inner-content">  \n' +
    '        \n' +
    '        <div class="row m-t-15">\n' +
    '          <div class="col-25 text-right section-title">\n' +
    '            <label class="bold">Added:</label>            \n' +
    '          </div>\n' +
    '          <div class="col col-75">\n' +
    '              <label class="item item-input">\n' +
    '                <input class="flag-input m-t-10" value="{{model.data.ADate | date: \'MM/dd/yyyy hh:mm:ss a\'}}" disabled>\n' +
    '              </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-15">\n' +
    '          <div class="col-25 text-right section-title">\n' +
    '            <label class="bold">Last Modified:</label>\n' +
    '          </div>\n' +
    '          <div class="col col-75">\n' +
    '              <label class="item item-input">\n' +
    '                <input class="flag-input m-t-10" value="{{model.data.MDate  | date: \'MM/dd/yyyy hh:mm:ss a\'}}" disabled>\n' +
    '              </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '  \n' +
    '        <div class="row m-t-15">\n' +
    '          <div class="col col-25 text-right section-title">\n' +
    '            <label class="bold" style="top: 10px">Note:</label>\n' +
    '          </div>\n' +
    '          <div class="col col-75">\n' +
    '              <textarea width="100%" class="text-input editable-textarea" ng-model="model.data.Clip" rows="4"></textarea>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row m-t-15">\n' +
    '            <div class="col-25 text-right section-title">\n' +
    '              <label class="bold">Clipboard only:</label>\n' +
    '            </div>\n' +
    '            <div class="col col-75">\n' +
    '                <label class="checkbox pull-left">\n' +
    '                    <input type="checkbox" ng-model="model.data.ClipboardOnly"/>\n' +
    '                </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        <div class="row m-t-25">\n' +
    '            <div class="col-20"></div>\n' +
    '            <div class="col-33 padding-horizontal">\n' +
    '              <button class="button button-positive button-block"\n' +
    '                      ng-click="model.save();">\n' +
    '                Save\n' +
    '              </button>\n' +
    '            </div>\n' +
    '            <div class="col-33 padding-left">\n' +
    '              <button class="button button-stable button-block back-btn"\n' +
    '                      ng-click="model.closeWindow();">\n' +
    '                Cancel\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '      </div>\n' +
    '    </content>\n' +
    '  </div>\n' +
    '  ');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/commentsDialog.html',
    '<div class="inner-content comments-popup">\n' +
    '  <div class="comment-header">\n' +
    '    <div>Comment</div>\n' +
    '    <button ng-click="model.clearBox()"\n' +
    '            class="clear-button">Clear</button>\n' +
    '  </div>\n' +
    '  <textarea class="text-input editable-textarea w-100"\n' +
    '            ng-model="model.comment"\n' +
    '            rows="8"\n' +
    '            ng-disabled="model.isViewOnly"></textarea>\n' +
    '  <div ng-if="model.noteItems && model.noteItems.length"\n' +
    '       class="canned-notes">\n' +
    '    <div class="canned-title">\n' +
    '      Canned Notes\n' +
    '    </div>\n' +
    '    <div class="item item-input input-dropdown-container border-none">\n' +
    '      <input-dropdown class="w-100"\n' +
    '                      list="model.noteItems"\n' +
    '                      model="model"\n' +
    '                      property="Name"\n' +
    '                      propertyvalue="Value"\n' +
    '                      modelproperty="comment"\n' +
    '                      disableenter="true"></input-dropdown>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/commentsTabScrollTemplate.html',
    '<div class="comments-container-with-padding"> \n' +
    '    <div ng-repeat="commentSetting in vm.techpadConfig.settings.CommentsSettings">\n' +
    '        <div class="item tab-header item-transparent">\n' +
    '            <b>{{commentSetting.Title}}</b>\n' +
    '            <i class="icon circle-icon ion-edit" ng-hide="(vm.flags[commentSetting.Field] || commentSetting.IsReadonly)"\n' +
    '                ng-click="vm.editComment(commentSetting)"\n' +
    '                ng-disabled="vm.isViewOnly || vm.shouldDisableControls()"></i>\n' +
    '            <i class="icon large-icon ion-ios-checkmark-outline" ng-show="vm.flags[commentSetting.Field]"\n' +
    '                ng-disabled="vm.isViewOnly || vm.shouldDisableControls()"\n' +
    '                ng-click="vm.editComment(commentSetting.Field)"></i>\n' +
    '            <i class="icon large-icon ion-ios-close-outline" ng-show="vm.flags[commentSetting.Field]"\n' +
    '                ng-disabled="vm.isViewOnly || vm.shouldDisableControls()"\n' +
    '                ng-click="vm.editComment(commentSetting.Field, true)"></i>\n' +
    '        </div>\n' +
    '        <div class="item item-text-wrap item-transparent">\n' +
    '            <textarea ng-show="vm.flags[commentSetting.Field]" class="comment-area"\n' +
    '                ng-model="vm.patient.Study.Comments[commentSetting.Field]"></textarea>\n' +
    '            <div ng-hide="(vm.flags[commentSetting.Field] || commentSetting.IsReadonly)">\n' +
    '                <pre ng-hide="vm.flags[commentSetting.Field]">{{vm.patient.Study.Comments[commentSetting.Field]}}</pre>\n' +
    '            </div>\n' +
    '            <div ng-show="(vm.flags[commentSetting.Field] || commentSetting.IsReadonly)">\n' +
    '                <br />\n' +
    '                <pre ng-hide="vm.flags[commentSetting.Field]">{{vm.patient.Study.Comments[commentSetting.Field]}}</pre>\n' +
    '            </div>\n' +
    '            <hr />\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/contactDocumentCreateDialog.html',
    '<div class="modal modal-form create-document-form contact-form">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      {{model.titleText}}\n' +
    '    </h3>\n' +
    '    <div class="buttons right-buttons">\n' +
    '      <button class="button button-icon ion-close" ng-click="model.close(true)"></button>\n' +
    '    </div>\n' +
    '\n' +
    '  </header>\n' +
    '  <content has-header="true">\n' +
    '    <label class="item" ng-if="model.loading"><b>Loading...</b></label>\n' +
    '    <div ng-if="!model.loading">\n' +
    '      <follow-up-patient-details\n' +
    '        patient-access-token="model.patientAccessToken"\n' +
    '        clip="model.clip">\n' +
    '      </follow-up-patient-details>\n' +
    '      <div class="follow-up-details-container">\n' +
    '        <div class="inner-content patient-contact-container">\n' +
    '          <div class="item item-transparent">\n' +
    '            <div class="row m-b-10">\n' +
    '              <div class="col-60 d-flex align-items-center">\n' +
    '                <div class="section-title">\n' +
    '                  <label class="bold">Contact Date:</label>\n' +
    '                </div>\n' +
    '                <div class="d-flex align-items-center">\n' +
    '                  <label class="item item-date-input no-border">\n' +
    '                    <input id="contact-date" ng-model="model.contact.ContactDate"\n' +
    '                           date-input="model.contact.ContactDate" />\n' +
    '                  </label>\n' +
    '                  <button class="contact-date-picker-button" ng-click="model.changeDate(model.contact, \'ContactDate\')">\n' +
    '                    <i class="icon ion-calendar"></i>\n' +
    '                  </button>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-40 d-flex align-items-center">\n' +
    '                <div class="section-title">\n' +
    '                  <label class="bold">Contact Type:</label>\n' +
    '                </div>\n' +
    '                <div class="item item-input no-border dropdown-input">\n' +
    '                  <dropdown-menu \n' +
    '                    class="modal-dropdown"\n' +
    '                    ng-class="{\'invalid-data\': model.highlightInvalidData && !model.contact.Code}"\n' +
    '                    placeholder="Select Contact Type" \n' +
    '                    list="model.contactTypes" \n' +
    '                    property="Description" \n' +
    '                    key="Code" \n' +
    '                    selected="model.contact.Code"\n' +
    '                    select-mode="true"\n' +
    '                    is-multi-select="false">\n' +
    '                  </dropdown-menu>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row m-b-10">\n' +
    '              <div class="col-100 d-flex align-items-center">\n' +
    '                <div class="section-title">\n' +
    '                  <label class="bold">Comment/Notes:</label>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row m-b-10">\n' +
    '              <div class="col-100 d-flex align-items-center">\n' +
    '                <div class="item item-input no-border textarea-container">\n' +
    '                  <textarea class="contact-comments" class="w-100" ng-model="model.contact.Comment" rows="5" placeholder="Contact comment"></textarea>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row m-b-10">\n' +
    '              <div class="col-100 d-flex align-items-center buttons-container">\n' +
    '                <button class="button button-positive button-block"\n' +
    '                    ng-click="model.saveContact()">\n' +
    '                  SAVE\n' +
    '                </button>\n' +
    '                <button class="button button-positive button-block"\n' +
    '                    ng-click="model.saveContact(true)">\n' +
    '                  SAVE AND CLOSE\n' +
    '                </button>\n' +
    '                <button class="button button-stable button-block back-btn"\n' +
    '                        ng-click="model.close(true)">\n' +
    '                  CANCEL\n' +
    '                </button>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="inner-content follow-up-list-container create" ng-if="model.followUpsOnDue && model.followUpsOnDue.length">\n' +
    '          <div class="item item-transparent" ng-show="!model.followUpOnDueToResolve">\n' +
    '            <div>\n' +
    '              <h2>Follow-up Information</h2>\n' +
    '            </div>\n' +
    '            <div ng-class="{\'scroll-bar-padding\': model.followUpsOnDue.length > 4}">\n' +
    '              <table class="w-100">\n' +
    '                <thead>\n' +
    '                  <tr class="row text-left">\n' +
    '                    <th class="col col-15">FOLLOW DATE</th>\n' +
    '                    <th class="col col-45">TYPE</th>\n' +
    '                    <th class="col col-10">LETTERS</th>\n' +
    '                    <th class="col col-15">STUDY</th>\n' +
    '                    <th class="col col-15"></th>\n' +
    '                  </tr>\n' +
    '                </thead>\n' +
    '              </table>\n' +
    '            </div>\n' +
    '            <div class="scrollable-follow-ups-records">\n' +
    '              <table class="w-100">\n' +
    '                <tbody>\n' +
    '                  <tr class="row text-left" ng-repeat="followUp in model.followUpsOnDue">\n' +
    '                    <td class="col col-15">\n' +
    '                      {{followUp.RecallDate | date:\'MM/dd/yyyy\'}}\n' +
    '                    </td>\n' +
    '                    <td class="col col-45">\n' +
    '                      {{followUp.RecommendationDescription}}\n' +
    '                    </td>\n' +
    '                    <td class="col col-10">\n' +
    '                      {{followUp.Letters}}\n' +
    '                    </td>\n' +
    '                    <td class="col col-15">\n' +
    '                      {{followUp.Study | date:\'MM/dd/yyyy\'}}\n' +
    '                    </td>\n' +
    '                    <td class="col col-15 small-buttons-container d-flex">\n' +
    '                      <button class="button button-dark button-outline button-small" ng-click="model.resolveFollowUp(followUp)">\n' +
    '                        <i class="icon ion-checkmark"></i>\n' +
    '                      </button>\n' +
    '                      <button class="button button-assertive button-outline button-small" ng-click="model.deleteFollowUp(followUp)">\n' +
    '                        <i class="icon ion-trash-a"></i>\n' +
    '                      </button>\n' +
    '                    </td>\n' +
    '                  </tr>\n' +
    '                </tbody>\n' +
    '              </table>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <resolve-follow-up\n' +
    '            ng-if="!!model.followUpOnDueToResolve"\n' +
    '            follow-up="model.followUpOnDueToResolve"\n' +
    '            is-show-resolve-button="true"\n' +
    '            is-show-delete-button="true"\n' +
    '            is-show-cancel-button="true"\n' +
    '            on-resolved="model.proceedResolveFollowUp()"\n' +
    '            on-canceled="model.cancelResolveFollowUp()"\n' +
    '            on-deleted="model.onDeletedFollowUp()"\n' +
    '            check-if-stil-owning="model.checkIfStillOwningAndNotOffline()">\n' +
    '          </resolve-follow-up>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/cropDialog.html',
    '<div class="modal modal-form">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      {{ model.title }}\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content has-header="true">\n' +
    '    <div class="inner-content">\n' +
    '      <div>\n' +
    '        <angular-cropper settings="model.cropperSettings"></angular-cropper>\n' +
    '      </div>\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-50 padding-right">\n' +
    '          <button class="button button-positive button-block"\n' +
    '                  ng-click="model.save();">\n' +
    '            Save\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-50 padding-left">\n' +
    '          <button class="button button-stable button-block back-btn"\n' +
    '                  ng-click="model.closeWindow();">\n' +
    '            Cancel\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/cropperService.html',
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/dashboardChangeAdditionalInfo.html',
    '<ion-popover-view>\n' +
    '  <ion-content scroll="true">\n' +
    '    <div class="list">\n' +
    '      <a class="item item-icon" href="javascript:void(0)" ng-repeat="additionalInfo in vm.additionalInfos"\n' +
    '        ng-click="vm.applyAdditionalInfo(worklistItem, additionalInfo, modal);">\n' +
    '        {{ vm.statusHelpers.getAdditionalInfoLabel(additionalInfo) }}\n' +
    '      </a>\n' +
    '      <!-- <a class="item item-icon red-colored" ng-if="!vm.additionalInfos && !!worklistItem.WorklistAdditionalInfo"\n' +
    '        href="javascript:void(0)" ng-click="modal.remove();">\n' +
    '        {{ vm.statusHelpers.getAdditionalInfoLabel(additionalInfo) }}\n' +
    '      </a>\n' +
    '      <a class="item item-icon red-colored" ng-if="!vm.additionalInfos && !worklistItem.WorklistAdditionalInfo"\n' +
    '        href="javascript:void(0)" ng-click="modal.remove();">\n' +
    '        No additional info configured\n' +
    '      </a> -->\n' +
    '      <a class="item item-icon red-colored" href="javascript:void(0)" ng-if="showRemoveAdditionalInfo"\n' +
    '        ng-click="vm.changeAdditionalInfo(worklistItem, \'\');modal.remove()">\n' +
    '        Remove additional info\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '</ion-popover-view>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/dashboardChangeStatus.html',
    '<ion-popover-view class="settings-popover">\n' +
    '  <ion-content scroll="false">\n' +
    '    <div class="list dashboard-statuses-list scroll">\n' +
    '      <a ng-if="!isLinked" class="item item-icon" href="javascript:void(0)"\n' +
    '         ng-repeat="status in vm.allowedWorklistChangeStatuses"\n' +
    '         ng-click="vm.changeStatus(item, status.Status);modal.remove()">\n' +
    '        {{status.Label}}\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '</ion-popover-view>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/dashboardWindow.html',
    '<div class="modal dashboard-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h1 class="title">\n' +
    '      <div class="name-wrapper" ng-class="{\'perform-exam\':model.isShowGeneratePinNumber(item)}">\n' +
    '        <div ng-if="item.FirstName || item.LastName" data-fittext data-fittext-min="15" data-fittext-max="30">\n' +
    '          {{item.LastName | camelize}}, {{item.FirstName | camelize}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </h1>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="padding">\n' +
    '    <div class="inner-content list">\n' +
    '      <div class="row">\n' +
    '        <div class="col-30 text-right label change-status-label">\n' +
    '          Change Status:\n' +
    '        </div>\n' +
    '        <div class="col-70 label-value">\n' +
    '          <button class="button button-stable button-block change-status-btn icon-right ion-arrow-down-b ripple" ng-click="model.changeDashboardItemStatusPopover(item, $event)" ng-disabled="!model.isOnline()">\n' +
    '                <label class="message-label-dasboard padding-top-9">\n' +
    '                {{ model.statusHelpers.getStatusName(item.Status) }}\n' +
    '                </label>\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '      <!-- <div class="row" ng-if="!!item.WorklistAdditionalInfo && (item.Status === \'TakeExam\' || item.Status === \'ReviewComplete\')"> -->\n' +
    '        <div class="col-30 text-right label change-status-label">\n' +
    '          Additional Information:\n' +
    '        </div>\n' +
    '        <div class="col-70 label-value display-inline">\n' +
    '          <!-- {{ item.Resource }} -->\n' +
    '          <button class="button button-stable button-block change-status-btn icon-right ion-arrow-down-b ripple" \n' +
    '                  ng-click="model.changeListMessageAndResourcePopover(item, $event, true)" \n' +
    '                  ng-disabled="!model.isOnline() || model.ListMessageReadOnly">\n' +
    '            <label class="message-label-dasboard padding-top-9">\n' +
    '            {{ item.Resource || \'Select Additional Info\'}}\n' +
    '            </label>\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="(model.authService.isRadiologist() && !!item.ListMessage) || (!model.authService.isRadiologist() && !!item.RadListMessage)">\n' +
    '        <div class="col-30 text-right label change-status-label">\n' +
    '          <span ng-if="model.authService.isRadiologist() && item.ListMessage">Tech Message:</span>\n' +
    '          <span ng-if="!model.authService.isRadiologist() && item.RadListMessage">Rad Message:</span>\n' +
    '        </div>\n' +
    '        <div class="col-70 label-value">\n' +
    '          <span ng-if="model.authService.isRadiologist() && item.ListMessage" class="mt-mb-10">{{ item.ListMessage }}</span>\n' +
    '          <span ng-if="!model.authService.isRadiologist() && item.RadListMessage" class="mt-mb-10">{{ item.RadListMessage }}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-30 text-right label change-status-label">\n' +
    '          Message:\n' +
    '        </div>\n' +
    '        <div class="col-70 label-value">\n' +
    '          <textarea placeholder="Type message here" class="list-messages-add-message col-100" rows="4" type="text"\n' +
    '                    ng-model="item.newListMessage"\n' +
    '                    ng-disabled="model.ListMessageReadOnly"></textarea>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-100 label-value align-right">\n' +
    '          <button class="button button-balanced button-outline btn-save ripple" r-color="#FFFFFF"\n' +
    '                  ng-click="model.onDashboardWindowSave(item, modal)" \n' +
    '                  ng-disabled="!model.isOnline() || item.newListMessage === item.oldListMessage">\n' +
    '            <div>\n' +
    '              &nbsp;&nbsp;Save&nbsp;&nbsp;\n' +
    '            </div>\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/dateRecordEditDialog.html',
    '<div class="modal modal-form modal-date-select-form">\n' +
    '        <header class="bar bar-header bar-dark">\n' +
    '          <h3 class="title">\n' +
    '            Select Date\n' +
    '          </h3>\n' +
    '        </header>\n' +
    '        <content has-header="true" class="padding">          \n' +
    '          <div class="inner-content" ng-show="!model.needRefresh">\n' +
    '                 \n' +
    '            <div class="row">\n' +
    '              <div class="col col-25"></div>\n' +
    '              \n' +
    '              <div class="col col-30">\n' +
    '                <label class="item item-input">\n' +
    '                  <input type="date" ng-model="model.date" class="left-side-date-input">   \n' +
    '                </label>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="col col-25"></div>\n' +
    '            </div>\n' +
    '      \n' +
    '                 \n' +
    '            <div class="row">              \n' +
    '              <div class="col-50 padding-horizontal">\n' +
    '                <button class="button button-positive button-block"\n' +
    '                        ng-click="model.save();">\n' +
    '                  Save\n' +
    '                </button>\n' +
    '              </div>\n' +
    '              <div class="col-50 padding-left">\n' +
    '                <button class="button button-stable button-block back-btn"\n' +
    '                        ng-click="model.closeWindow();">\n' +
    '                  Cancel\n' +
    '                </button>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '      \n' +
    '          </div>\n' +
    '        </content>\n' +
    '      </div>\n' +
    '      ');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/demographicTabTemplate.html',
    '<form class="custom-form" name="demographicForm">\n' +
    '    <div class="row">\n' +
    '      <div class="col-50 form-cols" ng-repeat="col in vm.historyConfig.leftHistoryConfig">\n' +
    '        <div class="row align-items-center" ng-repeat="item in col">\n' +
    '          <div class="col col-50 label" ng-class="{\'border-bottom-danger-child\': vm.showValidationErrors && vm.notValidLeftHistory[item.Id]}"\n' +
    '            ng-if="item.Type != \'BRCA\'">\n' +
    '            <label class="item">\n' +
    '              <b>{{item.Caption}}</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col col-50" ng-if="item.Type == \'YESNO\'">\n' +
    '            <div class="item">\n' +
    '              <label class="checkbox pull-left"\n' +
    '                     ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                <input id="{{item.Id+ \'YES\'}}" type="checkbox" ng-model="vm.leftHistoryData[item.Id]" value="true" ng-disabled="vm.isViewOnly"\n' +
    '                  ng-true-value="\'Y\'" ng-false-value="">\n' +
    '              </label>\n' +
    '              <label class="yesno-label pull-left">Yes</label>\n' +
    '              <label class="checkbox pull-left"\n' +
    '                     ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                <input id="{{item.Id+\'NO\'}}" type="checkbox" ng-model="vm.leftHistoryData[item.Id]" value="false" ng-disabled="vm.isViewOnly"\n' +
    '                  ng-true-value="\'N\'" ng-false-value="">\n' +
    '              </label>\n' +
    '              <label class="yesno-label pull-left">No</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col" ng-if="item.Type == \'DATE\'">\n' +
    '            <div class="item sub-list-item-editable">\n' +
    '              <input id="{{item.Id}}" class="demographic-date-input" ng-disabled="vm.isViewOnly" ng-model="vm.leftHistoryData[item.Id]"\n' +
    '                date-input="vm.leftHistoryData[item.Id]" />\n' +
    '              <button class="icon border-less ion-calendar"\n' +
    '                      ng-class="{\'ion-calendar-disabled\':vm.isViewOnly}" \n' +
    '                      ng-disabled="vm.isViewOnly" \n' +
    '                      type="button" \n' +
    '                      ng-click="vm.changeDate(vm.leftHistoryData, item.Id)"></button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col" ng-if="item.Type == \'AGE\' || item.Type == \'NUM\' || item.Type == \'POP\'">\n' +
    '            <div>\n' +
    '              <dropdown-menu \n' +
    '                ng-if="!vm.isViewOnly && !vm.shouldDisableControls() && vm.leftHistoryData"\n' +
    '                class="modal-dropdown" \n' +
    '                placeholder="Select {{ item.Caption }}" \n' +
    '                list="item.OPTIONS" \n' +
    '                property="Desc" \n' +
    '                display-property="Value"\n' +
    '                show-caret="true" \n' +
    '                select-mode="true"\n' +
    '                key="Code" \n' +
    '                selected="vm.leftHistoryData[item.Id]"\n' +
    '                is-multi-select="item.Property === \'MULTIPLE\'">\n' +
    '              </dropdown-menu>\n' +
    '              <input id="{{item.Id}}" class="checkbox-label mt-0" ng-disabled="vm.isViewOnly" ng-if="vm.isViewOnly" type="text" ng-value="vm.getElementDescByCode(item.OPTIONS, vm.leftHistoryData[item.Id], item.Property === \'MULTIPLE\').Desc" />\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="col col-100" ng-if="item.Type == \'BRCA\' && item.Id === \'PERSONAL_BRCA\'">\n' +
    '            <div class="row">\n' +
    '              <div class="col col-50 label brca-personal-label"\n' +
    '                ng-class="{\'border-bottom-danger-child\': (vm.showValidationErrors && vm.notValidLeftHistory[item.Id]) || vm.notValidPersonalBRCAHistory}">\n' +
    '                <label class="itemName"><b>{{vm.techpadConfig.settings.PatientHistoryDynamicLabels.PersonalBrcaCaption}}</b></label>\n' +
    '                <label class="itemName">{{vm.techpadConfig.settings.PatientHistoryDynamicLabels.PersonalBrcaFirstGeneLabel}}</label>\n' +
    '                <label class="itemName">{{vm.techpadConfig.settings.PatientHistoryDynamicLabels.PersonalBrcaSecondGeneLabel}}</label>\n' +
    '              </div>\n' +
    '              <div class="col col-50 ">\n' +
    '                <div class="row text-center brca-personal-result-label pr-0">\n' +
    '                  <div class="col-45">\n' +
    '                    <div class="row bottom pl-0 pr-0">{{vm.techpadConfig.settings.PatientHistoryDynamicLabels.PersonalBrcaResultNotKnown}}</div>\n' +
    '                  </div>\n' +
    '                  <div class="col-55">\n' +
    '                    <div class="row bottom pl-0 pr-0">\n' +
    '                      <div class="col-33">{{vm.techpadConfig.settings.PatientHistoryDynamicLabels.PersonalBrcaPositive}}</div>\n' +
    '                      <div class="col-33">{{vm.techpadConfig.settings.PatientHistoryDynamicLabels.PersonalBrcaNegative}}</div>\n' +
    '                      <div class="col-33">{{vm.techpadConfig.settings.PatientHistoryDynamicLabels.PersonalBrcaVus}}</div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="row text-center checkbox-p-r-0">\n' +
    '                  <div class="col-45 m-t-8">\n' +
    '                    <label class="checkbox "\n' +
    '                           ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                      <input id="{{item.Id}}" type="checkbox" data-id="BRCA1No" ng-disabled="vm.isViewOnly" ng-model="vm.personalBRCA1Value"\n' +
    '                            ng-true-value="\'0\'" ng-false-value="\'\'" ng-click="vm.personalBRCA1Change(\'0\')" />\n' +
    '                    </label>\n' +
    '                  </div>\n' +
    '                  <div class="col-55">\n' +
    '                    <div class="row pl-0 pr-0 p-t-0 p-b-0">\n' +
    '                      <div class="col-33 m-t-8">\n' +
    '                        <label class="checkbox"\n' +
    '                               ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                          <input id="{{item.Id}}" type="checkbox" ng-disabled="vm.isViewOnly" ng-model="vm.personalBRCA1Value"\n' +
    '                                 ng-true-value="\'1\'" ng-false-value="\'\'" ng-click="vm.personalBRCA1Change(\'1\')" />\n' +
    '                        </label>\n' +
    '                      </div>\n' +
    '                      <div class="col-33 m-t-8">\n' +
    '                        <label class="checkbox"\n' +
    '                               ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                        <input id="{{item.Id}}" type="checkbox" ng-disabled="vm.isViewOnly" ng-model="vm.personalBRCA1Value"\n' +
    '                               ng-true-value="\'2\'" ng-false-value="\'\'" ng-click="vm.personalBRCA1Change(\'2\')" />\n' +
    '                        </label>\n' +
    '                      </div>\n' +
    '                      <div class="col-33 m-t-8">\n' +
    '                        <label class="checkbox"\n' +
    '                               ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                        <input id="{{item.Id}}" type="checkbox" ng-disabled="vm.isViewOnly" ng-model="vm.personalBRCA1Value"\n' +
    '                               ng-true-value="\'3\'" ng-false-value="\'\'" ng-click="vm.personalBRCA1Change(\'3\')" />\n' +
    '                        </label>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="row text-center m-t-15 checkbox-p-r-0 ">\n' +
    '                  <div class="col-45">\n' +
    '                    <label class="checkbox "\n' +
    '                           ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                      <input id="{{item.Id}}" type="checkbox" data-id="BRCA2No" ng-disabled="vm.isViewOnly" ng-model="vm.personalBRCA2Value"\n' +
    '                             ng-true-value="\'0\'" ng-false-value="\'\'" ng-click="vm.personalBRCA2Change(\'0\')" />\n' +
    '                    </label>\n' +
    '                  </div>\n' +
    '                  <div class="col-55">\n' +
    '                    <div class="row pl-0 pr-0 p-t-0 p-b-0">\n' +
    '                      <div class="col-33">\n' +
    '                        <label class="checkbox "\n' +
    '                               ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                          <input  id="{{item.Id}}" type="checkbox" ng-disabled="vm.isViewOnly" ng-model="vm.personalBRCA2Value"\n' +
    '                                 ng-true-value="\'1\'" ng-false-value="\'\'" ng-click="vm.personalBRCA2Change(\'1\')" />\n' +
    '                        </label>\n' +
    '                      </div>\n' +
    '                      <div class="col-33">\n' +
    '                        <label class="checkbox "\n' +
    '                               ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                          <input id="{{item.Id}}" type="checkbox" ng-disabled="vm.isViewOnly" ng-model="vm.personalBRCA2Value"\n' +
    '                                 ng-true-value="\'2\'" ng-false-value="\'\'" ng-click="vm.personalBRCA2Change(\'2\')" />\n' +
    '                        </label>\n' +
    '                      </div>\n' +
    '                      <div class="col-33">\n' +
    '                        <label class="checkbox "\n' +
    '                               ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                          <input id="{{item.Id}}" type="checkbox" ng-disabled="vm.isViewOnly" ng-model="vm.personalBRCA2Value"\n' +
    '                                 ng-true-value="\'3\'" ng-false-value="\'\'" ng-click="vm.personalBRCA2Change(\'3\')" />\n' +
    '                        </label>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col" ng-if="item.Type == \'IMPLANTS\'">\n' +
    '            <div class="item sub-list-item-editable implants-result">\n' +
    '              <button class="icon border-less ion-edit"\n' +
    '                      ng-class="{\'ion-edit-disabled\':vm.isViewOnly}"\n' +
    '                      type="button"\n' +
    '                      ng-disabled="vm.isViewOnly"\n' +
    '                      ng-click="vm.openImplantsRecord()"></button>\n' +
    '              {{vm.implantString}}\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col col-50" ng-if="item.Type == \'HEIGHT\'">\n' +
    '            <div class="item">\n' +
    '              <input class="feet-and-inches-input" ng-disabled="vm.isViewOnly" id="{{item.Id}}.heightFeet" type="text"\n' +
    '                ng-model="vm.leftHistoryData[item.Id].heightFeet" numbers-only max-length="1" only-int="true" />\n' +
    '              <span class="feet-and-inches-separator">\'</span>\n' +
    '              <input class="feet-and-inches-input" ng-disabled="vm.isViewOnly" id="{{item.Id}}.heightInches" type="text"\n' +
    '                ng-model="vm.leftHistoryData[item.Id].heightInches" numbers-only max-length="2" only-int="true" />\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col col-50" ng-if="item.Type == \'WEIGHT\'">\n' +
    '            <div class="item">\n' +
    '              <input ng-disabled="vm.isViewOnly" id="{{item.Id}}" type="text" ng-model="vm.leftHistoryData[item.Id]"\n' +
    '                numbers-only max-length="3" only-int="true" />\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col col-50" ng-if="item.Type == \'BRASIZE\'">\n' +
    '            <div class="item">\n' +
    '              <input ng-disabled="vm.isViewOnly" id="{{item.Id}}" type="text" ng-model="vm.leftHistoryData[item.Id]"\n' +
    '                numbers-only max-length="2" only-int="true" />\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col col-50" ng-if="item.Type == \'TEXT\'">\n' +
    '            <div class="item">\n' +
    '              <textarea ng-disabled="vm.isViewOnly" id="{{item.Id}}" ng-model="vm.leftHistoryData[item.Id]" />\n' +
    '              </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </form>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/documentCreateDialog.html',
    '<div class="modal modal-form create-document-form">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title title-left">\n' +
    '      Add Document\n' +
    '    </h3>\n' +
    '    <div class="buttons right-buttons">\n' +
    '      <button class="button button-icon ion-close" ng-click="model.close(true)"></button> <!--model.close(showConfirmationModal = true)-->\n' +
    '    </div>\n' +
    '\n' +
    '  </header>\n' +
    '  <content has-header="true">\n' +
    '    <label class="item" ng-if="model.loading"><b>Loading...</b></label>\n' +
    '    <!-- <br> -->\n' +
    '    <div ng-show="!model.formName" class="forms-list">\n' +
    '      <h4>Choose template:</h4>\n' +
    '      <button ng-show="model.documentLoadedError" class="button button-dark" ng-click="model.reloadDocumentTemplates()">Reload document templates</button>\n' +
    '      <ion-list>\n' +
    '        <ion-item ng-repeat="form in model.templates" ng-click="model.initEditor(form.Name, form.PdfFormId)">\n' +
    '          {{form.Name}}<span ng-if="form.DocType"> ({{form.DocType}})</span>\n' +
    '        </ion-item>\n' +
    '      </ion-list>\n' +
    '    </div>\n' +
    '    <div class="editor-wrapper" ng-if="model.formSettings && model.formName">\n' +
    '      <div class="create-document-toolbar">\n' +
    '        <button ng-show="model.formName" ng-click="model.saveForm()" class="button button-dark">Save Document</button>\n' +
    '      </div>\n' +
    '\n' +
    '      <pdf-form-editor [server-url]="model.pdfFormServerUrl"\n' +
    '                       (valid-change)="model.validChange($event)"\n' +
    '                       (document-pages-error)="model.documentPagesError($event)"\n' +
    '                       (document-pages-loaded)="model.documentPagesLoaded($event)"\n' +
    '                       (on-error)="model.onError($event)"\n' +
    '                       [elements]="model.formSettings"\n' +
    '                       [patient-info]="model.patientInfo"\n' +
    '                       [pdf-template]="model.formName"\n' +
    '                       [pdf-form-id]="model.pdfFormId"\n' +
    '                       [show-validation-results]="model.showValidationResults"\n' +
    '                       class="pdf-signature-editor"></pdf-form-editor>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/documentsTabScrollTemplate.html',
    '<ion-list class="list documents-item">\n' +
    '    <ion-item class="item text-center" ng-if="!vm.documentsLoaded || !vm.documents || vm.isRefreshingDocuments">\n' +
    '      <b>Loading...</b>\n' +
    '    </ion-item>\n' +
    '\n' +
    '    <ion-item class="item text-center" ng-if="vm.documentsLoaded && !vm.documents.length && !vm.isRefreshingDocuments">\n' +
    '      <b>\n' +
    '        {{ vm.noDocumentsMessage }}\n' +
    '      </b>\n' +
    '    </ion-item>\n' +
    '\n' +
    '    <ion-item class="item item-icon-right repeat-animation relative"\n' +
    '              ng-repeat="document in vm.documents track by document.Id"\n' +
    '              ng-class="{\'disabled-document\':!document.Id || !isOnline(), \'{{ vm.getHighlightDocumentClassName() }}\': vm.shouldHighlight(document.Id) }"\n' +
    '              ng-click="vm.showDocument(document)">\n' +
    '              <!-- is-swiped="document.isSwiped"> -->\n' +
    '      <div class="row">\n' +
    '        <div class="col col-15 study-date-column">{{document.Date | date:\'MM/dd/yyyy\'}}</div>\n' +
    '        <div class="col col-20 ellipsis-documents-type-overflow">{{document.IsReferringPhysician ? \'RP Letter\' : document.Type}}</div>\n' +
    '        <div class="col col-65 ellipsis-documents-list-overflow">\n' +
    '          {{document.Description}}\n' +
    '        </div>\n' +
    '        <button class="icon ion-ios-circle-outline open-icon button button-clear no-activated-state"\n' +
    '                ng-click="$event.stopPropagation(); $event.preventDefault();">\n' +
    '          <i class="icon"\n' +
    '             ng-class="{ \'ion-ios-arrow-right\' : document.isSwiped, \'ion-ios-arrow-left\': !document.isSwiped }"></i>\n' +
    '        </button>\n' +
    '      </div>\n' +
    '      <ion-option-button class="button-position button-assertive" \n' +
    '                         ng-disabled="!isOnline()"\n' +
    '                         ng-if="vm.techpadConfig.settings.IsContactDocumentsDeletionAbilityEnabled && \n' +
    '                                document.DocumentSource === vm.commonConstants.CONTACT_DOCUMENT_SOURCE">\n' +
    '        <ripple class="documents-button" ng-click="$event.preventDefault(); $event.stopPropagation(); vm.deleteContact(document)">Remove</ripple>\n' +
    '      </ion-option-button>\n' +
    '      <ion-option-button class="button-position button-assertive" \n' +
    '                         ng-disabled="!isOnline()"\n' +
    '                         ng-if="vm.techpadConfig.settings.EnableDeleteDocuments && \n' +
    '                                document.DocumentSource.trim() === vm.commonConstants.PORTAL_DOCUMENT_SOURCE">\n' +
    '        <ripple class="documents-button" ng-click="$event.preventDefault(); $event.stopPropagation(); vm.deleteDocument(document)">Remove</ripple>\n' +
    '      </ion-option-button>\n' +
    '      <ion-option-button class="button-position button-dark" \n' +
    '                         ng-disabled="!isOnline()">\n' +
    '        <ripple class="documents-button" ng-click="vm.iosPrint(document, true)">Print</ripple>\n' +
    '      </ion-option-button>\n' +
    '    </ion-item>\n' +
    '  </ion-list>\n' +
    '\n' +
    '  <div class="load-more-documents-button-container" ng-if="!vm.stopInfiniteLoad">\n' +
    '    <div class="load-more-document-button"\n' +
    '         ng-if="!vm.stopInfiniteLoad"\n' +
    '         ng-click="vm.loadMoreDocuments()">\n' +
    '      Load More\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="container-with-padding">&nbsp;</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/documentWindow.html',
    '<div class="modal document-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h1 class="title title-left">\n' +
    '      <div class="name-wrapper">\n' +
    '        <div ng-if="model.patient.FirstName || model.patient.LastName" \n' +
    '             data-fittext data-fittext-min="18"\n' +
    '          data-fittext-max="40">\n' +
    '          {{ model.patient.FirstName }} {{ model.patient.LastName }}\n' +
    '          <small>&nbsp; {{ model.patient.DateOfBirth | date: \'MMM d, y\' }}</small>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </h1>\n' +
    '    <div class="buttons right-buttons">\n' +
    '      <button ng-click="model.iosPrint()" \n' +
    '              ng-if="isIOS || model.techpadSettings.ServerPrinterEnabled"\n' +
    '              class="button button-icon ion-printer"></button>\n' +
    '      <button class="button button-icon ion-close" \n' +
    '              ng-click="modal.remove()"></button>\n' +
    '    </div>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="content">\n' +
    '    <iframe-wrapper ng-if="!isIOS && !model.asImage "  \n' +
    '                    file-type="model.fileType" \n' +
    '                    uri="model.url" \n' +
    '                    on-error="modal.remove();model.error();" \n' +
    '                    on-load="model.loaded()"></iframe-wrapper>\n' +
    '\n' +
    '    <ion-scroll zooming="true" \n' +
    '                direction="xy" \n' +
    '                class="document-preview-content" \n' +
    '                max-zoom="3" min-zoom="1"\n' +
    '                overflow-scroll="false" \n' +
    '                ng-if="model.url && isIOS || model.asImage">\n' +
    '\n' +
    '      <txt-wrapper ng-if="model.fileType === \'txt\'" \n' +
    '              uri="model.url" \n' +
    '              on-error="modal.remove();model.error();" \n' +
    '              on-load="model.loaded()"></txt-wrapper>\n' +
    '      <img ng-if="model.fileType !== \'txt\'"\n' +
    '           ng-src="{{model.url}}" \n' +
    '           class="center-image" \n' +
    '           on-load="model.loaded()" \n' +
    '           on-image-error="modal.remove()" />\n' +
    '    </ion-scroll>\n' +
    '  </content>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/dropdown.bk.html',
    '<div class="dropdown-container" ng-class="{ show: listVisible }" on-tap="toggle($event)">\n' +
    '    <div class="dropdown-display ripple"  ng-class="{ clicked: listVisible, closed: !listVisible }">\n' +
    '        <span class="pull-left" ng-if="!isPlaceholder">{{display}}</span>\n' +
    '        <span class="placeholder pull-left" ng-if="isPlaceholder">{{placeholder}}</span>\n' +
    '        <div class="icon circle-icon" ng-if="!showCaret" ng-class="{\'ion-ios-arrow-down\':listVisible, \'{{icon}}\':!listVisible}"></div>\n' +
    '        <div class="icon caret" ng-if="showCaret"></div>\n' +
    '    </div>\n' +
    '    <div class="dropdown-list dropdown-list-height-{{ dropdownHeight }}">\n' +
    '        <div>\n' +
    '            <div class="dropdown-list-element" ng-repeat="item in list"\n' +
    '                 ng-class="{ selected: isSelected(item), separator: item.separator }">\n' +
    '                <div on-tap="select(item)" class="dropdown-list-element-content">\n' +
    '                    <span >{{property !== undefined ? item[property] : item}}</span>\n' +
    '                    <!--<hr ng-if="item.separator" />-->\n' +
    '                    <i ng-if="isSelected(item) && !item.separator" class="ion-checkmark"></i>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/dropdown.html',
    '<div ng-if="!!key && !isMultiSelect">\n' +
    '  <ui-select class="dropdown-menu-ui-select {{dropdownClass}}"\n' +
    '            ng-model="model.selected"\n' +
    '            theme="select2"\n' +
    '            search-enabled="false"\n' +
    '            append-to-body="true"\n' +
    '            ng-class="{\'is-hide-selected\': selectMode !== true, \'is-showing-clear-button\': hideCleanButton !== true}"\n' +
    '            on-select="onSelectedChange($item, $model)">\n' +
    '    <ui-select-match placeholder="{{ placeholder }}"\n' +
    '                    allow-clear="!hideCleanButton">\n' +
    '      {{ !hideSelectedValue ? $select.selected[property] : \'\' }}\n' +
    '      <div ng-if="!hideCleanButton && !!placeholder && selected != null && selected !== emptyValue && !disabled"\n' +
    '          class="btn-reset-select icon circle-icon ion-ios-close-empty"\n' +
    '          ng-click="resetSelectedClick($event, $select);">\n' +
    '      </div>\n' +
    '    </ui-select-match>\n' +
    '    <ui-select-choices repeat="option[key] as option in list"\n' +
    '                      ui-disable-choice="isSeparator(option)">\n' +
    '      <div ng-bind-html="option[property]"></div>\n' +
    '    </ui-select-choices>\n' +
    '    <ui-select-no-choice>No Options</ui-select-no-choice>\n' +
    '  </ui-select>\n' +
    '</div>\n' +
    '<div ng-if="!key && !isMultiSelect">\n' +
    '  <ui-select class="dropdown-menu-ui-select {{dropdownClass}}"\n' +
    '            ng-model="model.selected"\n' +
    '            theme="select2"\n' +
    '            search-enabled="false"\n' +
    '            append-to-body="true"\n' +
    '            ng-class="{\'is-hide-selected\': selectMode !== true, \'is-showing-clear-button\': hideCleanButton !== true}"\n' +
    '            on-select="onSelectedChange($item, $model)">\n' +
    '    <ui-select-match placeholder="{{ placeholder }}"\n' +
    '                    allow-clear="!hideCleanButton">\n' +
    '      {{ !hideSelectedValue ? $select.selected : \'\' }}\n' +
    '      <div ng-if="!hideCleanButton && !!placeholder && selected != null && selected !== emptyValue && !disabled"\n' +
    '          class="btn-reset-select icon circle-icon ion-ios-close-empty"\n' +
    '          ng-click="resetSelectedClick($event, $select);">\n' +
    '      </div>\n' +
    '    </ui-select-match>\n' +
    '    <ui-select-choices repeat="option in list"\n' +
    '                      ui-disable-choice="isSeparator(option)">\n' +
    '      <div ng-bind-html="option"></div>\n' +
    '    </ui-select-choices>\n' +
    '    <ui-select-no-choice>No Options</ui-select-no-choice>\n' +
    '  </ui-select>\n' +
    '</div>\n' +
    '\n' +
    '<div ng-if="!!isMultiSelect"\n' +
    '     ng-dropdown-multiselect=""\n' +
    '     extra-settings="multiselectSettings"\n' +
    '     options="list"\n' +
    '     selected-model="selectedItems"\n' +
    '     ng-disabled="disabled"\n' +
    '     ng-class="{\'disabled\': disabled}"\n' +
    '     events="multiSelectEvents"\n' +
    '     translation-texts="dropdownMultiSelectText"\n' +
    '     class="multiselect calc-{{width || \'30\'}} {{selectedItems && selectedItems.length ? \'\' : \'placeholder\'}}">\n' +
    '</div>\n' +
    '<div ng-if="!!isMultiSelect && !hideCleanButton && !!placeholder && selected != null && model.selected !== emptyValue && !disabled"\n' +
    '     class="btn-reset-select icon circle-icon ion-ios-close-empty multiselect-clear"\n' +
    '     ng-click="resetSelectedClick($select);">\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/dropDownOld.html',
    '<div class="dropdown-container" ng-class="{ show: listVisible }" on-tap="toggle($event)">\n' +
    '  <div class="dropdown-display ripple" ng-class="{ clicked: listVisible, closed: !listVisible }">\n' +
    '    <span ng-if="!isPlaceholder">{{display}}</span>\n' +
    '    <span class="placeholder" ng-class="{\'bold-placeholder\':boldPlaceholder}" ng-if="isPlaceholder">{{placeholder}}</span>\n' +
    '    <div class="icon circle-icon" ng-if="!showCaret"\n' +
    '         ng-class="{\'ion-ios-arrow-down\':listVisible, \'{{icon}}\':!listVisible}"></div>\n' +
    '    <div class="icon caret" ng-if="showCaret"></div>\n' +
    '  </div>\n' +
    '  <div class="dropdown-list dropdown-list-height-{{ dropdownHeight }}">\n' +
    '    <div class="scroll" ng-class="{\'showToTheTop\':showToTheTop && listVisible}">\n' +
    '      <div class="dropdown-list-element" ng-repeat="item in list"\n' +
    '           ng-class="{ selected: isSelected(item), separator: item.separator }">\n' +
    '        <div on-tap="select(item)" class="dropdown-list-element-content">\n' +
    '          <span ng-if="!item.separator">{{property !== undefined ? item[property] : item}}</span>\n' +
    '          <i ng-if="isSelected(item) && !item.separator" class="ion-checkmark"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/errorMessage.html',
    '<div class="modal error-message-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h1 class="title">Techpad</h1>\n' +
    '    <div class="button button-clear" ng-click="modal.remove()"><span class="icon ion-close"></span></div>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="padding">\n' +
    '    <div class="row">\n' +
    '      <div class="col text-center">\n' +
    '        <h4>A system error has occured.</h4>\n' +
    '        <p>{{$root.techpadSettings.TechpadErrorMessage || "Please note the following information and call the MagView Support Department at (800) 553-8998."}}</p>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="col">\n' +
    '        <p><b>Type:</b> {{type}}</p>\n' +
    '        <p><b>Error:</b> {{error.errorId}} <span ng-if="error.errorId">-</span> {{error.message}}</p>\n' +
    '        <p><b>Stamp:</b> {{stamp | date:\'MM/dd/yyyy\'}}</p>\n' +
    '        <p><b>Version:</b> {{version}}</p>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    {{details}}\n' +
    '\n' +
    '  </content>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/examTabTemplate.html',
    '<form name="examForm">\n' +
    '	<div class="row">\n' +
    '		<div class="col-33">\n' +
    '			<div class="item tab-header details-list-header item-transparent item-dropdown-header"\n' +
    '				ng-if="!vm.isViewOnly && !vm.shouldDisableControls()">\n' +
    '				<div class="dropdown-display">\n' +
    '					<span class="placeholder text-bold">\n' +
    '						Reason For Visit\n' +
    '					</span>\n' +
    '					<div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '					<dropdown-menu 						\n' +
    '						ng-class="{\'border-bottom-danger\': vm.showValidationErrors && vm.invalidReasonForVisit}"\n' +
    '						list="vm.visitReasons" \n' +
    '						property="Value" \n' +
    '						key="Key"\n' +
    '						hide-clean-button="true"\n' +
    '						hide-selected-value="true"\n' +
    '						on-selection-change="vm.changeReasonForVisit($type)">\n' +
    '					</dropdown-menu>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			<div ng-if="vm.isViewOnly || vm.shouldDisableControls()">\n' +
    '				<label class="item tab-header">\n' +
    '					<b class="pull-left dropdown-header" ng-if="vm.isViewOnly || vm.shouldDisableControls()">Reason For\n' +
    '						Visit</b>\n' +
    '					<hr class="full-width" />\n' +
    '				</label>\n' +
    '			</div>\n' +
    '			<div class="item item-text-wrap item-transparent dropdown-result">\n' +
    '				{{vm.getLabel(vm.patient.Study.VisitReason, vm.visitReasons)}}\n' +
    '			</div>\n' +
    '\n' +
    '			<div class="item tab-header details-list-header item-transparent item-dropdown-header"\n' +
    '				ng-show="vm.patient.Study.VisitReason != \'S\' || (vm.patient.AllowSProb && vm.patient.Study.VisitReason == \'S\')">\n' +
    '				<div class="dropdown-display"\n' +
    '						 ng-class="{\'border-bottom-danger\': vm.showValidationErrors && !vm.isProblemsValid,\n' +
    '							 				  \'view-only\': vm.isViewOnly}">\n' +
    '					<b>Problems</b>\n' +
    '					<div ng-click="vm.selectProblems()" tappable\n' +
    '						ng-if="vm.isOnline() && !vm.isViewOnly && !vm.shouldDisableControls()"\n' +
    '						class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '					</button>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			<div class="item item-text-wrap item-transparent dropdown-result"\n' +
    '				ng-show="vm.patient.Study.VisitReason != \'S\' || (vm.patient.AllowSProb && vm.patient.Study.VisitReason == \'S\')">\n' +
    '				{{vm.selectedProblems.join(\', \')}}\n' +
    '			</div>\n' +
    '\n' +
    '			<div class="item tab-header details-list-header item-transparent item-dropdown-header"\n' +
    '				ng-if="!vm.isViewOnly && !vm.shouldDisableControls()">\n' +
    '				<div class="dropdown-display">\n' +
    '					<span class="placeholder text-bold">\n' +
    '						Infection Control\n' +
    '					</span>\n' +
    '					<div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '					<dropdown-menu\n' +
    '						ng-class="{\'border-bottom-danger\': vm.techpadConfig.settings.ReqICP && vm.showValidationErrors && !vm.patient.Study.IsInfectionControlProcedureDone}"\n' +
    '						list="vm.trueFalseValues" \n' +
    '						property="Value" \n' +
    '						key="Key"\n' +
    '						hide-selected-value="true"\n' +
    '						on-selection-change="vm.changeInfectionControl($type)">\n' +
    '					</dropdown-menu>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			<div ng-if="vm.isViewOnly || vm.shouldDisableControls()">\n' +
    '				<label class="item tab-header">\n' +
    '					<b class="pull-left dropdown-header" ng-if="vm.isViewOnly || vm.shouldDisableControls()">Infection\n' +
    '						Control</b>\n' +
    '					<hr class="full-width" />\n' +
    '				</label>\n' +
    '			</div>\n' +
    '			<div class="item item-text-wrap item-transparent dropdown-result">\n' +
    '				{{vm.getLabel(vm.patient.Study.IsInfectionControlProcedureDone, vm.trueFalseValues)}}\n' +
    '			</div>\n' +
    '\n' +
    '			<div class="item tab-header details-list-header item-transparent item-dropdown-header"\n' +
    '				ng-if="vm.techpadConfig.settings.ShowSCad && !vm.isViewOnly && !vm.shouldDisableControls()">\n' +
    '				<div class="dropdown-display">\n' +
    '					<span class="placeholder text-bold">\n' +
    '						CAD\n' +
    '					</span>\n' +
    '					<div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '					<dropdown-menu\n' +
    '						ng-class="{\'border-bottom-danger\': vm.showValidationErrors && !vm.patient.Study.CadState}"\n' +
    '						list="vm.trueFalseValues" \n' +
    '						property="Value" \n' +
    '						key="Key"\n' +
    '						hide-selected-value="true"\n' +
    '						on-selection-change="vm.changeCadControl($type)">\n' +
    '					</dropdown-menu>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			<div ng-if="vm.techpadConfig.settings.ShowSCad && (vm.isViewOnly || vm.shouldDisableControls())">\n' +
    '				<label class="item tab-header">\n' +
    '					<b class="pull-left dropdown-header" ng-if="vm.isViewOnly || vm.shouldDisableControls()">CAD</b>\n' +
    '					<hr class="full-width" />\n' +
    '				</label>\n' +
    '			</div>\n' +
    '			<div ng-if="vm.techpadConfig.settings.ShowSCad" class="item item-text-wrap item-transparent dropdown-result">\n' +
    '				{{vm.getLabel(vm.patient.Study.CadState, vm.trueFalseValues)}}\n' +
    '			</div>\n' +
    '\n' +
    '      <div class="item tab-header details-list-header item-transparent item-dropdown-header"\n' +
    '           ng-if="!vm.isViewOnly && !vm.shouldDisableControls() && vm.canShowUltrasoundOptions() && vm.techpadConfig.settings.USScanTech">\n' +
    '        <div class="dropdown-display">\n' +
    '          <span class="placeholder text-bold">\n' +
    '            Ultrasound Technique\n' +
    '          </span>\n' +
    '          <div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '          <dropdown-menu class="multi-select hide-selection"\n' +
    '                         is-multi-select="true"\n' +
    '                         list="vm.ultrasoundTechniques"\n' +
    '                         property="Value"\n' +
    '                         key="Key"\n' +
    '                         width="100"\n' +
    '                         icon="ion-ios-arrow-right"\n' +
    '                         selected="vm.patient.Study.UTechnique"\n' +
    '                         on-item-deselected="vm.deselectedUltrasoundTechnique($type)"\n' +
    '                         on-item-selected="vm.selectedUltrasoundTechnique($type)"></dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '			<div\n' +
    '				ng-if="(vm.isViewOnly || vm.shouldDisableControls()) && vm.canShowUltrasoundOptions() && vm.techpadConfig.settings.USScanTech">\n' +
    '				<label class="item tab-header">\n' +
    '					<b class="pull-left dropdown-header" ng-if="vm.isViewOnly || vm.shouldDisableControls()">Ultrasound\n' +
    '						Technique</b>\n' +
    '					<hr class="full-width" />\n' +
    '				</label>\n' +
    '			</div>\n' +
    '			<div class="item item-text-wrap item-transparent dropdown-result" ng-if="vm.techpadConfig.settings.USScanTech">\n' +
    '				<div class="m-t-8" ng-repeat="technique in vm.studyUTechniques">\n' +
    '					<div class="col-12">{{vm.getLabel(technique, vm.ultrasoundTechniques)}}</div>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '\n' +
    '			<div class="item tab-header details-list-header item-transparent item-dropdown-header"\n' +
    '				ng-show="vm.canShowUltrasoundOptions()">\n' +
    '				<div class="dropdown-display"\n' +
    '						 ng-class="{\'view-only\': vm.isViewOnly}">\n' +
    '					<b>Scan Technique</b>\n' +
    '					<div ng-click="vm.selectUltraSoundTechniqnue()" tappable\n' +
    '						ng-if="vm.isOnline() && !vm.isViewOnly && !vm.shouldDisableControls()"\n' +
    '						class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '					</button>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			<div class="item item-text-wrap item-transparent dropdown-result" ng-show="vm.canShowUltrasoundOptions()">\n' +
    '				{{vm.getUltrasoundTechniqueLabel()}}\n' +
    '			</div>\n' +
    '\n' +
    '			<div class="item tab-header details-list-header item-transparent item-dropdown-header linked-studies-container"\n' +
    '				ng-show="vm.canLinkStudies()">\n' +
    '				<div class="emulated-dropdown-header">\n' +
    '					<b>Link Studies</b>\n' +
    '					<div ng-click="vm.linkStudies()" tappable ng-if="!vm.isViewOnly && !vm.shouldDisableControls()"\n' +
    '						class="icon circle-icon ion-ios-arrow-right">\n' +
    '					</div>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			\n' +
    '			<div ng-if="!vm.isViewOnly && !vm.shouldDisableControls()"\n' +
    '					 class="item tab-header details-list-header item-transparent item-dropdown-header">\n' +
    '				<div class="dropdown-display">\n' +
    '					<span class="placeholder text-bold">\n' +
    '						Technologist\n' +
    '					</span>\n' +
    '					<div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '					<dropdown-menu 					\n' +
    '						list="vm.patient.Technologists" \n' +
    '						property="Value" \n' +
    '						key="Key"\n' +
    '						hide-selected-value="true"\n' +
    '						on-selection-change="vm.updateFirstTechnologist($type)" ></dropdown-menu>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			<div ng-if="!vm.isViewOnly && !vm.shouldDisableControls()"\n' +
    '					 class="item item-text-wrap item-transparent dropdown-result relative pr-60">\n' +
    '				{{vm.getTechnologist(vm.patient.Study.Technologist, vm.patient.Technologists)}}\n' +
    '				<button ng-if="!vm.isViewOnly && !vm.shouldDisableControls() && vm.patient.Study.Technologist"\n' +
    '								class="button button-delete button-clear icon ion-ios-close-empty delete-second-technologist-btn ripple-effect dark"\n' +
    '								ng-click="vm.removeFirstTechnologist()"></button>\n' +
    '			</div>\n' +
    '			<div ng-if="vm.isViewOnly || vm.shouldDisableControls()">\n' +
    '				<div class="item tab-header details-list-header item-transparent item-dropdown-header">\n' +
    '					<div class="dropdown-display view-only">\n' +
    '						<span class="placeholder text-bold">\n' +
    '							Technologist\n' +
    '						</span>\n' +
    '					</div>\n' +
    '				</div>\n' +
    '				<div class="item item-text-wrap item-transparent dropdown-result">\n' +
    '					{{vm.getLabel(vm.patient.Study.Technologist, vm.tecknologists)}}\n' +
    '				</div>\n' +
    '			</div>\n' +
    '\n' +
    '			<div ng-if="!vm.isViewOnly && !vm.shouldDisableControls() && vm.techpadConfig.settings.ShowSelectSecondTechnologist"\n' +
    '					 class="item tab-header details-list-header item-transparent item-dropdown-header">\n' +
    '				<div class="dropdown-display">\n' +
    '					<span class="placeholder text-bold">\n' +
    '						Second Technologist\n' +
    '					</span>\n' +
    '					<div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '					<dropdown-menu 					\n' +
    '						list="vm.patient.Technologists" \n' +
    '						property="Value" \n' +
    '						key="Key"\n' +
    '						hide-selected-value="true"\n' +
    '						on-selection-change="vm.updateSecondTechnologist($type)" ></dropdown-menu>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			<div ng-if="!vm.isViewOnly && !vm.shouldDisableControls() && vm.techpadConfig.settings.ShowSelectSecondTechnologist"\n' +
    '					 class="item item-text-wrap item-transparent dropdown-result relative pr-60">\n' +
    '				{{vm.getTechnologist(vm.patient.Study.Technologist2, vm.patient.Technologists)}}\n' +
    '				<button ng-if="!vm.isViewOnly && !vm.shouldDisableControls() && vm.patient.Study.Technologist2"\n' +
    '								class="button button-delete button-clear icon ion-ios-close-empty delete-second-technologist-btn ripple-effect dark"\n' +
    '								ng-click="vm.removeSecondTechnologist()"></button>\n' +
    '			</div>\n' +
    '			<div ng-if="(vm.isViewOnly || vm.shouldDisableControls()) && vm.techpadConfig.settings.ShowSelectSecondTechnologist">\n' +
    '				<div class="item tab-header details-list-header item-transparent item-dropdown-header">\n' +
    '					<div class="dropdown-display view-only">\n' +
    '						<span class="placeholder text-bold">\n' +
    '							Second Technologist\n' +
    '						</span>\n' +
    '					</div>\n' +
    '				</div>\n' +
    '				<div class="item item-text-wrap item-transparent dropdown-result">\n' +
    '					{{vm.getLabel(vm.patient.Study.Technologist2, vm.tecknologists)}}\n' +
    '				</div>\n' +
    '			</div>\n' +
    '\n' +
    '			<div ng-if="!vm.isViewOnly && !vm.shouldDisableControls() && vm.techpadConfig.settings.ShowSelectThirdTechnologist"\n' +
    '					 class="item tab-header details-list-header item-transparent item-dropdown-header">\n' +
    '				<div class="dropdown-display">\n' +
    '					<span class="placeholder text-bold">\n' +
    '						Third Technologist\n' +
    '					</span>\n' +
    '					<div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '					<dropdown-menu 					\n' +
    '						list="vm.patient.Technologists" \n' +
    '						property="Value" \n' +
    '						key="Key"\n' +
    '						hide-selected-value="true"\n' +
    '						on-selection-change="vm.updateThirdTechnologist($type)" ></dropdown-menu>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			<div ng-if="!vm.isViewOnly && !vm.shouldDisableControls() && vm.techpadConfig.settings.ShowSelectThirdTechnologist"\n' +
    '					 class="item item-text-wrap item-transparent dropdown-result relative pr-60">				\n' +
    '				{{vm.getTechnologist(vm.patient.Study.Technologist3, vm.patient.Technologists)}}\n' +
    '				<button ng-if="!vm.isViewOnly && !vm.shouldDisableControls() && vm.patient.Study.Technologist3"\n' +
    '								class="button button-delete button-clear icon ion-ios-close-empty delete-second-technologist-btn ripple-effect dark"\n' +
    '								ng-click="vm.removeThirdTechnologist()"></button>\n' +
    '			</div>\n' +
    '			<div ng-if="(vm.isViewOnly || vm.shouldDisableControls()) && vm.techpadConfig.settings.ShowSelectThirdTechnologist">\n' +
    '				<div class="item tab-header details-list-header item-transparent item-dropdown-header">\n' +
    '					<div class="dropdown-display view-only">\n' +
    '						<span class="placeholder text-bold">\n' +
    '							Third Technologist\n' +
    '						</span>\n' +
    '					</div>\n' +
    '				</div>\n' +
    '				<div class="item item-text-wrap item-transparent dropdown-result">\n' +
    '					{{vm.getLabel(vm.patient.Study.Technologist3, vm.tecknologists)}}\n' +
    '				</div>\n' +
    '			</div>\n' +
    '\n' +
    '			<div ng-if="vm.techpadConfig.settings.IsShowStudyRefPhyOnExamDetailsPage" class="ref-phy-list">\n' +
    '				<div class="item tab-header details-list-header item-transparent item-dropdown-header">\n' +
    '					<div class="dropdown-display"\n' +
    '							 ng-class="{\'view-only\': vm.isViewOnly}">\n' +
    '						<span class="placeholder text-bold">\n' +
    '							Referring Physicians\n' +
    '						</span>\n' +
    '						<button type="button" class="button button-default button-small button-icon icon ion-edit study-rp-edit"\n' +
    '							ng-click="vm.editRefPhy();" ng-disabled="vm.isViewOnly"></button>\n' +
    '					</div>\n' +
    '				</div>\n' +
    '				<div class="item item-text-wrap item-transparent dropdown-result">\n' +
    '					<p ng-repeat="index in [0,1,2,3,4,5,6,7,8,9]" ng-if="vm.patient.Study.ReferringPhysicians[index]">\n' +
    '						{{vm.patient.Study.ReferringPhysicians[index].LastName}}\n' +
    '						{{vm.patient.Study.ReferringPhysicians[index].Suffix}}\n' +
    '						{{vm.patient.Study.ReferringPhysicians[index].FirstName}}</p>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '\n' +
    '			<div ng-if="vm.techpadConfig.settings.IsRiskOptOut">\n' +
    '				<div class="item tab-header details-list-header item-transparent item-dropdown-header"\n' +
    '					ng-if="!vm.isViewOnly && !vm.shouldDisableControls()">\n' +
    '					<div class="dropdown-display">\n' +
    '						<span class="placeholder text-bold">\n' +
    '							Opt Out of Risk\n' +
    '						</span>\n' +
    '						<div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '						<dropdown-menu\n' +
    '							ng-class="{\'border-bottom-danger\': vm.techpadConfig.settings.ReqICP && vm.showValidationErrors && !vm.patient.Study.IsOptOutOfRisk}"\n' +
    '							list="vm.optOutValues" \n' +
    '							property="Value" \n' +
    '							key="Key"\n' +
    '							label="Label"\n' +
    '							hide-selected-value="true"\n' +
    '							on-selection-change="vm.changeOptOutOfRiskControl($type)">\n' +
    '						</dropdown-menu>\n' +
    '					</div>\n' +
    '				</div>\n' +
    '				<div ng-if="vm.isViewOnly || vm.shouldDisableControls()">\n' +
    '					<label class="item tab-header">\n' +
    '						<b class="pull-left dropdown-header" ng-if="vm.isViewOnly || vm.shouldDisableControls()">Opt Out of Risk</b>\n' +
    '						<hr class="full-width" />\n' +
    '					</label>\n' +
    '				</div>\n' +
    '				<div class="item item-text-wrap item-transparent dropdown-result">\n' +
    '					{{vm.getRiskOptOutText()}}\n' +
    '				</div>\n' +
    '			</div>\n' +
    '\n' +
    '		</div>\n' +
    '		<div class="col-66">\n' +
    '\n' +
    '			<div ng-if="!vm.isViewOnly \n' +
    '								  && !vm.shouldDisableControls() \n' +
    '									&& vm.canShowViewsObtained() \n' +
    '									&& !vm.techpadConfig.settings.IsHideViewsFromExamTab"\n' +
    '					 class="item tab-header details-list-header item-transparent item-dropdown-header">\n' +
    '				<div class="dropdown-display">\n' +
    '					<span class="placeholder text-bold">\n' +
    '						Views Obtained\n' +
    '					</span>\n' +
    '					<div class="icon circle-icon ion-ios-plus-empty"></div>\n' +
    '					<dropdown-menu ng-if="!vm.isViewOnly && !vm.shouldDisableControls()"\n' +
    '												 ng-class="{\'border-bottom-danger\': vm.showValidationErrors && !vm.isViewsValid}"\n' +
    '												 list="vm.views" \n' +
    '												 property="Value"\n' +
    '												 hide-selected-value="true"\n' +
    '												 key="Key"\n' +
    '												 on-selection-change="vm.addView($type)"></dropdown-menu>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			<div ng-if="(vm.isViewOnly || vm.shouldDisableControls()) \n' +
    '									&& vm.canShowViewsObtained() \n' +
    '									&& !vm.techpadConfig.settings.IsHideViewsFromExamTab">\n' +
    '				<label class="item tab-header">\n' +
    '					<b ng-if="vm.isViewOnly || vm.shouldDisableControls()"\n' +
    '						 class="pull-left dropdown-header" >Views Obtained</b>\n' +
    '					<hr class="full-width" />\n' +
    '				</label>\n' +
    '			</div>\n' +
    '			<div ng-if="vm.canShowViewsObtained() && !vm.techpadConfig.settings.IsHideViewsFromExamTab"\n' +
    '					 class="table-container procedure-margin">\n' +
    '				<div class="row">\n' +
    '					<div class="col-33"><b>Name</b></div>\n' +
    '					<div class="col-33"><b>Side</b></div>\n' +
    '					<div class="col-25"><b>Type</b></div>\n' +
    '				</div>\n' +
    '				<div class="row views-row" \n' +
    '						 ng-repeat="p in vm.patient.Study.Views">\n' +
    '					<div class="col-33 table-label">\n' +
    '						<label simple-popover="{{vm.getLabel(p.Code, vm.views)}}"\n' +
    '									 ng-class="{\'red-colored\':vm.isDuplicate(p)}">\n' +
    '							{{ vm.getLabel(p.Code, vm.views) }}\n' +
    '						</label>\n' +
    '					</div>\n' +
    '					<div class="col-33">\n' +
    '						<dropdown-menu ng-if="!vm.isViewOnly && !vm.shouldDisableControls()" \n' +
    '													 class="modal-dropdown" \n' +
    '													 ng-class="{\'border-bottom-danger\': vm.isDuplicate(p)}"\n' +
    '													 placeholder="Side" \n' +
    '													 list="vm.viewsSidesDictionary[p.Code]" \n' +
    '													 display-property="Value"\n' +
    '													 property="Value" \n' +
    '													 key="Key" \n' +
    '													 selected="p.Side" \n' +
    '													 show-caret="true" \n' +
    '													 dropdown-height="156"\n' +
    '													 empty-value="\'U\'" \n' +
    '													 hide-other-dropdown="true"\n' +
    '													 select-mode="true"\n' +
    '													 on-selected-changed="vm.onViewsSideChange(selected, p)">\n' +
    '						</dropdown-menu>\n' +
    '						<label ng-if="vm.isViewOnly || vm.shouldDisableControls()"\n' +
    '									 class="align-items-center h-100 table-label value-label">\n' +
    '							{{vm.getLabel(p.Side, vm.sidesWithoutUnknown)}}\n' +
    '						</label>\n' +
    '					</div>\n' +
    '					<div class="col-25">\n' +
    '						<dropdown-menu ng-if="!vm.isViewOnly && !vm.shouldDisableControls()"\n' +
    '													 class="modal-dropdown" \n' +
    '													 ng-class="{\'border-bottom-danger\': vm.isDuplicate(p)}"\n' +
    '													 placeholder="Type" \n' +
    '													 list="vm.viewsTypes" \n' +
    '													 display-property="Value"\n' +
    '													 property="Value" \n' +
    '													 key="Key" \n' +
    '													 selected="p.Type" \n' +
    '													 show-caret="true" \n' +
    '													 dropdown-height="156"													 \n' +
    '													 hide-other-dropdown="true"\n' +
    '													 on-selected-changed="vm.onViewsTypeChange(selected, p)"\n' +
    '													 hide-clean-button="true"\n' +
    '													 select-mode="true"\n' +
    '													 empty-value="\'N\'">\n' +
    '						</dropdown-menu>\n' +
    '						<label ng-if="vm.isViewOnly || vm.shouldDisableControls()"\n' +
    '									 class="align-items-center h-100 table-label value-label">\n' +
    '							{{vm.getLabel(p.Type, vm.viewsTypes)}}\n' +
    '						</label>\n' +
    '					</div>\n' +
    '					<div>\n' +
    '						<button ng-if="!vm.isViewOnly && !vm.shouldDisableControls()"\n' +
    '										class="button button-delete button-clear icon ion-ios-close-empty delete-procedure-btn ripple-effect dark"\n' +
    '										ng-click="$event.stopPropagation(); vm.removeView(p)"></button>\n' +
    '					</div>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '\n' +
    '			<div class="item tab-header details-list-header item-transparent item-dropdown-header procedures-header"\n' +
    '				ng-if="!vm.isViewOnly && !vm.shouldDisableControls() && vm.techpadConfig.settings.SaveProcs">\n' +
    '				<div class="dropdown-display">\n' +
    '					<span class="placeholder text-bold">\n' +
    '						Procedures\n' +
    '					</span>\n' +
    '					<div class="icon circle-icon ion-ios-plus-empty"></div>\n' +
    '					<dropdown-menu \n' +
    '						ng-if="!vm.isViewOnly && !vm.shouldDisableControls() && vm.techpadConfig.settings.SaveProcs"\n' +
    '						list="vm.procedures" \n' +
    '						property="Value" \n' +
    '						key="Key"\n' +
    '						hide-selected-value="true"\n' +
    '						on-selection-change="vm.addProcedure($type)"></dropdown-menu>\n' +
    '				</div>\n' +
    '				<br ng-if="vm.isViewOnly" />\n' +
    '			</div>\n' +
    '\n' +
    '			<div ng-if="vm.isViewOnly || vm.shouldDisableControls() || !vm.techpadConfig.settings.SaveProcs">\n' +
    '				<label class="item tab-header">\n' +
    '					<b class="pull-left dropdown-header">Procedures</b>\n' +
    '					<hr class="full-width" />\n' +
    '				</label>\n' +
    '			</div>\n' +
    '			<div class="table-container">\n' +
    '				<div class="row">\n' +
    '					<div class="col-66"><b>Name</b></div>\n' +
    '					<div class="col-25"><b>Side</b></div>\n' +
    '				</div>\n' +
    '				<div class="row views-row" ng-repeat="p in vm.patient.Study.Procedures">\n' +
    '					<div class="col-66" ng-class="{\'table-label\':!vm.isViewOnly}">\n' +
    '						<label simple-popover="{{vm.getLabel(p.Code, vm.procedures)}}">{{vm.getLabel(p.Code,\n' +
    '							vm.procedures)}}</label>\n' +
    '					</div>\n' +
    '					<div class="col-25"\n' +
    '							 ng-if="!vm.isViewOnly && vm.techpadConfig.settings.SaveProcs">\n' +
    '						<dropdown-menu \n' +
    '							placeholder="Side" \n' +
    '							list="vm.procedureSideDictionary[p.Code]"\n' +
    '							display-property="Value" \n' +
    '							property="Value" \n' +
    '							key="Key" \n' +
    '							selected="p.Side" \n' +
    '							show-caret="true"\n' +
    '							dropdown-height="82" \n' +
    '							class="modal-dropdown" \n' +
    '							empty-value="\'U\'" \n' +
    '							hide-other-dropdown="true"\n' +
    '							select-mode="true"\n' +
    '							on-selection-change="vm.onProcedureChanged($event)">\n' +
    '						</dropdown-menu>\n' +
    '					</div>\n' +
    '					<div class="col-25" ng-class="{\'table-label\':!vm.isViewOnly}"\n' +
    '						ng-if="vm.isViewOnly || !vm.techpadConfig.settings.SaveProcs">\n' +
    '						<label>\n' +
    '							{{vm.getLabel(p.Side, vm.sides)}}\n' +
    '						</label>\n' +
    '					</div>\n' +
    '					<div>\n' +
    '						<button\n' +
    '							class="button button-trashcan trashcan-procedure-btn button-clear icon fas fa-trash-alt ripple-effect dark"\n' +
    '							ng-click="$event.stopPropagation();vm.removeProcedure(p)"\n' +
    '							ng-if="!vm.isViewOnly && !vm.shouldDisableControls() && vm.techpadConfig.settings.SaveProcs"\n' +
    '							title="Remove Procedure"></button>\n' +
    '					</div>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '			<div class="exam-udfs row">\n' +
    '				<div class="col-50 form-cols" ng-repeat="col in vm.historyConfig.examUfieldsConfig">\n' +
    '					<div ng-repeat="item in col">\n' +
    '						<div class="item tab-header details-list-header item-transparent item-dropdown-header">\n' +
    '							<div class="dropdown-display"\n' +
    '									 ng-class="{\'view-only\': vm.isViewOnly}">\n' +
    '								<div ng-class="{\'border-bottom-danger\': vm.showValidationErrors && vm.notValidExamUfields[item.Id]}">\n' +
    '									<span class="placeholder text-bold">\n' +
    '										{{item.Caption}}\n' +
    '									</span>\n' +
    '								</div>\n' +
    '							</div>\n' +
    '						</div>\n' +
    '						\n' +
    '						<div ng-if="item.Type == \'DATE\'" class="item item-text-wrap item-transparent sub-list-item-editable">\n' +
    '							<input class="demographic-date-input" ng-disabled="vm.isViewOnly" name="{{item.Id}}"\n' +
    '								ng-model="vm.examUfieldsData[item.Id]" date-input="vm.examUfieldsData[item.Id]" />\n' +
    '							<button ng-disabled="vm.isViewOnly" type="button" class="icon border-less ion-calendar"\n' +
    '								ng-click="vm.changeDate(vm.examUfieldsData, item.Id)"></button>\n' +
    '						</div>\n' +
    '\n' +
    '						<div ng-if="item.Type == \'TEXT\'" class="item item-text-wrap item-transparent">\n' +
    '							<textarea ng-disabled="vm.isViewOnly" id="{{item.Id}}" ng-model="vm.examUfieldsData[item.Id]"\n' +
    '								maxlength="{{item.MaxLength || 9999}}"></textarea>\n' +
    '						</div>\n' +
    '\n' +
    '						<div ng-if="item.Type == \'POP\'" class="item item-text-wrap item-transparent dropdown-result">\n' +
    '							<dropdown-menu \n' +
    '								ng-if="!vm.isViewOnly"\n' +
    '								list="item.OPTIONS" \n' +
    '								disabled=\'vm.isViewOnly\' \n' +
    '								placeholder="Select" \n' +
    '								class="modal-dropdown"\n' +
    '								ng-class="{\'border-bottom-danger\': vm.showValidationErrors && vm.notValidExamUfields[item.Id]}"\n' +
    '								select-mode="true" \n' +
    '								display-property="Value" \n' +
    '								property="Desc" \n' +
    '								key="Code"\n' +
    '								selected="vm.examUfieldsData[item.Id]" \n' +
    '								on-selection-change="vm.examUfieldsData[item.Id] = $type"\n' +
    '								show-caret="true" \n' +
    '								hide-other-dropdown="true"></dropdown-menu>\n' +
    '							<label ng-if="vm.isViewOnly"\n' +
    '										 class="align-items-center h-100 table-label value-label">\n' +
    '								{{vm.getLabel(vm.examUfieldsData[item.Id], item.OPTIONS, \'Code\', \'Desc\')}}\n' +
    '							</label>\n' +
    '						</div>\n' +
    '\n' +
    '					</div>\n' +
    '\n' +
    '				</div>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '\n' +
    '	</div>\n' +
    '	</div>\n' +
    '</form>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/examWindow.html',
    '<div class="modal worklist-exam-modal" ng-class="{\'ready-exam-modal\': model.shouldShowReadForExamMenu}">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h1 class="title">\n' +
    '      <div class="name-wrapper" ng-class="{\'perform-exam\':model.isShowGeneratePinNumber(item)}">\n' +
    '        <div ng-if="item.FirstName || item.LastName" data-fittext data-fittext-min="15" data-fittext-max="30">\n' +
    '          {{item.LastName | camelize}}, {{item.FirstName | camelize}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </h1>\n' +
    '    <div ng-show="model.isShowGeneratePinNumber(item) && !model.examInUse">\n' +
    '      <div class="modal-pin-show">\n' +
    '        Survey PIN:\n' +
    '      </div>\n' +
    '      <div class="modal-pin-number">\n' +
    '        {{ item.PinNumber || \'N/A\' }}\n' +
    '      </div>\n' +
    '      <div class="button button-clear generate-new-pin-button" ng-click="model.generatePinNumber(item)"\n' +
    '        ng-disabled="!model.isOnline()">\n' +
    '        <span class="icon ion-loop"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div ng-if="model.shouldShowReadForExamMenu" class="button button-clear close-modal" ng-click="closeModal()">\n' +
    '      <i class="fas fa-times close-icon"></i>\n' +
    '    </div>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="padding">\n' +
    '    <div class="inner-content">\n' +
    '      <div class="row" ng-if="!!item.ListMessage && !model.shouldShowReadForExamMenu">\n' +
    '        <div class="col-100">\n' +
    '          <div class="modal-list-message"\n' +
    '            style="color: {{item.ListMessageColor || (model.darkMode ? \'#ddd\': \'#3b3b3b\')}};">\n' +
    '            {{ item.ListMessage }}\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div ng-if="model.shouldShowReadForExamMenu">\n' +
    '        <div class="row open-exam-modal-button-container">\n' +
    '          <div class="col-100">\n' +
    '            <button class="button button-large button-block button-dark exam-big-btn ripple ready-for-exam-button"\n' +
    '              r-color="#ffffff" ng-click="model.sendReadyForExam(item, modal);" ng-disabled="!model.isOnline()">\n' +
    '              <div class="exam-ripple-container">\n' +
    '                <div class="clipboad-icon-container">\n' +
    '                  <i class="icon ion-clipboard ion-icon-element"></i>\n' +
    '                </div>\n' +
    '                <div>\n' +
    '                  <div class="exam-window-perform-exam-container">\n' +
    '                    {{performExamButtonLabel}}\n' +
    '                  </div>\n' +
    '                  <div class="exam-window-notify-label-container">\n' +
    '                    Click here to notify the patient that you are ready for their exam.\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div ng-if="!model.shouldShowReadForExamMenu">\n' +
    '        <div class="row">\n' +
    '          <div class="col-45">\n' +
    '\n' +
    '            <button class="button button-large button-block button-dark exam-big-btn ripple" r-color="#ffffff"\n' +
    '              ng-click="model.openItem(item, false, $event, modal);" ng-disabled="!model.isOnline()">\n' +
    '              {{performExamButtonLabel}}\n' +
    '              <i class="icon ion-clipboard"></i>\n' +
    '            </button>\n' +
    '          </div>\n' +
    '          <div class="col-45 col-offset-10">\n' +
    '\n' +
    '            <button class="button button-large button-block button-stable exam-big-btn ripple"\n' +
    '              ng-click="model.openItem(item, true, $event, modal);" ng-disabled="!model.isOnline()">\n' +
    '              View Only\n' +
    '              <i class="icon ion-eye"></i>\n' +
    '            </button>\n' +
    '\n' +
    '          </div>\n' +
    '          <div class="row bottom-row">\n' +
    '            <div class="col-45">\n' +
    '\n' +
    '              <button class="button button-stable button-block change-status-btn icon-right ion-arrow-down-b ripple"\n' +
    '                ng-click="model.changeStatusPopover(item, $event)" ng-hide="model.examInUse"\n' +
    '                ng-disabled="!model.isOnline() || !model.canChangeStatus(item)">\n' +
    '                Change Status\n' +
    '              </button>\n' +
    '            </div>\n' +
    '            <div class="col-45 col-offset-10">\n' +
    '\n' +
    '              <button class="button button-stable button-block back-btn ripple" ng-if="model.isExamMine(item)"\n' +
    '                ng-click="model.unassignWorklist(item, modal)" ng-disabled="!model.isOnline()">\n' +
    '                Un-assign from Me\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '  </content>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/findings.html',
    '<div class="old-diagram-header" ng-show="vm.findingFullscreen && diagramImage">\n' +
    '  <img ng-src="{{ diagramImage }}" alt="Diagram Image"/>\n' +
    '\n' +
    '  <label class="old-diagram-description" ng-bind="oldDiagramDescription"></label>\n' +
    '\n' +
    '  <button class="button button-icon ion-arrow-expand toggle-diagram-full-screen"\n' +
    '          ng-class="{ \'ion-arrow-shrink\': vm.findingFullscreen, \'ion-arrow-expand\': !vm.findingFullscreen }"\n' +
    '          ng-click="vm.toggleDiagramFullscreen()"></button>\n' +
    '</div>\n' +
    '<div class="row old-diagram-container findings-container"\n' +
    '     ng-class="{viewOnly: viewOnly, \'previous-image-shown\':vm.findingFullscreen && diagramImage}">\n' +
    '  <div class="findingsEditorContainer" ng-show="!findingEditing && diagramImage" drop-target=\'true\'\n' +
    '       on-drop=\'vm.dropped\'>\n' +
    '    <h3 class="old-diagram-description-internal" ng-show="!findingEditing" ng-bind="oldDiagramDescription"></h3>\n' +
    '    <img ng-src="{{ diagramImage }}" alt="Diagram Image" width="800"/>\n' +
    '  </div>\n' +
    '  <div class="findingsEditorContainer" ng-show="findingEditing || !diagramImage" drop-target=\'true\'\n' +
    '       on-drop=\'vm.dropped\'>\n' +
    '    <h3 class="old-diagram-description-internal" ng-show="!findingEditing" ng-bind="oldDiagramDescription"></h3>\n' +
    '    <div id="findingsEditor"\n' +
    '         diagram-editor\n' +
    '         set-diagram-editor="vm.setDiagramEditor"\n' +
    '         problems="problemsList"\n' +
    '         selected="vm.selectedElement"\n' +
    '         zoom="vm.zoom"\n' +
    '         save-action="vm.save"\n' +
    '         get-mode="vm.getMode"\n' +
    '         add-problem="vm.addProblem"\n' +
    '         draw-scar="vm.drawScar"\n' +
    '         view-only="viewOnly || !findingEditing"\n' +
    '         problem-settings="vm.diagramSettings">\n' +
    '    </div>\n' +
    '<!-- \n' +
    '         ng-hide="!viewOnly && findingEditing"\n' +
    '    <div id="findingsEditor_ViewOnly" diagram-view problems="problemsList" ng-if="viewOnly || !findingEditing">\n' +
    '\n' +
    '    </div>-->\n' +
    '  </div>\n' +
    '  <div class="right-panel no-background" ng-show="!findingEditing && !viewOnly">\n' +
    '    <button class="panel-item hint-alert button button-block" role="button" ng-click="vm.enableEditing()">\n' +
    '      Modify\n' +
    '    </button>\n' +
    '  </div>\n' +
    '  <div class="right-panel" ng-hide="viewOnly || !findingEditing">\n' +
    '    <div class="panel-item hint-alert">\n' +
    '      <span ng-show="vm.mode==\'s\'">Use your finger to draw</span>\n' +
    '      <span ng-show="vm.mode!=\'\' && vm.mode!=\'s\'">Tap on image to add</span>\n' +
    '      <span ng-show="vm.mode==\'\'">Select or drag to image</span>\n' +
    '    </div>\n' +
    '    <div class="list">\n' +
    '      <div class="panel-item item-icon-left" ng-repeat="el in vm.problems" ng-class="{ active: vm.mode == el.value }"\n' +
    '           ng-click="vm.turnMode(el.value)" draggable="{{el.draggable}}">\n' +
    '        <div class="item-content">\n' +
    '          <i class="icon {{el.icon}}"></i>\n' +
    '          <span>{{el.label}}&nbsp;&nbsp;&nbsp;</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div>\n' +
    '      <button type="button" ng-hide="problemsList.length == 0" class="button button-stable button-block button-small"\n' +
    '              ng-click=\'vm.startClearing()\'>Clear diagram\n' +
    '      </button>\n' +
    '    </div>\n' +
    '    <div>\n' +
    '      <button type="button" ng-if="showSaveButton" class="button button-positive button-block button-small"\n' +
    '              ng-click=\'customSaveAction()\'>Save Diagram\n' +
    '      </button>\n' +
    '    </div>\n' +
    '    <div ng-if="diagramImage && showSaveButton">\n' +
    '      <button class="button button-positive button-block button-small"\n' +
    '              ng-click="vm.toggleDiagramFullscreen()">\n' +
    '        <i class="ion-arrow-expand"\n' +
    '           ng-class="{ \'ion-arrow-shrink\': vm.findingFullscreen, \'ion-arrow-expand\': !vm.findingFullscreen }"></i>\n' +
    '        Toggle Old Diagram\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<hr class="comments-header-hr"/>\n' +
    '<!-- <h3 class="comments-header">\n' +
    '  <span ng-hide="vm.selectedElement" class="header-text">Comments </span>\n' +
    '  <button class="button button-outline button-positive button-add-comment no-animation" ng-click=\'vm.editComment()\' ng-show="vm.selectedElement">\n' +
    '    {{!vm.selectedElement.Comments ? \'Add Comment\' : \'Edit Comment\'}}\n' +
    '  </button>\n' +
    '</h3>\n' +
    '<div class="row">\n' +
    '\n' +
    '  <div class="col-100">\n' +
    '    <div class="padding comment-item col-33" ng-repeat="problem in vm.problemsList track by $index" ng-show="problem.Comments != null">\n' +
    '        <b>{{vm.getLabel(problem.Type)}} ({{problem.index}})</b> - {{problem.Comments}}\n' +
    '      <button class="button button-icon icon pull-right button-delete ion-ios-close-empty" ng-click="vm.removeComment(problem)"></button>\n' +
    '      <br />\n' +
    '      <hr />\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    ' -->\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/followUpEditDialog.html',
    '<div class="modal modal-form" id="follow-up-edit-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      <ng-template>\n' +
    '        <span ng-if="model.followUpId && model.canEdit">Edit</span>\n' +
    '        <span ng-if="!model.followUpId && model.canEdit">Add</span>\n' +
    '        <span> Follow-Up Record</span>\n' +
    '        <span ng-if="!model.canEdit"> Detail</span>\n' +
    '      </ng-template>\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content has-header="true">\n' +
    '    <div class="inner-content connection-lost-message" ng-show="model.needRefresh">\n' +
    '      Unable to load data due to network problem. Please check your network settings. Data will be loaded when network\n' +
    '      is back.\n' +
    '      <button class="button button-stable button-block back-btn close-fu-warning" ng-click="model.close()"> OK</button>\n' +
    '    </div>\n' +
    '    <div class="inner-content" ng-show="!model.needRefresh">\n' +
    '      <div class="row">\n' +
    '        <div class="col col-100 block-title m-t-15">\n' +
    '          <label class="bold">Follow-up Information</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-35">\n' +
    '        <div class="col col-20 text-right section-title">\n' +
    '          <label class="bold">Study Date:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-20 relative">\n' +
    '          <label class="date-element input-container uneditable underlined">\n' +
    '            <div class="followup-date">{{model.data.StudyDate | date: \'MM/dd/yyyy\'}}</div>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-10 relative" ng-if="model.canEdit">\n' +
    '          <button type="button" class="icon ion-calendar date-element"\n' +
    '            ng-click="model.changeDate(\'StudyDate\')"></button>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col col-20 text-right section-title">\n' +
    '          <label class="bold">Recall By:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-20 relative">\n' +
    '          <label class="date-element input-container uneditable underlined">\n' +
    '            <div class="followup-date">{{model.data.RecallDate | date: \'MM/dd/yyyy\'}}</div>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-10 relative" ng-if="model.canEdit">\n' +
    '          <button type="button" class="icon ion-calendar date-element"\n' +
    '            ng-click="model.changeDate(\'RecallDate\')"></button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col col-100">\n' +
    '          <dropdown-menu \n' +
    '            placeholder="Location" \n' +
    '            list="model.locations" \n' +
    '            select-mode="true" \n' +
    '            property="Value" \n' +
    '            key="Key"\n' +
    '            display-property="Value" \n' +
    '            show-caret="true" \n' +
    '            dropdown-height="205" \n' +
    '            class="modal-dropdown"\n' +
    '            disabled="!model.canEdit" \n' +
    '            selected="model.data.Location"></dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row ref-phy-row">\n' +
    '        <div class="col col-33 section-title ref-phy-on-follow-up">\n' +
    '          <label class="bold">Referring Physician:</label>\n' +
    '        </div>\n' +
    '        <div class="col">\n' +
    '          <input ion-autocomplete id="pef-phy-autocomplete-input" type="text" class="ion-autocomplete underlined full-width ref-phy-input"\n' +
    '            items-method="model.getRefPhyAutocomplete(query)" ng-model="model.data.RefNum"\n' +
    '            placeholder="{{model.refPhyPlaceholder}}" item-value-key="RefNum"\n' +
    '            select-items-label="Select Referring Physician" selected-items-label="Selected Referring Physician"\n' +
    '            item-view-value-key="DisplayName" items-clicked-method="model.refPhySelected(callback)"\n' +
    '            model-to-item-method="model.getRefPhyByKey(modelValue)" external-model="[model.data.RefNum]"\n' +
    '            autocomplete="off" max-selected-items="1" template-url="views/templates/followUpEditRefPhyDialog.html"\n' +
    '            template-data="model.templateData" ng-disabled="!model.canEdit"\n' +
    '            ng-class="{\'FU-ref-phy-edit-mode\': !model.canEdit}" cancel-button-clicked-method="model.onRefPhyAutocompleteModalClosed($event)"\n' +
    '            ng-readonly="true" ng-click="onRefPhyAutocompleteInputClick($event)" ontouchend="onRefPhyAutocompleteTouchEnd(event)" />\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col col-100">\n' +
    '          <dropdown-menu placeholder="Assessment" list="model.assessments" select-mode="true"\n' +
    '            display-property="Description" property="Description" key="Code" show-caret="true" dropdown-height="205"\n' +
    '            class="modal-dropdown" disabled="!model.canEdit" selected="model.data.Assessment"></dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col col-100">\n' +
    '          <dropdown-menu placeholder="Recommendation" ng-show="!!model.data.Assessment" list="model.recommendations"\n' +
    '            select-mode="true" display-property="Description" property="Description" key="Code" show-caret="true"\n' +
    '            dropdown-height="205" class="modal-dropdown" disabled="!model.canEdit" selected="model.data.Recommendation">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col col-50">\n' +
    '          <dropdown-menu placeholder="Modality" list="model.modalityOptions" select-mode="true"\n' +
    '            display-property="Description" property="Description" key="Code" show-caret="true" dropdown-height="205"\n' +
    '            class="modal-dropdown" disabled="!model.canEdit" selected="model.data.Modality"></dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-50">\n' +
    '          <dropdown-menu placeholder="Side" list="model.sideOptions" select-mode="true" display-property="Description"\n' +
    '            property="Description" key="Code" show-caret="true" dropdown-height="205" disabled="!model.canEdit"\n' +
    '            class="modal-dropdown" selected="model.data.Side"></dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-25" ng-if="model.canEdit">\n' +
    '        <div class="col-45">\n' +
    '\n' +
    '          <button class="button button-positive button-block ripple" ng-click="model.save();">\n' +
    '            Save\n' +
    '          </button>\n' +
    '\n' +
    '        </div>\n' +
    '        <div class="col-45 col-offset-10">\n' +
    '\n' +
    '          <button class="button button-stable button-block back-btn ripple" r-color="#000000"\n' +
    '            ng-click="model.closeWindow();">\n' +
    '            Cancel\n' +
    '          </button>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-25" ng-if="!model.canEdit">\n' +
    '        <div class="col-100">\n' +
    '\n' +
    '          <button class="button button-stable button-block back-btn ripple" r-color="#000000" ng-click="model.close();">\n' +
    '            Close\n' +
    '          </button>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/followUpEditRefPhyDialog.html',
    '<div class="ion-autocomplete-container {{viewModel.randomCssClass}} modal" style="display: none;" id="follow-up-edit-ref-phy-dialog">\n' +
    '  <div class="bar bar-header item-input-inset">\n' +
    '    <label class="item-input-wrapper">\n' +
    '      <i class="icon ion-search placeholder-icon"></i>\n' +
    '      <input type="search" class="ion-autocomplete-search" ng-model="viewModel.searchQuery"\n' +
    '        ng-model-options="viewModel.ngModelOptions" placeholder="{{viewModel.placeholder}}" />\n' +
    '    </label>\n' +
    '    <div class="ion-autocomplete-loading-icon" ng-if="viewModel.showLoadingIcon && viewModel.loadingIcon">\n' +
    '      <ion-spinner icon="{{viewModel.loadingIcon}}"></ion-spinner>\n' +
    '    </div>\n' +
    '    <button class="ion-autocomplete-cancel button button-clear" ng-click="viewModel.cancelClick()">\n' +
    '      {{viewModel.cancelLabel}}\n' +
    '    </button>\n' +
    '  </div>\n' +
    '  <ion-content class="has-header">\n' +
    '    <ion-item class="item-divider">{{viewModel.selectedItemsLabel}}</ion-item>\n' +
    '    <ion-item ng-if="viewModel.isArray(viewModel.selectedItems)"\n' +
    '      ng-repeat="selectedItem in viewModel.selectedItems track by $index"\n' +
    '      class="item-icon-left item-icon-right item-text-wrap">\n' +
    '      <i class="icon ion-checkmark"></i>\n' +
    '      {{viewModel.getItemValue(selectedItem, viewModel.itemViewValueKey)}}\n' +
    '      <i class="icon ion-close" style="cursor:pointer" ng-click="viewModel.removeItem($index)"></i>\n' +
    '    </ion-item>\n' +
    '    <ion-item ng-if="!viewModel.isArray(viewModel.selectedItems) && viewModel.selectedItems" class="item-icon-left item-icon-right item-text-wrap">\n' +
    '      <i class="icon ion-checkmark"></i>\n' +
    '      {{viewModel.getItemValue(viewModel.selectedItems, viewModel.itemViewValueKey)}}\n' +
    '      <i class="icon ion-close" style="cursor:pointer" ng-click="viewModel.removeItem(0)"></i>\n' +
    '    </ion-item>\n' +
    '    <ion-item class="item-divider" ng-if="viewModel.searchItems.List.length > 0">{{viewModel.selectItemsLabel}}\n' +
    '    </ion-item>\n' +
    '    <ion-item ng-repeat="item in viewModel.searchItems.List track by $index" item-height="55px" item-width="100%"\n' +
    '      ng-click="viewModel.selectItem(item)" class="item-text-wrap">\n' +
    '      {{viewModel.getItemValue(item, viewModel.itemViewValueKey)}}\n' +
    '    </ion-item>\n' +
    '    <ion-item class="getRefPhyError" ng-show="viewModel.searchItems.IsError">\n' +
    '      {{viewModel.searchItems.ErrorMessage}}\n' +
    '    </ion-item>\n' +
    '\n' +
    '    <ion-item ng-if="viewModel.templateData.showLoadMore" ng-click="viewModel.fetchSearchQuery(viewModel.searchQuery || \'\',false)" class="item-text-wrap load-more-refphys-button-container">\n' +
    '      <div class="load-more-refphys-button">Load More</div>\n' +
    '    </ion-item>\n' +
    '  </ion-content>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/followUpPatientDetails.html',
    '<div class="inner-content patient-readonly-container">\n' +
    '  <div class="item item-transparent">\n' +
    '    <div class="row m-b-10">\n' +
    '      <div class="col-60 d-flex align-items-center">\n' +
    '        <div class="section-title">\n' +
    '          <label class="bold">Patient Name:</label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '          <label class="item item-input no-border">\n' +
    '            <span class="patient-info">{{patientFullName}}</span>\n' +
    '            <span class="patient-age-and-dob">({{patientAgeAndDobString}})</span>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-40 d-flex align-items-center">\n' +
    '        <div class="section-title">\n' +
    '          <label class="bold">Home Phone:</label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '          <label class="item item-input no-border">\n' +
    '            <span class="patient-info">{{patientDetails.HomePhone}}</span>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '      <div class="col-60 d-flex align-items-center">\n' +
    '        <div class="section-title">\n' +
    '          <label class="bold">Patient ID:</label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '          <label class="item item-input no-border">\n' +
    '            <span class="patient-info">{{patientDetails.Ssn}}</span>\n' +
    '            <button class="patient-notification" ng-if="clip && clip.Flag" ng-click="showPatClipPopup()">\n' +
    '              <i class="icon ion-alert-circled"></i>{{clip.Flag}}\n' +
    '            </button>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="col-40 d-flex align-items-center">\n' +
    '        <div class="section-title">\n' +
    '          <label class="bold">Cell Phone:</label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '          <label class="item item-input no-border">\n' +
    '            <span class="patient-info">{{patientDetails.CellPhone}}</span>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/followUpResolveDialog.html',
    '<div class="modal modal-form create-document-form contact-form">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title title-left">\n' +
    '      Resolve Follow-Up\n' +
    '    </h3>\n' +
    '    <div class="buttons right-buttons">\n' +
    '      <button class="button button-icon ion-close" ng-click="model.close()"></button>\n' +
    '    </div>\n' +
    '\n' +
    '  </header>\n' +
    '  <content has-header="true">\n' +
    '    <label class="item" ng-if="model.loading"><b>Loading...</b></label>\n' +
    '    <div ng-if="!model.loading">\n' +
    '      <follow-up-patient-details\n' +
    '        patient-access-token="model.patientAccessToken"\n' +
    '        clip="model.clip">\n' +
    '      </follow-up-patient-details>\n' +
    '    </div>\n' +
    '    <div ng-if="!model.loading" class="follow-up-details-container follow-up-list-container resolve-follow-up-only">\n' +
    '      <div class="follow-up-details">\n' +
    '        <resolve-follow-up\n' +
    '          follow-up="model.followUp"\n' +
    '          is-show-resolve-button="false"\n' +
    '          on-resolved="model.resolveFollowUp()"\n' +
    '          on-canceled="model.close()"\n' +
    '          is-show-buttons-as-modal="true"\n' +
    '          check-if-stil-owning="model.checkIfStillOwningAndNotOffline()"\n' +
    '          >\n' +
    '        </resolve-follow-up>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/followUpTabScrollTemplate.html',
    '<ion-list class="list followups-items">\n' +
    '    <ion-item class="item text-center" ng-if="!vm.getFollowUps()">\n' +
    '        <ion-spinner></ion-spinner>\n' +
    '        <b>Loading...</b>\n' +
    '    </ion-item>\n' +
    '\n' +
    '    <ion-item class="item text-center" ng-if="!!vm.getFollowUps() && !vm.getFollowUps().length">\n' +
    '        <b>\n' +
    '            {{ vm.getNoFollowUpMessage() }}\n' +
    '        </b>\n' +
    '    </ion-item>\n' +
    '\n' +
    '    <ion-item class="item item-icon-right repeat-animation relative" ng-repeat="followUp in vm.getFollowUps()">\n' +
    '        <!-- is-swiped="followUp.isSwiped"> -->\n' +
    '        <div class="row">\n' +
    '\n' +
    '            <div class="col col-20">{{ followUp.StudyDate | date:\'MM/dd/yyyy\' }}</div>\n' +
    '            <div class="col col-20">{{ followUp.RecallDate | date:\'MM/dd/yyyy\' }}</div>\n' +
    '            <div class="col col-45">{{ followUp.AssessmentDescription }}</div>\n' +
    '            <div class="col col-15">{{ !!followUp.FUReason.trim() ? \'Closed\' : \'Open\' }}</div>\n' +
    '            <button class="icon ion-ios-circle-outline open-icon button button-clear no-activated-state"\n' +
    '                ng-click="$event.stopPropagation(); $event.preventDefault();" ng-if="!vm.isViewOnly || vm.isMyPatientMode">\n' +
    '                <i class="icon"\n' +
    '                    ng-class="{ \'ion-ios-arrow-right\' : followUp.isSwiped, \'ion-ios-arrow-left\': !followUp.isSwiped }"></i>\n' +
    '            </button>\n' +
    '        </div>\n' +
    '\n' +
    '        <ng-container ng-if="!vm.isViewOnly || vm.isMyPatientMode">\n' +
    '            <ion-option-button class="list-item-button button button-assertive" ng-click="vm.deleteFollowUp(followUp)">\n' +
    '                Delete\n' +
    '            </ion-option-button>\n' +
    '\n' +
    '            <ion-option-button class="list-item-button button button-dark" ng-show="!followUp.FUReason.trim()"\n' +
    '                ng-click="vm.resolveFollowUp(followUp)">\n' +
    '                Resolve\n' +
    '            </ion-option-button>\n' +
    '\n' +
    '            <ion-option-button class="list-item-button button button-dark" ng-show="!!followUp.FUReason.trim()"\n' +
    '                ng-click="vm.reopenFollowUp(followUp)">\n' +
    '                Unresolve\n' +
    '            </ion-option-button>\n' +
    '\n' +
    '            <ion-option-button class="list-item-button button button-edit" ng-click="vm.editFollowUp(followUp)">\n' +
    '                Edit\n' +
    '            </ion-option-button>\n' +
    '        </ng-container>\n' +
    '    </ion-item>\n' +
    '</ion-list>\n' +
    '<div class="container-with-padding">\n' +
    '    &nbsp;\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/historyBRCAEditDialog.html',
    '<div class="modal modal-form">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      {{model.dynamicLabels.FamilyBrcaCaption}}\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content has-header="true">\n' +
    '    <div class="inner-content" ng-show="!model.needRefresh">\n' +
    '      <div class="row m-t-15" ng-if="model.config.Relative">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Relative:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-75">\n' +
    '          <dropdown-menu placeholder="Relative" list="model.config.Relative.Options" select-mode="true"\n' +
    '            display-property="Desc" property="Desc" key="Code" selected="model.data.Relative" show-caret="true"\n' +
    '            dropdown-height="225" class="modal-dropdown" hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15" ng-if="model.checkIfAskParentRelative()">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Parent:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-75">\n' +
    '          <dropdown-menu placeholder="Parent" list="model.selectedRelativeParentsList.Options" select-mode="true"\n' +
    '            display-property="Desc" property="Desc" key="Code" selected="model.data.Parent" show-caret="true"\n' +
    '            dropdown-height="225" class="modal-dropdown" hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15 brca-history-result-header" ng-if="model.config.Relative">\n' +
    '        <div class="col col-20 text-right section-column-title">\n' +
    '          <label class="bold">{{model.dynamicLabels.FamilyBrcaTitle}}:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-20 text-center section-column-title"><label class="bold text-center show">{{model.dynamicLabels.FamilyBrcaNotTested}}</label></div>\n' +
    '        <div class="col col-20 text-center section-column-title"><label class="bold text-center show">{{model.dynamicLabels.FamilyBrcaPositive}}</label></div>\n' +
    '        <div class="col col-20 text-center section-column-title"><label class="bold text-center show">{{model.dynamicLabels.FamilyBrcaNegative}}</label></div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15 brca-history-result-wrapper" ng-if="model.config.Relative">\n' +
    '        <div class="col col-20 text-right section-column-title">\n' +
    '          <label class="name">{{model.dynamicLabels.FamilyBrcaFirstGeneLabel}}:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-20 text-center">\n' +
    '          <label class="checkbox">\n' +
    '            <input type="checkbox" data-id="FamilyBRCA1No" ng-model="model.familyBRCA1Value" ng-true-value="\'0\'"\n' +
    '              ng-false-value="\'\'" ng-click="model.familyBRCA1Change(\'0\')" />\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-20 text-center">\n' +
    '          <label class="checkbox">\n' +
    '            <input type="checkbox" ng-model="model.familyBRCA1Value" ng-true-value="\'1\'" ng-false-value="\'\'"\n' +
    '              ng-click="model.familyBRCA1Change(\'1\')" />\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-20 text-center">\n' +
    '          <label class="checkbox">\n' +
    '            <input type="checkbox" ng-model="model.familyBRCA1Value" ng-true-value="\'2\'" ng-false-value="\'\'"\n' +
    '              ng-click="model.familyBRCA1Change(\'2\')" />\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15 brca-history-result-wrapper" ng-if="model.config.Relative">\n' +
    '        <div class="col col-20 text-right section-column-title">\n' +
    '          <label class="name">{{model.dynamicLabels.FamilyBrcaSecondGeneLabel}}:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-20 text-center">\n' +
    '          <label class="checkbox">\n' +
    '            <input type="checkbox" data-id="FamilyBRCA2No" ng-model="model.familyBRCA2Value" ng-true-value="\'0\'"\n' +
    '              ng-false-value="\'\'" ng-click="model.familyBRCA2Change(\'0\')" />\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-20 text-center">\n' +
    '          <label class="checkbox">\n' +
    '            <input type="checkbox" ng-model="model.familyBRCA2Value" ng-true-value="\'1\'" ng-false-value="\'\'"\n' +
    '              ng-click="model.familyBRCA2Change(\'1\')" />\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-20 text-center">\n' +
    '          <label class="checkbox">\n' +
    '            <input type="checkbox" ng-model="model.familyBRCA2Value" ng-true-value="\'2\'" ng-false-value="\'\'"\n' +
    '              ng-click="model.familyBRCA2Change(\'2\')" />\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-25">\n' +
    '        <div class="col-33 padding-right">\n' +
    '          <button ng-if="model.editMode" class="button button-assertive button-block" ng-click="model.delete();">\n' +
    '            Remove\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-33 padding-horizontal">\n' +
    '          <button class="button button-positive button-block" ng-click="model.save();">\n' +
    '            Save\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-33 padding-left">\n' +
    '          <button class="button button-stable button-block back-btn" ng-click="model.closeWindow();">\n' +
    '            Cancel\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/historyCancerEditDialog.html',
    '<div class="modal modal-form modal-form-cancer">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      {{model.title}}\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content has-header="true">\n' +
    '    <div class="inner-content" ng-show="!model.needRefresh">\n' +
    '\n' +
    '      <div class="row m-t-15" ng-if="model.config.Relative">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Relative:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-33">\n' +
    '          <dropdown-menu\n' +
    '            placeholder="Relative"\n' +
    '            list="model.config.Relative.Options"\n' +
    '            select-mode="true"\n' +
    '            display-property="Desc"\n' +
    '            property="Desc"\n' +
    '            key="Code"\n' +
    '            selected="model.data.Relative"\n' +
    '            show-caret="true"\n' +
    '            dropdown-height="225"\n' +
    '            class="modal-dropdown"\n' +
    '            hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-40">\n' +
    '          <dropdown-menu\n' +
    '            placeholder="Current Age"\n' +
    '            list="model.config.Age.Options"\n' +
    '            select-mode="true"\n' +
    '            display-property="Desc"\n' +
    '            property="Desc"\n' +
    '            key="Code"\n' +
    '            selected="model.data.CurrentAge"\n' +
    '            show-caret="true"\n' +
    '            dropdown-height="225"\n' +
    '            class="modal-dropdown"\n' +
    '            hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-15" ng-if="model.checkIfAskParentRelative()">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Parent:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-75">\n' +
    '          <dropdown-menu placeholder="Parent"\n' +
    '                         list="model.selectedRelativeParentsList.Options"\n' +
    '                         select-mode="true"\n' +
    '                         display-property="Desc"\n' +
    '                         property="Desc" key="Code"\n' +
    '                         selected="model.data.Parent"\n' +
    '                         show-caret="true"\n' +
    '                         dropdown-height="225"\n' +
    '                         class="modal-dropdown"\n' +
    '                         hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Diagnosis date:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-33">\n' +
    '          <dropdown-menu placeholder="Month"\n' +
    '                         list="model.config.DMonth.Options"\n' +
    '                         select-mode="true"\n' +
    '                         display-property="Desc"\n' +
    '                         property="Desc" key="Code"\n' +
    '                         selected="model.data.DiagnosisMonth"\n' +
    '                         show-caret="true"\n' +
    '                         dropdown-height="225"\n' +
    '                         class="modal-dropdown"\n' +
    '                         hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-40">\n' +
    '          <dropdown-menu placeholder="Year"\n' +
    '                         list="model.config.DYear.Options"\n' +
    '                         select-mode="true"\n' +
    '                         display-property="Desc"\n' +
    '                         property="Desc" key="Code"\n' +
    '                         selected="model.data.DiagnosisYear"\n' +
    '                         show-caret="true"\n' +
    '                         dropdown-height="225"\n' +
    '                         class="modal-dropdown"\n' +
    '                         hide-other-dropdown="true"\n' +
    '                         on-selected-changed="model.onYearSelectedChanged(selected, \'DYear\', \'DiagnosisYear\')">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label>or age:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-20">\n' +
    '          <dropdown-menu placeholder="Age"\n' +
    '                         list="model.config.Age.Options"\n' +
    '                         select-mode="true"\n' +
    '                         display-property="Desc"\n' +
    '                         property="Desc" key="Code"\n' +
    '                         selected="model.data.Age"\n' +
    '                         show-caret="true"\n' +
    '                         dropdown-height="156"\n' +
    '                         class="modal-dropdown"\n' +
    '                         hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-15 text-right section-title">\n' +
    '            <label>or date:</label>\n' +
    '        </div>\n' +
    '        <div class="col relative" class="col-25">\n' +
    '          <label class="date-element">\n' +
    '            <input ng-model="model.data.Date" date-input="model.data.Date" />\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-15 relative">\n' +
    '          <button type="button" class="icon ion-calendar date-element" ng-click="model.changeDate(model.data, \'Date\')"></button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15" ng-if="model.config.Menopausal">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">{{model.config.Menopausal.Caption}}:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-50 m-l-15">\n' +
    '          <label class="checkbox pull-left">\n' +
    '            <input type="checkbox" ng-model="model.data.Menopausal" value="true"\n' +
    '                    ng-true-value="\'Y\'" ng-false-value="">\n' +
    '          </label>\n' +
    '          <label class="yesno-label pull-left">Yes</label>\n' +
    '          <label class="checkbox pull-left">\n' +
    '            <input type="checkbox" ng-model="model.data.Menopausal" value="false"\n' +
    '                    ng-true-value="\'N\'" ng-false-value="">\n' +
    '          </label>\n' +
    '          <label class="yesno-label pull-left">No</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15" ng-if="model.config.Bilateral">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">{{model.config.Bilateral.Caption}}:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-50 m-l-15">\n' +
    '          <label class="checkbox pull-left">\n' +
    '            <input type="checkbox" ng-model="model.data.Bilateral" value="true"\n' +
    '                    ng-true-value="\'Y\'" ng-false-value="">\n' +
    '          </label>\n' +
    '          <label class="yesno-label pull-left">Yes</label>\n' +
    '          <label class="checkbox pull-left">\n' +
    '            <input type="checkbox" ng-model="model.data.Bilateral" value="false"\n' +
    '                    ng-true-value="\'N\'" ng-false-value="">\n' +
    '          </label>\n' +
    '          <label class="yesno-label pull-left">No</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Type:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-75">\n' +
    '          <dropdown-menu placeholder="Type"\n' +
    '                         list="model.config.Cancer.Options"\n' +
    '                         select-mode="true"\n' +
    '                         display-property="Desc"\n' +
    '                         property="Desc" key="Code"\n' +
    '                         selected="model.data.Type"\n' +
    '                         show-caret="true"\n' +
    '                         dropdown-height="156"\n' +
    '                         class="modal-dropdown"\n' +
    '                         hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15" ng-if="model.config.Side && !model.disabledSide">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Side:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-25">\n' +
    '          <dropdown-menu placeholder="Side"\n' +
    '                         list="model.config.Side.Options"\n' +
    '                         select-mode="true"\n' +
    '                         display-property="Desc"\n' +
    '                         property="Desc" key="Code"\n' +
    '                         selected="model.data.Side"\n' +
    '                         show-caret="true"\n' +
    '                         dropdown-height="156"\n' +
    '                         class="modal-dropdown"\n' +
    '                         hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title history-record-notes-title">\n' +
    '          <label class="bold">Notes:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-80">\n' +
    '          <textarea no-new-line class="history-record-notes w-100" ng-model="model.data.Notes" rows="3"></textarea>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-25">\n' +
    '        <div class="col-33 padding-right">\n' +
    '          <button ng-if="model.editMode"\n' +
    '                  class="button button-assertive button-block"\n' +
    '                  ng-click="model.delete();">\n' +
    '            Remove\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-33 padding-horizontal">\n' +
    '          <button class="button button-positive button-block"\n' +
    '                  ng-click="model.save();">\n' +
    '            Save\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-33 padding-left">\n' +
    '          <button class="button button-stable button-block back-btn"\n' +
    '                  ng-click="model.closeWindow();">\n' +
    '            Cancel\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/historyHormoneEditDialog.html',
    '<div class="modal modal-form modal-form-hormone">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      {{model.title}}\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content has-header="true">\n' +
    '    <div class="inner-content" ng-show="!model.needRefresh">\n' +
    '\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Type:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-80 m-l-15">\n' +
    '          <dropdown-menu placeholder="Type" list="model.config.HORM.Options" select-mode="true" display-property="Desc"\n' +
    '            property="Desc" key="Code" selected="model.data.Type" show-caret="true" dropdown-height="156"\n' +
    '            class="modal-dropdown" hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Currently using:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-50 m-l-15">\n' +
    '          <label class="checkbox pull-left">\n' +
    '            <input type="checkbox" ng-model="model.data.CurrentUsing" value="true" ng-true-value="\'Y\'"\n' +
    '              ng-false-value="" ng-change="model.onCurrentUsingChanged()">\n' +
    '          </label>\n' +
    '          <label class="yesno-label pull-left">Yes</label>\n' +
    '          <label class="checkbox pull-left">\n' +
    '            <input type="checkbox" ng-model="model.data.CurrentUsing" value="false" ng-true-value="\'N\'"\n' +
    '              ng-false-value="" ng-change="model.onCurrentUsingChanged()">\n' +
    '          </label>\n' +
    '          <label class="yesno-label pull-left">No</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">First Use:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-20 m-l-15">\n' +
    '          <dropdown-menu placeholder="Month" list="model.config.FMonth.Options" select-mode="true"\n' +
    '            display-property="Desc" property="Desc" key="Code" selected="model.data.FMonth" show-caret="true"\n' +
    '            dropdown-height="156" class="modal-dropdown" hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-15 m-l-10">\n' +
    '          <dropdown-menu placeholder="Day" list="model.config.FDay.Options" select-mode="true" display-property="Desc"\n' +
    '            property="Desc" key="Code" selected="model.data.FDay" show-caret="true" dropdown-height="156"\n' +
    '            class="modal-dropdown" hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-15 m-l-10">\n' +
    '          <dropdown-menu placeholder="Year" list="model.config.FYear.Options" select-mode="true" display-property="Desc"\n' +
    '            property="Desc" key="Code" selected="model.data.FYear" show-caret="true" dropdown-height="156"\n' +
    '            class="modal-dropdown" hide-other-dropdown="true" on-selected-changed="model.onYearSelectedChanged(selected, \'FYear\', \'FYear\')">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-10 section-title">\n' +
    '          <label>or age:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-15 m-l-15">\n' +
    '          <dropdown-menu placeholder="Age" list="model.config.FAge.Options" select-mode="true" display-property="Desc"\n' +
    '            property="Desc" key="Code" selected="model.data.FAge" show-caret="true" dropdown-height="156"\n' +
    '            class="modal-dropdown" hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Last Use:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-20 m-l-15">\n' +
    '          <dropdown-menu placeholder="Month" list="model.config.LMonth.Options" select-mode="true"\n' +
    '            display-property="Desc" property="Desc" key="Code" selected="model.data.LMonth" show-caret="true"\n' +
    '            dropdown-height="156" class="modal-dropdown" hide-other-dropdown="true"\n' +
    '            ng-class="{\'disabled-class\': model.data.CurrentUsing === model.constantStrings.common.Yes}">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-15 m-l-10">\n' +
    '          <dropdown-menu placeholder="Day" list="model.config.LDay.Options" select-mode="true" display-property="Desc"\n' +
    '            property="Desc" key="Code" selected="model.data.LDay" show-caret="true" dropdown-height="156"\n' +
    '            class="modal-dropdown" hide-other-dropdown="true" \n' +
    '            ng-class="{\'disabled-class\': model.data.CurrentUsing === model.constantStrings.common.Yes}">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-15 m-l-10">\n' +
    '          <dropdown-menu placeholder="Year" list="model.config.LYear.Options" select-mode="true" display-property="Desc"\n' +
    '            property="Desc" key="Code" selected="model.data.LYear" show-caret="true" dropdown-height="156"\n' +
    '            class="modal-dropdown" hide-other-dropdown="true" \n' +
    '            ng-class="{\'disabled-class\': model.data.CurrentUsing === model.constantStrings.common.Yes}"\n' +
    '            on-selected-changed="model.onYearSelectedChanged(selected, \'LYear\', \'LYear\')">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-10 section-title">\n' +
    '          <label>or age:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-15 m-l-15">\n' +
    '          <dropdown-menu placeholder="Age" list="model.config.LAge.Options" select-mode="true" display-property="Desc"\n' +
    '            property="Desc" key="Code" selected="model.data.LAge" show-caret="true" dropdown-height="156"\n' +
    '            ng-class="{\'disabled-class\': model.data.CurrentUsing === model.constantStrings.common.Yes}"\n' +
    '            class="modal-dropdown" hide-other-dropdown="true" \n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Intend use:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-10 m-l-15">\n' +
    '          <label class="item item-input short">\n' +
    '            <input ng-model="model.data.IYear" number-input-validate="model.data.IYear" min="0" max="12" \n' +
    '              ng-class="{\'disabled-class\': model.data.CurrentUsing != model.constantStrings.common.Yes}"\n' +
    '              ng-disabled="model.data.CurrentUsing != model.constantStrings.common.Yes">\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-10 section-title">\n' +
    '          <label class="text-left">Years</label>\n' +
    '        </div>\n' +
    '        <div class="col col-10">\n' +
    '          <label class="item item-input short">\n' +
    '            <input ng-model="model.data.IMonth" number-input-validate="model.data.IMonth" min="0" max="11" \n' +
    '              ng-class="{\'disabled-class\': model.data.CurrentUsing != model.constantStrings.common.Yes}"\n' +
    '              ng-disabled="model.data.CurrentUsing != model.constantStrings.common.Yes">\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-10 section-title">\n' +
    '          <label class="text-left">Months</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Continuous use:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-50 m-l-15">\n' +
    '          <label class="checkbox pull-left">\n' +
    '            <input type="checkbox" ng-model="model.data.ContinuousUse" value="true" ng-true-value="\'Y\'"\n' +
    '              ng-false-value="">\n' +
    '          </label>\n' +
    '          <label class="yesno-label pull-left">Yes</label>\n' +
    '          <label class="checkbox pull-left">\n' +
    '            <input type="checkbox" ng-model="model.data.ContinuousUse" value="false" ng-true-value="\'N\'"\n' +
    '              ng-false-value="">\n' +
    '          </label>\n' +
    '          <label class="yesno-label pull-left">No</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Duration of longest use:</label>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col col-10 m-l-15">\n' +
    '          <label class="item item-input short">\n' +
    '            <input ng-model="model.data.DYear" number-input-validate="model.data.DYear" min="0" maxlength="3">\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-10 section-title">\n' +
    '          <label class="text-left">Years</label>\n' +
    '        </div>\n' +
    '        <div class="col col-10">\n' +
    '          <label class="item item-input short">\n' +
    '            <input ng-model="model.data.DMonth" number-input-validate="model.data.DMonth" min="0" maxlength="3">\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-10 section-title">\n' +
    '          <label class="text-left">Months</label>\n' +
    '        </div>\n' +
    '        <div class="col col-10">\n' +
    '          <label class="item item-input short">\n' +
    '            <input ng-model="model.data.DWeek" number-input-validate="model.data.DWeek" min="0" maxlength="3">\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-10 section-title">\n' +
    '          <label class="text-left">Weeks</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title history-record-notes-title">\n' +
    '          <label class="bold">Notes:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-80">\n' +
    '          <textarea no-new-line inputValue="model.data.Notes" class="history-record-notes w-100" ng-model="model.data.Notes" rows="3"></textarea>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-25">\n' +
    '        <div class="col-33 padding-right">\n' +
    '          <button ng-if="model.editMode" class="button button-assertive button-block" ng-click="model.delete();">\n' +
    '            Remove\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-33 padding-horizontal">\n' +
    '          <button class="button button-positive button-block" ng-click="model.save();">\n' +
    '            Save\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-33 padding-left">\n' +
    '          <button class="button button-stable button-block back-btn" ng-click="model.closeWindow();">\n' +
    '            Cancel\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/historyProcedureEditDialog.html',
    '<div class="modal modal-form modal-form-procedure">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      {{ model.title }}\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content has-header="true">\n' +
    '    <div class="inner-content" ng-show="!model.needRefresh">\n' +
    '\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Date:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-33">\n' +
    '          <dropdown-menu placeholder="Month"\n' +
    '                         list="model.config.Month.Options"\n' +
    '                         select-mode="true"\n' +
    '                         display-property="Desc"\n' +
    '                         property="Desc" key="Code"\n' +
    '                         selected="model.data.Month"\n' +
    '                         show-caret="true"\n' +
    '                         dropdown-height="205"\n' +
    '                         class="modal-dropdown"\n' +
    '                         hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-40">\n' +
    '          <dropdown-menu placeholder="Year"\n' +
    '                         list="model.config.Year.Options"\n' +
    '                         select-mode="true"\n' +
    '                         display-property="Desc"\n' +
    '                         property="Desc" key="Code"\n' +
    '                         selected="model.data.Year"\n' +
    '                         show-caret="true"\n' +
    '                         dropdown-height="205"\n' +
    '                         class="modal-dropdown"\n' +
    '                         hide-other-dropdown="true"\n' +
    '                         on-selected-changed="model.onYearSelectedChanged(selected, \'Year\', \'Year\')">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label>or age:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-20">\n' +
    '          <dropdown-menu placeholder="Age"\n' +
    '                         list="model.config.Age.Options"\n' +
    '                         select-mode="true"\n' +
    '                         display-property="Desc"\n' +
    '                         property="Desc" key="Code"\n' +
    '                         selected="model.data.Age"\n' +
    '                         show-caret="true"\n' +
    '                         dropdown-height="156"\n' +
    '                         class="modal-dropdown"\n' +
    '                         hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-15 text-right section-title">\n' +
    '            <label>or date:</label>\n' +
    '        </div>\n' +
    '        <div class="col relative" class="col-25">\n' +
    '          <label class="date-element">\n' +
    '            <input ng-model="model.data.Date" date-input="model.data.Date" />\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-15 relative">\n' +
    '          <button type="button" class="icon ion-calendar date-element" ng-click="model.changeDate(model.data, \'Date\')"></button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Type:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-75">\n' +
    '          <dropdown-menu placeholder="Type"\n' +
    '                         list="model.config.Procedure.Options"\n' +
    '                         select-mode="true"\n' +
    '                         display-property="Desc"\n' +
    '                         property="Desc" key="Code"\n' +
    '                         selected="model.data.List"\n' +
    '                         show-caret="true"\n' +
    '                         dropdown-height="156"\n' +
    '                         class="modal-dropdown"\n' +
    '                         hide-other-dropdown="true"\n' +
    '                         on-selection-change="model.checkIfSideDisabled($type)">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15" ng-if="model.config.Result">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">{{model.config.Result.Caption}}:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-75">\n' +
    '          <dropdown-menu placeholder="Result"\n' +
    '                          list="model.config.Result.Options"\n' +
    '                          select-mode="true"\n' +
    '                          display-property="Desc"\n' +
    '                          property="Desc" key="Code"\n' +
    '                          selected="model.data.Result"\n' +
    '                          show-caret="true"\n' +
    '                          dropdown-height="156"\n' +
    '                          class="modal-dropdown"\n' +
    '                          hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15" ng-if="!model.disabledSide">\n' +
    '        <div class="col-20 text-right section-title">\n' +
    '          <label class="bold">Side:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-25">\n' +
    '          <dropdown-menu placeholder="Side"\n' +
    '                         list="model.config.Side.Options"\n' +
    '                         select-mode="true"\n' +
    '                         display-property="Desc"\n' +
    '                         property="Desc" key="Code"\n' +
    '                         selected="model.data.Side"\n' +
    '                         show-caret="true"\n' +
    '                         dropdown-height="156"\n' +
    '                         class="modal-dropdown"\n' +
    '                         hide-other-dropdown="true">\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-20 text-right section-title history-record-notes-title">\n' +
    '          <label class="bold">Notes:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-80">\n' +
    '          <textarea no-new-line inputValue="model.data.Notes" class="history-record-notes w-100" ng-model="model.data.Notes" rows="3"></textarea>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row m-t-25">\n' +
    '        <div class="col-33 padding-right">\n' +
    '          <button ng-if="model.editMode"\n' +
    '                  class="button button-assertive button-block"\n' +
    '                  ng-click="model.delete();">\n' +
    '            Remove\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-33 padding-horizontal">\n' +
    '          <button class="button button-positive button-block"\n' +
    '                  ng-click="model.save();">\n' +
    '            Save\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-33 padding-left">\n' +
    '          <button class="button button-stable button-block back-btn"\n' +
    '                  ng-click="model.closeWindow();">\n' +
    '            Cancel\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/historyTabScrollTemplate.html',
    '\n' +
    '    <div class="h-100">\n' +
    '        <div class="row no-padding" ng-repeat="item in col">\n' +
    '          <div class="col no-padding">\n' +
    '            <div class="row">\n' +
    '              <div class="col right-history-item">\n' +
    '                <label class="tab-header details-list-header list-item-editable item-transparent lb-add__history_Item item no-padding">\n' +
    '                  <button id="{{item.Id}}" type="button" class="icon circle-icon small-circle-icon ion-ios-plus-empty" ng-click="vm.openRightHistoryRecord(item)"\n' +
    '                    ng-disabled="vm.isViewOnly || vm.techpadConfig.settings.FamilyTreeEnabled && (item.Type == \'Cancer\' || item.Type == \'BRCA\') && !vm.familyTreeEnabledCodeObject[item.Id]">\n' +
    '                  </button>\n' +
    '                </label>\n' +
    '                <label data-label-id="{{item.Id}}" class="title__history_item">\n' +
    '                  <button type="button" \n' +
    '                          ng-click="vm.openRightHistoryRecord(item)" \n' +
    '                          ng-class="{\'disabled-history-tab-label\': vm.isViewOnly || vm.techpadConfig.settings.FamilyTreeEnabled && (item.Type == \'Cancer\' || item.Type == \'BRCA\') && !vm.familyTreeEnabledCodeObject[item.Id]}"\n' +
    '                          ng-disabled="vm.isViewOnly || vm.techpadConfig.settings.FamilyTreeEnabled && (item.Type == \'Cancer\' || item.Type == \'BRCA\') && !vm.familyTreeEnabledCodeObject[item.Id]">\n' +
    '                    {{item.Type !== \'BRCA\' ? item.Caption : vm.techpadConfig.settings.PatientHistoryDynamicLabels.FamilyBrcaCaption}}\n' +
    '                  </button>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '              <div class="col right-history-item">\n' +
    '                <label class="checkbox__history_Item left" ng-if="item.hasNone">\n' +
    '                  <label class="checkbox"\n' +
    '                         ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                    <input type="checkbox" \n' +
    '                      ng-class="{\'disabled-history-tab-сheckbox\': vm.isViewOnly || vm.isDisableNoneCheckbox(item.Id) || vm.techpadConfig.settings.FamilyTreeEnabled && (item.Type == \'Cancer\' || item.Type == \'BRCA\') && !vm.familyTreeEnabledCodeObject[item.Id]}"\n' +
    '                      ng-change="vm.noneCheckboxChange(item.Id)" ng-model="(vm.rightHistoryData | filter:{ name: item.Id}:true)[0].none"\n' +
    '                      ng-disabled="vm.isViewOnly || vm.isDisableNoneCheckbox(item.Id) || vm.techpadConfig.settings.FamilyTreeEnabled && (item.Type == \'Cancer\' || item.Type == \'BRCA\') && !vm.familyTreeEnabledCodeObject[item.Id]">\n' +
    '                  </label>\n' +
    '                  <span ng-class="{\'disabled-history-tab-label\': vm.isViewOnly || vm.isDisableNoneCheckbox(item.Id) || vm.techpadConfig.settings.FamilyTreeEnabled && (item.Type == \'Cancer\' || item.Type == \'BRCA\') && !vm.familyTreeEnabledCodeObject[item.Id]}">None</span>\n' +
    '                </label>\n' +
    '                <label class="checkbox__history_Item" ng-if="item.hasUnknown">\n' +
    '                  <label class="checkbox"\n' +
    '                         ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                    <input type="checkbox" \n' +
    '                      ng-class="{\'disabled-history-tab-сheckbox\': vm.isViewOnly || vm.isDisableNoneCheckbox(item.Id) || vm.techpadConfig.settings.FamilyTreeEnabled && (item.Type == \'Cancer\' || item.Type == \'BRCA\') && !vm.familyTreeEnabledCodeObject[item.Id]}"\n' +
    '                      ng-model="(vm.rightHistoryData | filter:{ name: item.Id}:true)[0].unknown"\n' +
    '                      ng-change="vm.unknownCheckboxChange(item.Id)" ng-disabled="vm.isViewOnly || vm.isDisableUnknowCheckbox(item.Id) || vm.techpadConfig.settings.FamilyTreeEnabled && (item.Type == \'Cancer\' || item.Type == \'BRCA\') && !vm.familyTreeEnabledCodeObject[item.Id]">\n' +
    '                  </label>\n' +
    '                  <span ng-class="{\'disabled-history-tab-label\': vm.isViewOnly || vm.isDisableNoneCheckbox(item.Id) || vm.techpadConfig.settings.FamilyTreeEnabled && (item.Type == \'Cancer\' || item.Type == \'BRCA\') && !vm.familyTreeEnabledCodeObject[item.Id]}">Unknown</span>\n' +
    '                </label>\n' +
    '                <div class="sub-list-item-editable" ng-repeat="itemData in vm.rightHistoryData | filter:{ name: item.Id}:true">\n' +
    '                  <div class="sub-list-item-editable" ng-repeat="record in itemData.data | filter:{ IsDeleted: \'!true\'}">\n' +
    '                    <button type="button" class="icon border-less ion-edit" ng-click="vm.openRightHistoryRecord(item, record)"\n' +
    '                      ng-disabled="vm.isViewOnly || vm.techpadConfig.settings.FamilyTreeEnabled && (item.Type == \'Cancer\' || item.Type == \'BRCA\') && !vm.familyTreeEnabledCodeObject[item.Id]"></button>\n' +
    '                    {{record.Description}}\n' +
    '                  </div>\n' +
    '                  <div class="sub-list-item-editable" ng-repeat="path in itemData.pathText">\n' +
    '                    <button type="button" class="icon border-less ion-edit ion-edit-disabled" disabled="disabled" ng-show="!vm.isViewOnly && !(vm.techpadConfig.settings.FamilyTreeEnabled && (item.Type == \'Cancer\' || item.Type == \'BRCA\') && !vm.familyTreeEnabledCodeObject[item.Id])"></button>\n' +
    '                    {{path}}\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="container-with-padding">\n' +
    '           &nbsp;\n' +
    '         </div>\n' +
    '    </div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/imagePreview.html',
    '<div class="modal image-preview-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h1 class="title">Image Preview</h1>\n' +
    '    <div class="button button-clear" ng-click="modal.remove()"><span class="icon ion-close"></span></div>\n' +
    '  </header>\n' +
    '  <content has-header="true">\n' +
    '    <div class="inner-content">\n' +
    '      <ion-scroll zooming="true" direction="xy" overflow-scroll="false">\n' +
    '        <div class="image-wrapper">\n' +
    '          <img ng-src="images/real-images/{{imageName}}.png"/>\n' +
    '        </div>\n' +
    '      </ion-scroll>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/implantsEditDialog.html',
    '<div class="modal modal-form">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      Edit Implants\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="padding">\n' +
    '    <!--<div class="inner-content connection-lost-message" ng-show="model.needRefresh">\n' +
    '      Unable to load data due to network problem. Please check your network settings. Data will be loaded when network\n' +
    '      is back.\n' +
    '      <button class="button button-stable button-block back-btn close-fu-warning" ng-click="model.close()"> OK</button>\n' +
    '    </div>-->\n' +
    '    <div class="inner-content" ng-show="!model.needRefresh">\n' +
    '\n' +
    '      <div class="row">\n' +
    '        <div class="col col-50">\n' +
    '          <h4 class="implants-label" ng-if="model.data.SameInBoth == \'True\'">Both Breasts</h4>\n' +
    '          <h4 class="implants-label" ng-if="model.data.SameInBoth != \'True\'">Right Breast</h4>\n' +
    '          <div>\n' +
    '            <div class="row" ng-repeat="item in model.rightImplants"\n' +
    '                 ng-click="model.toggleRightImplant(item)">\n' +
    '              <label class="checkbox">\n' +
    '                <input type="checkbox" ng-checked="model.hasImplant(item)"/>\n' +
    '              </label>\n' +
    '              <div class="checkbox-label" role="button">\n' +
    '                {{ item.Label || item.Lable }}\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col col-50 implants-label" ng-show="model.data.SameInBoth != \'True\'">\n' +
    '          <h4 class="implants-label">Left Breast</h4>\n' +
    '          <div>\n' +
    '            <div class="row" role="button" ng-repeat="item in model.leftImplants"\n' +
    '                 ng-click="model.toggleLeftImplant(item)">\n' +
    '              <label class="checkbox">\n' +
    '                <input type="checkbox" ng-checked="model.hasImplant(item)"/>\n' +
    '              </label>\n' +
    '              <div class="checkbox-label">\n' +
    '                {{ item.Label || item.Lable }}\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <br/>\n' +
    '      <div class="row">\n' +
    '        <div class="col">\n' +
    '          <div class="row" ng-click="model.toggleBothSide();" role="button">\n' +
    '            <label class="checkbox">\n' +
    '              <input type="checkbox" ng-checked="model.data.SameInBoth == \'True\'"/>\n' +
    '            </label>\n' +
    '            <div class="checkbox-label">Implants are the same in both breasts</div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <br/>\n' +
    '      <div class="row">\n' +
    '        <div class="col-50 padding-right">\n' +
    '          <button class="button button-positive button-block"\n' +
    '                  ng-click="model.save();">\n' +
    '            Save\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-50 padding-left">\n' +
    '          <button class="button button-stable button-block back-btn"\n' +
    '                  ng-click="model.closeWindow();">\n' +
    '            Cancel\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/inputDropdown.html',
    '<div class="input-dropdown {{disableenter}}">\n' +
    '  <div ng-click="showDropdown = !showDropdown"\n' +
    '       class="multiselect-container {{containerclass}}">\n' +
    '    <input ng-if="!disableenter"\n' +
    '           class="flag-input"\n' +
    '           ng-model="model.Flag"\n' +
    '           ng-disabled="isViewOnly"\n' +
    '           ng-click="showDropdown = !showDropdown" />\n' +
    '    <div ng-if="!!disableenter"\n' +
    '         class="selected_field">\n' +
    '      {{ selectedString }}\n' +
    '    </div>\n' +
    '    <div ng-if="list && list.length"\n' +
    '         class="dropdown-icon">\n' +
    '      <div ng-class="{\'fa fa-caret-down\': !showDropdown, \'fa fa-caret-up\': showDropdown}"></div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div ng-if="list && list.length"\n' +
    '       class="item-list w-100"\n' +
    '       ng-class="{\'show\': showDropdown }"\n' +
    '       on-scroll="preventScroll($event)">\n' +
    '    <ul>\n' +
    '      <li ng-repeat="item in list"\n' +
    '          class="dropdown-item"\n' +
    '          ng-class="{\'selected\': model[modelproperty].toLowerCase().includes(item[propertyvalue].toLowerCase())}">\n' +
    '        <div ng-click="onItemSelected($event, item)">\n' +
    '          {{item[property]}}</div>\n' +
    '      </li>\n' +
    '    </ul>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/ionic-datepicker-modal.html',
    '<ion-modal-view class="ionic_datepicker_modal">\n' +
    '  <ion-header-bar class="header">\n' +
    '    <h1 class="title">{{selctedDateEpoch | date : mainObj.dateFormat}}</h1>\n' +
    '  </ion-header-bar>\n' +
    '  <ion-content class="ionic_datepicker_modal_content">\n' +
    '    <div class="">\n' +
    '      <div class="row text-center">\n' +
    '        <div class="col col-10 left_arrow" ng-click="prevMonth()">\n' +
    '          <button class="button-clear font_22px"\n' +
    '                  ng-class="{\'pointer_events_none\':((firstDayEpoch - 86400000) < fromDate)}">\n' +
    '            <i class="icon ion-chevron-left"></i>\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col col-80 text-center">\n' +
    '          <div class="row select_section">\n' +
    '            <div class="col col-50 padding_right_5px">\n' +
    '              <label class="item item-input item-select month_select">\n' +
    '                <span class="input-label">&nbsp;</span>\n' +
    '                <select ng-model="data.currentMonth" ng-change="monthChanged(data.currentMonth)">\n' +
    '                  <option ng-repeat="month in monthsList" ng-selected="month == data.currentMonthSelected"\n' +
    '                          value="{{month}}">\n' +
    '                    {{month}}\n' +
    '                  </option>\n' +
    '                </select>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="col col-50 padding_left_5px">\n' +
    '              <label class="item item-input item-select year_select">\n' +
    '                <span class="input-label">&nbsp;</span>\n' +
    '                <select ng-model="data.currentYear" ng-change="yearChanged(data.currentYear)"\n' +
    '                        ng-options="year for year in yearsList | reverse"></select>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col col-10 right_arrow" ng-click="nextMonth()">\n' +
    '          <button class=" button-clear font_22px"\n' +
    '                  ng-class="{\'pointer_events_none\':((lastDayEpoch + 86400000)> toDate)}">\n' +
    '            <i class="icon ion-chevron-right"></i>\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="calendar_grid">\n' +
    '        <div class="row padding-top weeks_row">\n' +
    '          <div class="col text-center font_bold"\n' +
    '               ng-repeat="weekName in weeksList track by $index" ng-bind="weekName"></div>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '          <div class="row text-center padding_top_zero" ng-repeat="row in rows track by $index">\n' +
    '            <div class="col padding_zero date_col" ng-repeat="col in cols track by $index"\n' +
    '                 ng-class="{\'selected_date\': (dayList[row + $index].epoch === selctedDateEpoch),\n' +
    '                      \'today\' : (dayList[row + $index].epoch == today),\n' +
    '                      \'pointer_events_none\':((disabledDates.indexOf(dayList[row + $index].epoch) >= 0) || (dayList[row + $index].disabled))}"\n' +
    '                 ng-click="dateSelected(dayList[row + $index])">\n' +
    '              <div class="date_cell">\n' +
    '                {{dayList[row + col].date}}\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '  <ion-footer-bar class="footer">\n' +
    '    <div class="row padding_zero">\n' +
    '      <button class="button button-clear button-block button_set" ng-if="!mainObj.closeOnSelect"\n' +
    '              ng-click="setIonicDatePickerDate()">{{mainObj.setLabel}}\n' +
    '      </button>\n' +
    '      <button class="button button-clear button-block button_today" ng-if="mainObj.showTodayButton"\n' +
    '              ng-click="setIonicDatePickerTodayDate()">{{mainObj.todayLabel}}\n' +
    '      </button>\n' +
    '      <button class="button button-clear button-block button_close"\n' +
    '              ng-click="closeIonicDatePickerModal()">{{mainObj.closeLabel}}\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </ion-footer-bar>\n' +
    '</ion-modal-view>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/ionic-datepicker-popup.html',
    '<div class="selected_date_full" ng-class="{\'dark-mode\': mainObj.darkMode}">{{selctedDateEpoch | date : mainObj.dateFormat}}</div>\n' +
    '<div class="date_selection">\n' +
    '  <div class="row show_nav">\n' +
    '    <div class="col col-10 prev_btn_section col-center" ng-click="prevMonth()">\n' +
    '      <button class="button-clear"\n' +
    '              ng-class="{\'pointer_events_none\':((firstDayEpoch - 86400000) < fromDate)}">\n' +
    '        <i class="icon ion-chevron-left"></i>\n' +
    '      </button>\n' +
    '    </div>\n' +
    '    <div class="col col-80 month_year_section text-center">\n' +
    '      <div class="row select_section">\n' +
    '        <div class="col col-50 padding_right_5px">\n' +
    '          <dropdown-menu class="modal-dropdown"\n' +
    '                         dropdown-class="datepicker-dropdown"\n' +
    '                         select-mode="true"\n' +
    '                         selected="data.currentMonth"\n' +
    '                         list="monthsList"\n' +
    '                         hide-clean-button="true"\n' +
    '                         on-selection-change="monthChanged($type)"></dropdown-menu>\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '        <div class="col col-50 padding_left_5px">\n' +
    '          <dropdown-menu class="modal-dropdown"\n' +
    '                         dropdown-class="datepicker-dropdown"\n' +
    '                         select-mode="true"\n' +
    '                         selected="data.currentYear"\n' +
    '                         list="yearsList"\n' +
    '                         hide-clean-button="true"\n' +
    '                         on-selection-change="yearChanged($type)"></dropdown-menu>\n' +
    '          </dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col col-10 next_btn_section col-center" ng-click="nextMonth()">\n' +
    '      <button class="button-clear"\n' +
    '              ng-class="{\'pointer_events_none\':((lastDayEpoch + 86400000)> toDate)}">\n' +
    '        <i class="icon ion-chevron-right"></i>\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="calendar_grid">\n' +
    '    <div class="row weeks_row">\n' +
    '      <div class="col text-center font_bold"\n' +
    '           ng-repeat="weekName in weeksList track by $index" ng-bind="weekName"></div>\n' +
    '    </div>\n' +
    '    <div>\n' +
    '      <div class="row text-center padding_zero" ng-repeat="row in rows track by $index">\n' +
    '        <div class="col no_padding date_col" ng-repeat="col in cols track by $index"\n' +
    '             ng-class="{\'selected_date\': (dayList[row + $index].epoch === selctedDateEpoch),\n' +
    '                      \'today\' : (dayList[row + $index].epoch == today),\n' +
    '                      \'pointer_events_none\':((disabledDates.indexOf(dayList[row + $index].epoch) >= 0) || dayList[row + $index].disabled)}"\n' +
    '             ng-click="dateSelected(dayList[row + $index])">\n' +
    '          <div class="date_cell">\n' +
    '            {{dayList[row + col].date}}\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/linkedStudiesWindow.html',
    '<div class="modal worklist-exam-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h1 class="title">\n' +
    '      <div class="name-wrapper">\n' +
    '        <div ng-if="model.worklist.FirstName || model.worklist.LastName" data-fittext data-fittext-min="15"\n' +
    '             data-fittext-max="30">\n' +
    '          Link Studies ({{model.worklist.FirstName | camelize}} {{model.worklist.LastName | camelize}})\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </h1>\n' +
    '    <div class="button button-clear" ng-click="modal.hide()"><span class="icon ion-close"></span></div>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="padding">\n' +
    '    <div class="inner-content linking-items">\n' +
    '      <span class="validation-message" ng-if="model.isShowPrimaryValidation">Please select Primary exam</span>\n' +
    '      <ion-scroll ng-if="model.isIOSDevice" class="link-studies-scroll" zooming="false" direction="y">\n' +
    '        <ng-include src="\'views/templates/linkedStudiesWindowScrollTemplate.html\'"></ng-include>\n' +
    '      </ion-scroll>\n' +
    '      <div ng-if="!model.isIOSDevice" class="scroll-y link-studies-scroll">\n' +
    '        <ng-include src="\'views/templates/linkedStudiesWindowScrollTemplate.html\'"></ng-include>\n' +
    '      </div>\n' +
    '      <div ng-class="{\'bottom-row\':model.studies.length < 4}" class="row">\n' +
    '        <div class="col-45">\n' +
    '          <button class="button button-block button-dark" ng-click="model.saveLinked(modal);">\n' +
    '            Save Changes\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-45 col-offset-10">\n' +
    '          <button class="button button-block button-stable" ng-click="modal.hide();">\n' +
    '            Cancel\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/linkedStudiesWindowScrollTemplate.html',
    '<div class="row" ng-repeat="study in model.studies">\n' +
    '    <div ng-class="{\'strong\': study.isPrimary}" class="col-50">\n' +
    '      {{study.StudyDate | date:\'MM/dd/yyyy\'}} ({{study.Accession}})<br>\n' +
    '      <span ng-repeat="p in study.Procedures">\n' +
    '        <span ng-if="$index > 0">, </span>{{p.Name}} {{model.getSide(p.Side)}}\n' +
    '      </span>\n' +
    '    </div>\n' +
    '    <div class="col-25">\n' +
    '      <button ng-click="model.togglePrimary(study)" ng-class="{\'button-balanced\': study.isPrimary}"\n' +
    '              class="button button-light button-block">Primary\n' +
    '      </button>\n' +
    '    </div>\n' +
    '    <div class="col-25">\n' +
    '      <button ng-click="model.toggleLinked(study)" ng-class="{\'button-balanced\': study.isLinked}"\n' +
    '            class="button button-block">Link\n' +
    '      </button>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/multiRadioDetailsDialogModel.html',
    '<div class="modal modal-form multi-select-form gene-results-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      {{model.title}}\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="form-page" class="padding no-scroll">\n' +
    '\n' +
    '    <div zooming="false" direction="y" class="gene-items scroll multi-select-options-container">\n' +
    '      <ng-include src="\'views/templates/multiRadioDetailsTemplate.html\'"></ng-include>\n' +
    '    </div>\n' +
    '\n' +
    '  </content>\n' +
    '\n' +
    '  <footer class="bar bar-footer">\n' +
    '    <div class="row">\n' +
    '      <div class="col col-50">\n' +
    '        <button class="button button-positive button-block" ng-click="model.ok()">OK</button>\n' +
    '      </div>\n' +
    '      <div class="col col-50">\n' +
    '        <button class="button button-light button-cancel button-block" ng-click="model.cancel()">CANCEL</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </footer>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/multiRadioDetailsTemplate.html',
    '<div class="row item item-text-wrap dropdown-result title-item ng-binding sticky-header">\n' +
    '  <div class="col-40 align-items-center d-flex multiradio-column first-column">\n' +
    '    <b>Name</b>\n' +
    '  </div>\n' +
    '  <div class="col-15 align-items-center justify-content-center d-flex multiradio-column"\n' +
    '       ng-class="{\'bold\': column.Important}"\n' +
    '       ng-repeat="column in model.multiRadioProperty.Columns | orderBy:model.defaultSortingPropery">\n' +
    '    <b>{{column.Caption}}</b>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<div class="row item align-items-center justify-content-center d-flex"\n' +
    '     ng-repeat="option in model.multiRadioProperty.Options | orderBy:model.defaultSortingPropery">\n' +
    '  <label class="col-40 yesno-label mr-0 mt-0 ml-0 fs-16 multiradio-option"\n' +
    '         ng-class="{ \'bold\': option.Important,\n' +
    '                     \'green-colored bold\': option.Response === \'2\',\n' +
    '                     \'red-colored bold\': option.Response === \'1\',\n' +
    '                     \'grey-colored bold\': option.Response === \'0\',\n' +
    '                     \'orange-colored bold\': option.Response === \'3\' }">\n' +
    '    {{option.Caption}}\n' +
    '  </label>\n' +
    '  <div class="col-15 item align-items-center justify-content-center d-flex multi-select-option"\n' +
    '       ng-repeat="suboption in option.Options | orderBy:model.defaultSortingPropery">\n' +
    '    <label class="checkbox pull-left">\n' +
    '      <input type="checkbox"\n' +
    '             ng-checked="model.geneticCouncelingMultiradioChecked(model.multiRadioProperty.Options, option, suboption)"\n' +
    '             ng-click="model.geneticCouncelingMultiradioClick(model.multiRadioProperty.Options, option, suboption)" />\n' +
    '    </label>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/networkStatusChecker.html',
    '<button id="status-btn" class="button button-clear button-online-status"\n' +
    '        ng-class="{\'button-balanced\': isOnline(), \'button-assertive\': !isOnline()}"\n' +
    '        ng-click="tryReconnectAgain()">\n' +
    '  <div ng-if="isOnline()">ONLINE</div>\n' +
    '  <div ng-if="!isOnline()">\n' +
    '    <div class="error toggle-text1">OFFLINE</div>\n' +
    '    <div class="info toggle-text2">CLICK TO RECONNECT</div>\n' +
    '  </div>\n' +
    '</button>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/outsideStudyDetailsScrollTemplate.html',
    '<div class="row">\n' +
    '    <div class="col-100">\n' +
    '      <label class="item tab-header item-transparent">\n' +
    '        <b>Exam Date</b>\n' +
    '        <hr/>\n' +
    '      </label>\n' +
    '      <div class="item item-text-wrap item-transparent">\n' +
    '        {{vm.currentStudy.Date | date: \'MM/dd/yyyy\'}}\n' +
    '        <button class="button button-default button-small button-icon icon button-change-date ion-calendar" ng-click="vm.changeDate()"></button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row second-row second-dropdown-container">\n' +
    '    <div class="col-100">\n' +
    '      <div class="item tab-header details-list-header item-transparent item-dropdown-header">\n' +
    '        <div class="dropdown-display">\n' +
    '          <span class="placeholder text-bold">\n' +
    '            Select Location\n' +
    '          </span>\n' +
    '          <div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '          <dropdown-menu placeholder=""\n' +
    '                         list="vm.locations"\n' +
    '                         property="Value"\n' +
    '                         key="Key"\n' +
    '                         on-selection-change="vm.changeOtherStudyLocation($type)"\n' +
    '                         hide-selected-value="true"></dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="item item-text-wrap item-transparent">\n' +
    '        {{vm.getLabel(vm.currentStudy.Loc_num, vm.locations)}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row second-row">\n' +
    '    <div class="col-100">\n' +
    '      <label class="item tab-header item-transparent">\n' +
    '        <b>Location Name</b>\n' +
    '        <hr/>\n' +
    '      </label>\n' +
    '      <div class="item item-text-wrap item-transparent input-text-wrapper">\n' +
    '          <input ng-hide="!!vm.currentStudy.Loc_num" type="text" placeholder="Location Name"\n' +
    '                 ng-model="vm.currentStudy.Locname">\n' +
    '          <input ng-show="!!vm.currentStudy.Loc_num" type="text"\n' +
    '                 placeholder="{{vm.getLabel(vm.currentStudy.Loc_num, vm.locations)}}" ng-disabled="true">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row second-row second-dropdown-container">\n' +
    '    <div class="col-100">\n' +
    '      <div class="item tab-header details-list-header item-transparent item-dropdown-header">\n' +
    '        <div class="dropdown-display">\n' +
    '          <span class="placeholder text-bold">\n' +
    '            Procedure Type\n' +
    '            <div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '          </span>\n' +
    '          <dropdown-menu placeholder=""\n' +
    '                         list="vm.procTypes"\n' +
    '                         property="Value"\n' +
    '                         key="Key"\n' +
    '                         icon="ion-ios-arrow-right"\n' +
    '                         on-selection-change="vm.changeOtherStudyProcedureType($type)"\n' +
    '                         hide-selected-value="true"></dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="item item-text-wrap item-transparent">\n' +
    '        {{vm.getLabel(vm.currentStudy.Proctype, vm.procTypes)}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row second-row">\n' +
    '    <div class="col-100">\n' +
    '      <div class="item tab-header details-list-header item-transparent item-dropdown-header">\n' +
    '        <div class="dropdown-display">\n' +
    '            <span class="placeholder text-bold">\n' +
    '              Exam Reason\n' +
    '            </span>\n' +
    '          <div class="icon circle-icon ion-ios-arrow-right"></div>\n' +
    '          <dropdown-menu placeholder=""\n' +
    '                         list="vm.viewsTypes"\n' +
    '                         property="Value"\n' +
    '                         key="Key"\n' +
    '                         icon="ion-ios-arrow-right"\n' +
    '                         on-selection-change="vm.changeOtherStudyExamReason($type)"\n' +
    '                         hide-selected-value="true"></dropdown-menu>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="item item-text-wrap item-transparent">\n' +
    '        {{vm.getLabel(vm.currentStudy.Scr_pro, vm.viewsTypes)}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row second-row">\n' +
    '    <div class="col-100">\n' +
    '      <label class="item tab-header item-transparent">\n' +
    '        <b>Results</b>\n' +
    '        <hr/>\n' +
    '      </label>\n' +
    '      <div class="item item-text-wrap item-transparent input-text-wrapper">\n' +
    '        <!-- <label class="item item-input"> -->\n' +
    '          <input type="text" placeholder="Results" ng-model="vm.currentStudy.Result"/>\n' +
    '        <!-- </label> -->\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>\n' +
    '<div class="container-with-padding">\n' +
    '    &nbsp;\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/outsideStudyScrollTemplate.html',
    '<ion-item ng-repeat="study in vm.studies | orderBy:\'-Date\'" ng-class="{active: vm.isActive(study)}"\n' +
    '    ng-click="vm.selectStudy(study, true)" class="outside-study outside-study-list">\n' +
    '    <div class="ripple w-100">\n' +
    '        {{study.Date | date:\'MM/dd/yyyy\'}} -\n' +
    '        {{study.Locname}}\n' +
    '        {{vm.getLabel(study.Loc_num, vm.locations)}} -\n' +
    '        {{vm.getLabel(study.Scr_pro, vm.viewsTypes)}}\n' +
    '        {{vm.getLabel(study.Proctype, vm.procTypes)}}\n' +
    '    </div>\n' +
    '</ion-item>\n' +
    '<div class="container-with-padding">\n' +
    '    &nbsp;\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/patientDetailsDialog.html',
    '<div class="modal document-modal">\n' +
    '    <header class="bar bar-header bar-dark">\n' +
    '      <h1 class="title title-left">\n' +
    '        {{vm.patient.FirstName}} {{vm.patient.LastName}}\n' +
    '      </h1>\n' +
    '      <div class="buttons right-buttons">\n' +
    '        <button class="button button-icon ion-close" ng-click="vm.checkIfModelChanged(modal)"></button>\n' +
    '      </div>\n' +
    '\n' +
    '    </header>\n' +
    '    <content ng-if="vm.isIOSDevice" has-header="true" class="content">\n' +
    '      <ion-view class="patient-info">\n' +
    '        <div class="patient-info-content">\n' +
    '          <div class="col m-t-90">\n' +
    '          </div>\n' +
    '          <div class="card form-page">\n' +
    '            <ng-include src="\'views/patientDetails/patientDetails.html\'"></ng-include>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </ion-view>\n' +
    '    </content>\n' +
    '    <div ng-if="!vm.isIOSDevice" has-header="true" class="content">\n' +
    '      <div class="patient-info">\n' +
    '        <div class="patient-info-content">\n' +
    '          <div class="col">\n' +
    '          </div>\n' +
    '          <div class="card form-page">\n' +
    '            <ng-include src="\'views/patientDetails/patientDetails.html\'"></ng-include>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="app-version-right-bottom app-version-overflow">\n' +
    '      <app-version></app-version>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/patientDetailsScrollTempate.html',
    '<form class="custom-form">\n' +
    '    <div class="row wider-scroll-area">\n' +
    '      <div class="col-50 form-cols">\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label"\n' +
    '               ng-class="{\'border-bottom-danger-child\': (vm.showValidationErrors && !vm.patient.LastName)}">\n' +
    '            <label class="item">\n' +
    '              <b>Last</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <input type="text" ng-model="vm.patient.LastName" ng-disabled="vm.isViewOnly"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label"\n' +
    '               ng-class="{\'border-bottom-danger-child\': (vm.showValidationErrors && !vm.patient.FirstName)}">\n' +
    '            <label class="item">\n' +
    '              <b>First</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <input type="text" ng-model="vm.patient.FirstName" ng-disabled="vm.isViewOnly"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label"\n' +
    '               ng-class="{\'border-bottom-danger-child\': (vm.showValidationErrors && !vm.patient.DOB)}">\n' +
    '            <label class="item">\n' +
    '              <b>DOB</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-33">\n' +
    '            <label class="item item-input item-text-wrap item-transparent">\n' +
    '            <span ng-if="vm.patient && vm.patient.DOB">\n' +
    '                {{vm.patient.DOB | date: \'MM/dd/yyyy\'}}\n' +
    '            </span>\n' +
    '              <span ng-if="!vm.patient || !vm.patient.DOB">\n' +
    '                MM/dd/yyyy\n' +
    '            </span>\n' +
    '              <button type="button"\n' +
    '                      class="button button-default button-small button-icon min-h-ini icon ion-calendar" \n' +
    '                      ng-click="vm.changeDate()" \n' +
    '                      ng-disabled="vm.isViewOnly"></button>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-33">\n' +
    '            <label class="item">\n' +
    '              <b>Age</b> {{vm.getAge()}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label"\n' +
    '               ng-class="{\'border-bottom-danger-child\': (vm.showValidationErrors && !vm.patient.Sex)}">\n' +
    '            <label class="item">\n' +
    '              <b>Gender</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <label class="checkbox pull-left">\n' +
    '                <input type="checkbox" ng-model="vm.patient.Sex" value="true" ng-disabled="vm.isViewOnly"\n' +
    '                       ng-true-value="\'M\'"\n' +
    '                       ng-false-value="">\n' +
    '              </label>\n' +
    '              <label class="yesno-label pull-left">Male</label>\n' +
    '              <label class="checkbox pull-left">\n' +
    '                <input type="checkbox" ng-model="vm.patient.Sex" value="false" ng-disabled="vm.isViewOnly"\n' +
    '                       ng-true-value="\'F\'"\n' +
    '                       ng-false-value="">\n' +
    '              </label>\n' +
    '              <label class="yesno-label pull-left">Female</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label"\n' +
    '               ng-class="{\'border-bottom-danger-child\': (vm.showValidationErrors && vm.patient.Email && vm.invalidEmailFormat)}">\n' +
    '            <label class="item">\n' +
    '              <b>Email</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <div class="patient-email-group">\n' +
    '                <input  type="text"\n' +
    '                        class="tbx-patient-email"\n' +
    '                        ng-model="vm.patient.Email"\n' +
    '                        ng-disabled="vm.isViewOnly"\n' +
    '                        ng-change="vm.showValidationErrors && vm.checkEmailFormat()"/>\n' +
    '                <button class="button btn-check-patient-email"\n' +
    '                        ng-disabled="vm.isViewOnly || !vm.isValidEmailFormat(vm.patient.Email) || vm.patientCopy.Email == vm.patient.Email || vm.isCheckingEmailExist"\n' +
    '                        ng-click="vm.checkEmailExist(vm.patient.Email)">Check</button>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label">\n' +
    '            <label class="item">\n' +
    '              <b>Race</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <dropdown-menu placeholder="Select Race"\n' +
    '                             list="vm.races"\n' +
    '                             select-mode="true"\n' +
    '                             key="Key"\n' +
    '                             property="Value"\n' +
    '                             selected="vm.patient.Ethnicity"\n' +
    '                             hide-other-dropdown="true"\n' +
    '                             class="modal-dropdown"\n' +
    '                             ng-if="!vm.isViewOnly"></dropdown-menu>\n' +
    '              <input ng-if="vm.isViewOnly" type="text" disabled\n' +
    '                     ng-value="vm.getLookupByKey(vm.races, vm.patient.Ethnicity).Value"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label">\n' +
    '            <label class="item">\n' +
    '              <b>Language</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <dropdown-menu placeholder="Select Language"\n' +
    '                             list="vm.languages"\n' +
    '                             select-mode="true"\n' +
    '                             key="Key"\n' +
    '                             property="Value"\n' +
    '                             selected="vm.patient.Language"\n' +
    '                             hide-other-dropdown="true"\n' +
    '                             class="modal-dropdown"\n' +
    '                             ng-if="!vm.isViewOnly"></dropdown-menu>\n' +
    '              <input ng-if="vm.isViewOnly" type="text" disabled\n' +
    '                     ng-value="vm.getLookupByKey(vm.languages, vm.patient.Language).Value"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label">\n' +
    '            <label class="item">\n' +
    '              <b>Hispanic</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <label class="checkbox pull-left">\n' +
    '                <input type="checkbox" ng-model="vm.patient.IsHispanic" value="true" ng-disabled="vm.isViewOnly">\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row" \n' +
    '             ng-if="vm.techpadSettings.IsRiskOptOut">\n' +
    '          <div class="col col-33 label">\n' +
    '            <label class="item">\n' +
    '              <b>Opt Out of Risk</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <label class="checkbox pull-left">\n' +
    '                <input type="checkbox" \n' +
    '                       ng-model="vm.patient.IsRiskOptOut" \n' +
    '                       value="false" \n' +
    '                       ng-disabled="vm.isViewOnly"\n' +
    '                       ng-true-value="true"\n' +
    '                       ng-false-value=""\n' +
    '                       ng-change="vm.techpadSettings.IsRiskOOWarn && vm.patient.IsRiskOptOut && vm.showRiskOOWarn()">\n' +
    '              </label>\n' +
    '              <label class="yesno-label pull-left">Yes</label>\n' +
    '              <label class="checkbox pull-left">\n' +
    '                <input type="checkbox" \n' +
    '                       ng-model="vm.patient.IsRiskOptOut" \n' +
    '                       value="false" \n' +
    '                       ng-disabled="vm.isViewOnly"\n' +
    '                       ng-true-value="false"\n' +
    '                       ng-false-value="">\n' +
    '              </label>\n' +
    '              <label class="yesno-label pull-left">No</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label">\n' +
    '            <label class="item">\n' +
    '              <b>RP</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="row">\n' +
    '              <div class="col col-20">\n' +
    '                <label class="item">\n' +
    '                  <button type="button"\n' +
    '                          class="button button-default button-small button-icon icon button-change-date ion-edit"\n' +
    '                          ng-click="vm.editRefPhy();"\n' +
    '                          ng-disabled="vm.isViewOnly"></button>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '                <div class="col">\n' +
    '                <ion-scroll ng-if="vm.isIOSDevice" class="scroll-y h-125" overflow-scroll="false">\n' +
    '                    <ng-include src="\'views/templates/refferingPhysicianListTemplate.html\'"></ng-include>\n' +
    '                </ion-scroll>\n' +
    '                <div ng-if="!vm.isIOSDevice" class="scroll-y-auto scroll h-125">\n' +
    '                    <ng-include src="\'views/templates/refferingPhysicianListTemplate.html\'"></ng-include>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '      <div class="col-50 form-cols">\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label">\n' +
    '            <label class="item">\n' +
    '              <b>Street 1</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <input type="text" ng-model="vm.patient.Street" ng-disabled="vm.isViewOnly"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label">\n' +
    '            <label class="item">\n' +
    '              <b>Street 2</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <input type="text" ng-model="vm.patient.Street2" ng-disabled="vm.isViewOnly"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label">\n' +
    '            <label class="item">\n' +
    '              <b>State</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <dropdown-menu placeholder="Select State"\n' +
    '                             list="vm.statesList"\n' +
    '                             select-mode="true"\n' +
    '                             property="name" key="code"\n' +
    '                             dropdown-height="225"\n' +
    '                             show-caret="true"\n' +
    '                             selected="vm.patient.State"\n' +
    '                             hide-other-dropdown="true"\n' +
    '                             class="modal-dropdown"\n' +
    '                             on-selection-change="vm.changeState($type)"\n' +
    '                             ng-if="!vm.isViewOnly">\n' +
    '              </dropdown-menu>\n' +
    '              <input class="checkbox-label" ng-disabled="vm.isViewOnly" ng-if="vm.isViewOnly" type="text" ng-value="vm.getStateName(vm.patient.State)"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label">\n' +
    '            <label class="item">\n' +
    '              <b>City</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <dropdown-menu placeholder="Select City"\n' +
    '                             list="vm.citiesList"\n' +
    '                             select-mode="true"\n' +
    '                             property="Name" key="Name"\n' +
    '                             dropdown-height="225"\n' +
    '                             show-caret="true"\n' +
    '                             selected="vm.patient.City"\n' +
    '                             hide-other-dropdown="true"\n' +
    '                             class="modal-dropdown"\n' +
    '                             on-selection-change="vm.changeCity($type)"\n' +
    '                             ng-if="!vm.isViewOnly"\n' +
    '                             disabled="!vm.patient.State"></dropdown-menu>\n' +
    '              <input class="checkbox-label" ng-disabled="vm.isViewOnly" ng-if="vm.isViewOnly" type="text" ng-value="vm.patient.City"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label">\n' +
    '            <label class="item">\n' +
    '              <b>Zip</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <dropdown-menu placeholder="Select Zip"\n' +
    '                             list="vm.zipCodesList"\n' +
    '                             select-mode="true"\n' +
    '                             property="code" key="code"\n' +
    '                             dropdown-height="225"\n' +
    '                             show-caret="true"\n' +
    '                             selected="vm.patient.Zip"\n' +
    '                             hide-other-dropdown="true"\n' +
    '                             class="modal-dropdown"\n' +
    '                             ng-if="!vm.isViewOnly && vm.patient.State && vm.patient.City"></dropdown-menu>\n' +
    '              <!--<input class="checkbox-label" ng-disabled="vm.isViewOnly" ng-if="vm.isViewOnly" type="text"\n' +
    '                     ng-value="vm.patient.Zip"/>-->\n' +
    '              <input type="text" maxlength="5" ng-change="vm.fillStateCity()" ng-model="vm.patient.Zip" oninput="this.value=this.value.replace(/[^0-9]/g,\'\');"\n' +
    '                     ng-disabled="vm.isViewOnly" ng-show="vm.isViewOnly || !vm.patient.State || !vm.patient.City"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label">\n' +
    '            <label class="item">\n' +
    '              <b>Country</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <input type="text" disabled value="USA"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label"\n' +
    '               ng-class="{\'border-bottom-danger-child\': (vm.showValidationErrors && vm.isHomePhoneValid === false)}">\n' +
    '            <label class="item">\n' +
    '              <b>Home</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <input type="text" ng-model="vm.patient.HomePhone" ng-disabled="vm.isViewOnly"\n' +
    '                     ng-change="vm.patient.HomePhone = vm.formatPhoneValue(vm.patient.HomePhone);vm.validatePhoneNumbers();"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label"\n' +
    '               ng-class="{\'border-bottom-danger-child\': (vm.showValidationErrors && vm.isCellPhoneValid === false)}">\n' +
    '            <label class="item">\n' +
    '              <b>Cell</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <input type="text" ng-model="vm.patient.CellPhone" ng-disabled="vm.isViewOnly"\n' +
    '                     ng-change="vm.patient.CellPhone = vm.formatPhoneValue(vm.patient.CellPhone);vm.validatePhoneNumbers();"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label"\n' +
    '               ng-class="{\'border-bottom-danger-child\': (vm.showValidationErrors && vm.isWorkPhoneValid === false)}">\n' +
    '            <label class="item">\n' +
    '              <b>Work</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item">\n' +
    '              <input type="text" ng-model="vm.patient.WorkPhone" ng-disabled="vm.isViewOnly"\n' +
    '                     ng-change="vm.patient.WorkPhone = vm.formatPhoneValue(vm.patient.WorkPhone);vm.validatePhoneNumbers();"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="col col-33 label">\n' +
    '            <label class="item">\n' +
    '              <b>Letter Type</b>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="col col-66">\n' +
    '            <div class="item item-input item-text-wrap item-transparen">\n' +
    '              <dropdown-menu placeholder="Select {{vm.patient.LetterTypeConfig.CAPTION}}"\n' +
    '                             list="vm.patient.LetterTypeConfig.Options"\n' +
    '                             select-mode="true"\n' +
    '                             property="Desc" \n' +
    '                             key="Code"\n' +
    '                             dropdown-height="225"\n' +
    '                             show-caret="true"\n' +
    '                             selected="vm.patient.LetterTypeAnswer.Code"\n' +
    '                             hide-other-dropdown="true"\n' +
    '                             class="modal-dropdown"\n' +
    '                             ng-if="vm.patient.LetterTypeAnswer && !vm.isViewOnly"></dropdown-menu>\n' +
    '              <input class="checkbox-label" ng-disabled="vm.isViewOnly" ng-if="vm.isViewOnly" type="text"\n' +
    '                     ng-value="vm.patient.LetterTypeAnswer.Desc"/>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class = "container-with-padding">&nbsp;</div>\n' +
    '  </form>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/patientListScrollTemplate.html',
    '<ion-list class="list options-list">\n' +
    '  <ion-item ng-if="vm.isSearching" class="text-center">\n' +
    '    Looking for patients...\n' +
    '  </ion-item>\n' +
    '  <ion-item ng-if="!vm.patients.length && !vm.haveSearched && !vm.isSearching" class="text-center">\n' +
    '    Please click \'Search\' to search for patient\n' +
    '  </ion-item>\n' +
    '  <ion-item ng-if="!vm.patients.length && vm.haveSearched" class="text-center">\n' +
    '    No patient matches your search condition. Please try different keyword.\n' +
    '  </ion-item>\n' +
    '  <ion-item ng-repeat="patient in vm.patients" ng-click="goToPatientDetail(patient)">\n' +
    '    {{ !vm.techpadSettings.UseAlternateUserIdentifier ? patient.Ssn : patient.ExternalId}} -\n' +
    '    {{ vm.getPatientDisplayName(patient) }}\n' +
    '    <span ng-if="patient.DOB">({{patient.DOB | date:\'MM/dd/yyyy\'}})</span>\n' +
    '  </ion-item>\n' +
    '</ion-list>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/patientReferringPhysiciansDialog.html',
    '<div class="modal modal-form">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      Referring Physicians\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="padding">\n' +
    '\n' +
    '    <div class="inner-content">\n' +
    '\n' +
    '      <div class="row" data-ng-repeat="index in [0,1,2,3,4,5,6,7,8,9]">\n' +
    '        <div class="col col-33 text-right section-title ref-phy-width">\n' +
    '          <label class="bold">{{index == 0 ? \'Primary Physician\' : \'Other Physician \' + (index + 1)}}</label>\n' +
    '        </div>\n' +
    '        <div class="col">\n' +
    '          <input ion-autocomplete \n' +
    '                 type="text"\n' +
    '                 class="ion-autocomplete underlined full-width"\n' +
    '                 items-method="model.getRefPhyAutocomplete(query, index)"\n' +
    '                 ng-model="model.data[index]"\n' +
    '                 placeholder="Select"\n' +
    '                 item-value-key="RefNum"\n' +
    '                 select-items-label="Select Referring Physician"\n' +
    '                 selected-items-label="Selected Referring Physician"\n' +
    '                 item-view-value-key="DisplayName"\n' +
    '                 items-clicked-method="model.onRefPhySelectionChange(index, callback)"\n' +
    '                 model-to-item-method="model.getRefPhyByKey(modelValue)"\n' +
    '                 external-model="[model.data[index]]"\n' +
    '                 autocomplete="off"\n' +
    '                 max-selected-items="1"\n' +
    '                 template-url="views/templates/selectReferringPhysicianDialog.html"\n' +
    '                 template-data="model.templateData"\n' +
    '                 readonly="readonly" />\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col col-50">\n' +
    '            <button class="button button-positive button-block" ng-click="model.addReferringPhysican();">Add Physician</button>\n' +
    '        </div>\n' +
    '        <div class="col col-50">\n' +
    '            <button class="button button-positive button-block" ng-click="model.save();">Done</button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/refferingPhysicianListTemplate.html',
    '<div ng-repeat="index in [0,1,2,3,4,5,6,7,8,9]" ng-if="vm.patient.ReferringPhysicians[index]">\n' +
    '    {{vm.patient.ReferringPhysicians[index].LastName}}\n' +
    '    {{vm.patient.ReferringPhysicians[index].Suffix}}\n' +
    '    {{vm.patient.ReferringPhysicians[index].FirstName}}\n' +
    '    ({{vm.patient.ReferringPhysicians[index].RefNum.trim()}})\n' +
    '  </div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/refreshWorklistDetailsDialog.html',
    '<div class="modal modal-form refresh-form">\n' +
    '    <header class="bar bar-header bar-dark">\n' +
    '        <h3 class="title">\n' +
    '        Error loading history data\n' +
    '        </h3>\n' +
    '    </header>\n' +
    '    <content has-header="true" class="padding">\n' +
    '        \n' +
    '        <div class="spacer"></div>\n' +
    '    \n' +
    '        <div class="row history-data-message">\n' +
    '            <label class="col">History data could not be loaded. Please refresh.</label>\n' +
    '        </div>\n' +
    '    \n' +
    '        <div class="row">\n' +
    '            <div class="col-50 padding-horizontal">\n' +
    '            <button class="button button-positive button-block"\n' +
    '                    ng-click="model.refreshCall()">\n' +
    '                Refresh\n' +
    '            </button>\n' +
    '            </div>\n' +
    '            <div class="col-50 padding-horizontal">\n' +
    '            <button class="button button-stable button-block back-btn"\n' +
    '                    ng-click="model.closeWindow()">\n' +
    '                Close\n' +
    '            </button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    \n' +
    '    </content>\n' +
    '</div>\n' +
    '      ');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/resolveFollowUp.html',
    '<div class="item item-transparent follow-up-details">\n' +
    '  <div class="row title-section">\n' +
    '    <div>\n' +
    '      <h2>Follow-up Details</h2>\n' +
    '    </div>\n' +
    '    <div class="small-buttons-container d-flex">\n' +
    '      <button class="button button-dark button-small" \n' +
    '              ng-if="!!isShowResolveButton"\n' +
    '              ng-click="proceedResolveFollowUp()">\n' +
    '        RESOLVE\n' +
    '      </button>\n' +
    '      <button class="button button-assertive button-small" \n' +
    '              ng-if="!!isShowDeleteButton"\n' +
    '              ng-click="deleteFollowUp()">\n' +
    '        DELETE\n' +
    '      </button>\n' +
    '      <button class="button button-stable button-small" \n' +
    '              ng-if="!!isShowCancelButton"\n' +
    '              ng-click="cancelResolveFollowUp()">\n' +
    '        <i class="icon ion-close"></i>\n' +
    '      </button>\n' +
    '    </div>            \n' +
    '  </div>\n' +
    '  \n' +
    '  <div class="row">\n' +
    '    <div class="col-100 d-flex align-items-center">\n' +
    '      <div class="section-title">\n' +
    '        <label class="bold">Findings:</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <div class="row m-b-10 scrollable-follow-ups-records">\n' +
    '    <div class="col-100 d-flex align-items-center">\n' +
    '      <div class="item item-input no-border findings-container"\n' +
    '           ng-if="!!findings">\n' +
    '        {{findings.StudyInfo}}\n' +
    '        <br ng-if="findings.FollowUpInfo" />\n' +
    '        {{findings.FollowUpInfo}}\n' +
    '        <br ng-if="findings.FindingSummary" />\n' +
    '        {{findings.FindingSummary}}\n' +
    '        <br ng-if="findings.AssessmentInfo" />\n' +
    '        {{findings.AssessmentInfo}}\n' +
    '        <br ng-if="findings.RecommendationInfo" />\n' +
    '        {{findings.RecommendationInfo}}\n' +
    '      </div>              \n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row m-b-10">\n' +
    '    <div class="col-40 p-r-25"> \n' +
    '      <div class="row m-b-10 column-title-container">\n' +
    '        <div class="col-100 d-flex align-items-center">\n' +
    '          <div class="section-title">\n' +
    '            <label class="bold">Resolution:</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      \n' +
    '      <div class="row m-b-10 resolution-dropdown-container">\n' +
    '        <div class="col-100 d-flex align-items-center">  \n' +
    '          <div class="item item-input no-border dropdown-input">\n' +
    '            <dropdown-menu \n' +
    '              class="modal-dropdown" \n' +
    '              ng-class="{\'invalid-data\': highlightFuInvalidData && !followUp.FUReason}"\n' +
    '              placeholder="Select Resolution" \n' +
    '              list="resolutions" \n' +
    '              property="Value" \n' +
    '              key="Key" \n' +
    '              selected="followUp.FUReason" \n' +
    '              select-mode="true" \n' +
    '              is-multi-select="false">\n' +
    '            </dropdown-menu>\n' +
    '          </div>            \n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-60">\n' +
    '      <div class="row m-b-10 column-title-container">\n' +
    '        <div class="col-100 d-flex align-items-center">\n' +
    '          <div class="section-title">\n' +
    '            <label class="bold">Comments:</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      \n' +
    '      <div class="row m-b-10 comments-dropdown-container">\n' +
    '        <div class="col-100 d-flex align-items-center">\n' +
    '          <div class="item item-input no-border textarea-container">\n' +
    '            <textarea class="contact-comments" class="w-100" ng-model="followUp.Notes" rows="5" maxlength="50" placeholder="Follow-up comment"/>\n' +
    '          </div>              \n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '<div ng-if="!!isShowButtonsAsModal">\n' +
    '  <div class="row p-20-px p-t-0">\n' +
    '    <div class="col-50"></div>\n' +
    '    <div class="col-25 padding-horizontal">\n' +
    '      <button class="button button-positive button-block"\n' +
    '              ng-click="proceedResolveFollowUp()">\n' +
    '        Resolve\n' +
    '      </button>\n' +
    '    </div>\n' +
    '    <div class="col-25 padding-left">\n' +
    '      <button class="button button-stable button-block back-btn"\n' +
    '              ng-click="cancelResolveFollowUp()">\n' +
    '        Cancel\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div> \n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/riskTabScrollTemplate.html',
    '<div class="h-100 risk-tab-scroll">\n' +
    '  <div class="row" ng-if="techpadSettings.NccnPat && $index === 0 && !vm.isGcTestResultsChanged()">\n' +
    '    <div class="col-66">\n' +
    '      <h2 class="item">Risk Assessment</h2>\n' +
    '    </div>\n' +
    '    <div class="col-33">\n' +
    '      <button class="button button-refresh pull-right button-dark" ng-click="vm.recalculateRisks()"\n' +
    '              ng-disabled="vm.shouldDisableRecalculateRisks()">\n' +
    '        <i class="button-icon ion-refresh"></i>&nbsp; Update\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row" ng-if="techpadSettings.NccnPat && $index === 0 && vm.isGcTestResultsChanged()">\n' +
    '    <div class="col-100">\n' +
    '      <h4 class="force-update-risks-message">The patient\'s history has been updated. Click the update button to update the risk.</h4>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row" ng-if="techpadSettings.NccnPat && $index === 0 && vm.isGcTestResultsChanged()">\n' +
    '    <div class="col-66">\n' +
    '\n' +
    '    </div>\n' +
    '    <div class="col-33">\n' +
    '      <button class="button button-refresh pull-right button-dark" ng-click="vm.saveAndReloadRisk()" ng-disabled="vm.shouldDisableRecalculateRisks()" >\n' +
    '        <i class="button-icon ion-refresh"></i>&nbsp; Update\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row" ng-if="techpadSettings.NccnPat && $index === 1">\n' +
    '    <div class="col-66">\n' +
    '      <h2 class="item">NCCN Guidelines</h2>\n' +
    '    </div>\n' +
    '    <div class="col-33">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row no-padding">\n' +
    '    <div class="col no-padding">\n' +
    '\n' +
    '      <div class="row item" ng-if="col.indexOf(vm.riskPropertyConstants.ibisRiskModule) > -1 &&\n' +
    '                              (!techpadSettings.NccnPat || techpadSettings.NccnPat && !vm.isGcTestResultsChanged())">\n' +
    '        <div class="col-100">\n' +
    '          <div class="item tab-header no-padding">\n' +
    '            <div class="row">\n' +
    '              <label class="item tab-header col-100">\n' +
    '                <b class="pull-left dropdown-header">Tyrer-Cuzick Risk:</b>\n' +
    '                <hr class="full-width"/>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.patient.Sex === vm.commonConstants.maleGenderCode">\n' +
    '              <div class="col-100">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  Tyrer-Cuzick risk cannot be calculated for a male patient.\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.patient.Sex === vm.commonConstants.femaleGenderCode">\n' +
    '              <div class="col-60">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  Personal life time probability:\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-25">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                  <input disabled="disabled" ng-model="vm.patient.StoreRiskResults.Ibislife" type="number"\n' +
    '                         class="col-70 result-block">\n' +
    '                  <span>%</span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.patient.Sex === vm.commonConstants.femaleGenderCode">\n' +
    '              <div class="col-60">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  BRCA1 probability:\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-25">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                  <input disabled="disabled" ng-model="vm.patient.StoreRiskResults.Ibisbrca1" type="number"\n' +
    '                         class="col-70 result-block">\n' +
    '                  <span>%</span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.patient.Sex === vm.commonConstants.femaleGenderCode">\n' +
    '              <div class="col-60">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  BRCA2 probability:\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-25">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                  <input disabled="disabled" ng-model="vm.patient.StoreRiskResults.Ibisbrca2" type="number"\n' +
    '                         class="col-70 result-block">\n' +
    '                  <span>%</span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="col.indexOf(vm.riskPropertyConstants.heraRiskModule) > -1 &&\n' +
    '                              (!techpadSettings.NccnPat || techpadSettings.NccnPat && !vm.isGcTestResultsChanged())">\n' +
    '        <div class="col-100">\n' +
    '          <div class="item tab-header no-padding">\n' +
    '            <div class="row">\n' +
    '              <label class="item tab-header col-100">\n' +
    '                <b class="pull-left dropdown-header">HERA Risk:</b>\n' +
    '                <hr class="full-width"/>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.patient.Sex === vm.commonConstants.maleGenderCode">\n' +
    '              <div class="col-100">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  HERA risk cannot be calculated for a male patient.\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.patient.Sex === vm.commonConstants.femaleGenderCode">\n' +
    '              <div class="col-60">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  HERA risk point:\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-25">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                  <input disabled="disabled" ng-model="vm.patient.StoreRiskResults.Heralife" type="number"\n' +
    '                         class="col-70 result-block">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="col.indexOf(vm.riskPropertyConstants.nciRiskModule) > -1 &&\n' +
    '                              (!techpadSettings.NccnPat || techpadSettings.NccnPat && !vm.isGcTestResultsChanged())">\n' +
    '        <div class="col-100">\n' +
    '          <div class="item tab-header no-padding">\n' +
    '            <div class="row">\n' +
    '              <label class="item tab-header col-100">\n' +
    '                <b class="pull-left dropdown-header">NCI Risk:</b>\n' +
    '                <hr class="full-width"/>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.calculateAge(vm.patient.DateOfBirth) < 35">\n' +
    '              <div class="col-100">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  NCI risk cannot be calculated for a patient younger than 35.\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.patient.Sex === vm.commonConstants.maleGenderCode">\n' +
    '              <div class="col-100">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  NCI risk cannot be calculated for a male patient.\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.patient.Sex === vm.commonConstants.femaleGenderCode && vm.patient.StoreRiskResults.Ncilife === -1">\n' +
    '              <div class="col-100">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  NCI risk tables are not installed. Please call MagView support to load these tables.\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row"\n' +
    '                 ng-if="vm.patient.Sex === vm.commonConstants.femaleGenderCode &&\n' +
    '                        vm.patient.StoreRiskResults.Ncilife !== -1 && vm.calculateAge(vm.patient.DateOfBirth) >= vm.riskPropertyConstants.minimumNciRiskAge">\n' +
    '              <div class="col-60">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  within lifetime:\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-25">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                  <input disabled="disabled" ng-model="vm.patient.StoreRiskResults.Ncilife" type="number"\n' +
    '                         class="col-70 result-block">\n' +
    '                  <span>%</span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="col.indexOf(vm.riskPropertyConstants.clausRiskModule) > -1 &&\n' +
    '                              (!techpadSettings.NccnPat || techpadSettings.NccnPat && !vm.isGcTestResultsChanged())">\n' +
    '        <div class="col-100">\n' +
    '          <div class="item tab-header no-padding">\n' +
    '            <div class="row">\n' +
    '              <label class="item tab-header col-100">\n' +
    '                <b class="pull-left dropdown-header">Claus Risk:</b>\n' +
    '                <hr class="full-width"/>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.patient.Sex === vm.commonConstants.maleGenderCode">\n' +
    '              <div class="col-100">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  Claus risk cannot be calculated for a male patient.\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.patient.Sex === vm.commonConstants.femaleGenderCode && vm.patient.StoreRiskResults.Clauslife == -1">\n' +
    '              <div class="col-100">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  No family history\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.patient.Sex === vm.commonConstants.femaleGenderCode && vm.patient.StoreRiskResults.Clauslife != -1">\n' +
    '              <div class="col-60">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  to age 79:\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-25">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                  <input disabled="disabled" ng-model="vm.patient.StoreRiskResults.Clauslife" type="number"\n' +
    '                         class="col-70 result-block">\n' +
    '                  <span>%</span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="col.indexOf(vm.riskPropertyConstants.brcaRiskModule) > -1 &&\n' +
    '                              (!techpadSettings.NccnPat || techpadSettings.NccnPat && !vm.isGcTestResultsChanged())">\n' +
    '        <div class="col-100">\n' +
    '          <div class="item tab-header no-padding">\n' +
    '            <div class="row">\n' +
    '              <label class="item tab-header col-100">\n' +
    '                <b class="pull-left dropdown-header">BRCAPRO Risk:</b>\n' +
    '                <hr class="full-width"/>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '              <div class="col-60">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  Carrier probability:\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-25">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                  <input disabled="disabled" ng-model="vm.patient.StoreRiskResults.Brcabrcac" type="number"\n' +
    '                         class="col-70 result-block">\n' +
    '                  <span>%</span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '              <div class="col-60">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  BRCA1 probability:\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-25">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                  <input disabled="disabled" ng-model="vm.patient.StoreRiskResults.Brcabrca1" type="number"\n' +
    '                         class="col-70 result-block">\n' +
    '                  <span>%</span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '              <div class="col-60">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  BRCA2 probability:\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-25">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                  <input disabled="disabled" ng-model="vm.patient.StoreRiskResults.Brcabrca2" type="number"\n' +
    '                         class="col-70 result-block">\n' +
    '                  <span>%</span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '              <div class="col-60">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  within lifetime:\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-25">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                  <input disabled="disabled" ng-model="vm.patient.StoreRiskResults.Brcalife" type="number"\n' +
    '                         class="col-70 result-block">\n' +
    '                  <span>%</span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="col.indexOf(vm.riskPropertyConstants.bcscRiskModule) > -1 &&\n' +
    '                              (!techpadSettings.NccnPat || techpadSettings.NccnPat && !vm.isGcTestResultsChanged())">\n' +
    '        <div class="col-100">\n' +
    '          <div class="item tab-header no-padding">\n' +
    '            <div class="row">\n' +
    '              <label class="item tab-header col-100">\n' +
    '                <b class="pull-left dropdown-header">BCSC Risk:</b>\n' +
    '                <hr class="full-width"/>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="row" ng-if="vm.patient.Sex === vm.commonConstants.femaleGenderCode">\n' +
    '              <div class="col-60">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col-25">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                  <input disabled="disabled" ng-model="vm.patient.StoreRiskResults.Bcsc" type="number"\n' +
    '                         class="col-70 result-block">\n' +
    '                  <span>%</span>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="col.indexOf(vm.riskPropertyConstants.brst3RiskModule) > -1 &&\n' +
    '                              (!techpadSettings.NccnPat || techpadSettings.NccnPat && !vm.isGcTestResultsChanged())">\n' +
    '        <div class="col-100">\n' +
    '          <div class="item tab-header no-padding">\n' +
    '            <div class="row">\n' +
    '              <label class="item tab-header col-100">\n' +
    '                <b class="pull-left dropdown-header">B-RST 3.0 Result:</b>\n' +
    '                <hr class="full-width"/>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '              <div class="col-60" ng-if="vm.patient.Sex === vm.commonConstants.femaleGenderCode">\n' +
    '                <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                  {{vm.patient.StoreRiskCustomResults.BRST}}\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row" ng-if="col.indexOf(vm.riskPropertyConstants.nccnRiskModule) > -1">\n' +
    '        <div class="col-100">\n' +
    '          <div class="item tab-header no-padding">\n' +
    '\n' +
    '            <div class="relative mb-15" ng-repeat="nccnElement in vm.nccnGuideline.Elements | orderBy:vm.riskPropertyConstants.defaultSortingColumn">\n' +
    '              <div class="row">\n' +
    '                <label class="item tab-header col-100">\n' +
    '                  <b class="pull-left dropdown-header">{{nccnElement.Title}}</b>\n' +
    '                  <hr class="full-width"/>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div class="row myriad-buttons-container">\n' +
    '                <div ng-if="techpadSettings.Myriad \n' +
    '                            && nccnElement.Id === vm.riskPropertyConstants.geneticCounselingElementId\n' +
    '                            && (vm.isPatientQualified(nccnElement) \n' +
    '                                || techpadSettings.ShowMyriad)"\n' +
    '                     class="text-center">\n' +
    '                  <button class="myrad-btn"\n' +
    '                          ng-class="{\'button button-balanced button-assertive button-outline\': vm.isSendToMyriadTriggered && vm.isSuccessfullySentToMyriad,\n' +
    '                                    \'button button-dark\' : !vm.isSendToMyriadTriggered}"\n' +
    '                          ng-click="vm.saveAndSendToMyriad()"\n' +
    '                          ng-disabled="vm.shouldDisableRecalculateRisks()">\n' +
    '                    {{vm.myriadButtonText ? vm.myriadButtonText : vm.riskPropertyConstants.defaultSendToMyriadBUttonText}}\n' +
    '                  </button>\n' +
    '                  <div class="myrad-sent-date-container"\n' +
    '                       ng-if="techpadSettings.Myriad \n' +
    '                              && nccnElement.Id === vm.riskPropertyConstants.geneticCounselingElementId \n' +
    '                              && (vm.isPatientQualified(nccnElement) \n' +
    '                                  || techpadSettings.ShowMyriad)\n' +
    '                              && vm.lastSentDateToMyriad">\n' +
    '                    <span class="fs-12 font-style-italic">\n' +
    '                      Sent: {{vm.lastSentDateToMyriad | date: vm.commonConstants.defaultFullDateFormat}}\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div ng-if="techpadSettings.Myriad \n' +
    '                            && nccnElement.Id === vm.riskPropertyConstants.geneticCounselingElementId\n' +
    '                            && (vm.isPatientQualified(nccnElement) \n' +
    '                                && techpadSettings.ShowMyriadTrf)"\n' +
    '                     class="text-center">\n' +
    '                  <button class="myrad-btn button button-dark"\n' +
    '                          ng-click="vm.generateAndViewTrfForm()"\n' +
    '                          ng-disabled="vm.shouldDisableRecalculateRisks()">\n' +
    '                    Show Test Requisition Form\n' +
    '                  </button>\n' +
    '                  <div ng-if="techpadSettings.Myriad \n' +
    '                              && nccnElement.Id === vm.riskPropertyConstants.geneticCounselingElementId \n' +
    '                              && (vm.isPatientQualified(nccnElement) \n' +
    '                                  && techpadSettings.ShowMyriadTrf)\n' +
    '                              && vm.trfLastPrintDate">\n' +
    '                    <span class="fs-12 font-style-italic">\n' +
    '                      Printed: {{vm.trfLastPrintDate | date: vm.commonConstants.defaultFullDateFormat}}\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div\n' +
    '                ng-if="nccnElement.Properties && nccnElement.Properties.length === 1 || nccnElement.Id === vm.riskPropertyConstants.geneticCounselingElementId"\n' +
    '                ng-repeat="property in nccnElement.Properties | orderBy:vm.riskPropertyConstants.defaultSortingColumn">\n' +
    '\n' +
    '                <div class="row" ng-if="property.Type === vm.propertyTypeConstants.LABEL">\n' +
    '                  <label class="item tab-header col-100">\n' +
    '                    <h3 class="pull-left sub-h3-risk-custom item"\n' +
    '                        ng-class="{\'bold\': property.Important,\n' +
    '                                   \'green-colored\': property.Id === vm.riskPropertyConstants.gcPatientCompletedPropertyId,\n' +
    '                                   \'orange-colored\': property.Id === vm.riskPropertyConstants.gcPatientNotCompletedPropertyId \n' +
    '                                                     && !vm.areGenesAnswersIncomplete(),\n' +
    '                                   \'red-colored\': property.Id === vm.riskPropertyConstants.gcPatientQualifiedPropertyId \n' +
    '                                                  || property.Important && nccnElement.Id !== vm.riskPropertyConstants.geneticCounselingElementId\n' +
    '                                                  || vm.areGenesAnswersIncomplete() \n' +
    '                                                     && property.Id === vm.riskPropertyConstants.gcPatientNotCompletedPropertyId}">\n' +
    '                      {{property.Caption}}\n' +
    '                    </h3>\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '\n' +
    '                <div ng-if="property.Type === vm.propertyTypeConstants.DATE\n' +
    '                            && !vm.gcShouldHideIfPatientNotInterested(property) \n' +
    '                            && (\n' +
    '                                (\n' +
    '                                  property.Id === vm.riskPropertyConstants.gcDateOfferedPropertyId\n' +
    '                                  || property.Id === vm.riskPropertyConstants.gcDateRespondedPropertyId\n' +
    '                                  || property.Id === vm.riskPropertyConstants.gcDateRespondedPropertyId\n' +
    '                                     && vm.isPatientQualified(nccnElement)\n' +
    '                                )\n' +
    '                                || property.Id !== vm.riskPropertyConstants.gcDateOfferedPropertyId \n' +
    '                                   && property.Id !== vm.riskPropertyConstants.gcDateRespondedPropertyId \n' +
    '                                   && property.Id === vm.riskPropertyConstants.gcDatePerformedPropertyId\n' +
    '                               )"\n' +
    '                     class="row counseling-ml">\n' +
    '                  <div class="col-30">\n' +
    '                    <div class="item item-text-wrap item-transparent  title-item counseling-item">\n' +
    '                      {{property.Caption}}\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-70">\n' +
    '                    <div class="item item-text-wrap item-transparent d-flex">\n' +
    '                      <input id="{{property.Id}}" class="demographic-date-input" ng-disabled="vm.isViewOnly"\n' +
    '                             ng-model="property.Response" date-input="property.Response"/>\n' +
    '                      <button ng-disabled="vm.shouldDisableRecalculateRisks()" type="button" class="icon border-less ion-calendar"\n' +
    '                              ng-click="vm.riskTabChangeDate(nccnElement.Properties, property.Id)"></button>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="row counseling-ml align-items-center"\n' +
    '                     ng-if="property.Type === vm.propertyTypeConstants.RADIO\n' +
    '                            && (property.Id === vm.riskPropertyConstants.gcPatientAgreementPropertyId\n' +
    '                                 && vm.isPatientQualified(nccnElement)\n' +
    '                                 || property.Id !== vm.riskPropertyConstants.gcPatientAgreementPropertyId)">\n' +
    '                  <div class="col-30"> \n' +
    '                    <div class="item item-text-wrap item-transparent dropdown-result title-item"></div>\n' +
    '                  </div>\n' +
    '                  <div class="col-70">\n' +
    '                    <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                      <div class="row item align-items-center d-flex"\n' +
    '                           ng-repeat="option in property.Options | orderBy:vm.riskPropertyConstants.defaultSortingColumn">\n' +
    '                        <label class="radio-with-label">\n' +
    '                          <label class="checkbox"\n' +
    '                                 ng-class="{\'default-cursor\':vm.isViewOnly}">\n' +
    '                            <input type="checkbox"\n' +
    '                                   ng-disabled="vm.isViewOnly"\n' +
    '                                   ng-checked="option.Value === property.Response"\n' +
    '                                   ng-click="vm.onRadioValueChanged(property, option);">\n' +
    '                          </label>\n' +
    '                          <span ng-class="{\'caption\':!vm.isViewOnly}">{{option.Caption}}</span>\n' +
    '                        </label>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="row counseling-ml" ng-if="property.Type === vm.propertyTypeConstants.TEXT">\n' +
    '                  <div class="col-30">\n' +
    '                    <div class="item item-text-wrap item-transparent title-item counseling-item align-top">\n' +
    '                      {{property.Caption}}\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-70">\n' +
    '                    <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                      <textarea class="comment-area" rows="3" maxlength="250" \n' +
    '                                ng-disabled="vm.isViewOnly"\n' +
    '                                ng-model="property.Response"></textarea>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="row counseling-ml"\n' +
    '                     ng-if="property.Type === vm.propertyTypeConstants.MVPOP\n' +
    '                            && (property.Id === vm.riskPropertyConstants.gcReferralMVPOPPropertyId\n' +
    '                                && vm.isPatientQualified(nccnElement)\n' +
    '                                || property.Id !== vm.riskPropertyConstants.gcReferralMVPOPPropertyId)">\n' +
    '                  <div class="col-30">\n' +
    '                    <div class="item item-text-wrap item-transparent title-item counseling-item align-top">\n' +
    '                      {{property.Caption}}\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-70">\n' +
    '                    <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                      <select class="dropdown" \n' +
    '                              ng-disabled="vm.isViewOnly" \n' +
    '                              ng-model="property.Response" \n' +
    '                              ng-options="option.Value as option.Caption for option in property.Options">\n' +
    '                      </select>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="row counseling-ml" ng-if="property.Type === vm.propertyTypeConstants.MULTIRADIO">\n' +
    '                  <div class="col-30">\n' +
    '                    <div class="item item-text-wrap item-transparent dropdown-result title-item">\n' +
    '                      {{property.Caption}}\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                  <div class="col-70">\n' +
    '                    <div class="row pl-0">\n' +
    '                      <div ng-if="property.Caption2">\n' +
    '                        <label class="item tab-header">\n' +
    '                          <h3 class="pull-left sub-h3-risk-custom pl-0 pr-1"\n' +
    '                              ng-class="{\'green-colored\': !vm.areGenesAnswersIncomplete(),\n' +
    '                                         \'orange-colored\': vm.areGenesAnswersIncomplete()}">\n' +
    '                            {{property.Caption2}}\n' +
    '                          </h3>\n' +
    '                        </label>\n' +
    '                      </div>\n' +
    '                      <button ng-disabled="vm.shouldDisableRecalculateRisks()" type="button" class="icon ion-edit" ng-click="vm.openMultiRadioPopup(property)"></button>\n' +
    '                    </div>                    \n' +
    '\n' +
    '                    <div class="item item-text-wrap item-transparent dropdown-result value-item">\n' +
    '                      <div class="row item item-text-wrap item-transparent dropdown-result title-item ng-binding one-line"\n' +
    '                            ng-repeat="column in property.Columns | orderBy:vm.riskPropertyConstants.defaultSortingColumn"\n' +
    '                            ng-init="firstIndex = $index">\n' +
    '                        <div class="multi-radio-result-column-caption bold item">{{column.Caption}}:</div>\n' +
    '                        <div class="multi-radio-result-value item"\n' +
    '                              ng-repeat="option in property.Options | geneTestResultsFilterByResult:firstIndex | orderBy:vm.riskPropertyConstants.defaultSortingColumn"\n' +
    '                              ng-init="secondIndex = $index">\n' +
    '                            {{$last ? option.Caption : option.Caption + \',\'}}\n' +
    '                        </div>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div ng-if="nccnElement.Properties && nccnElement.Properties.length > 1 \n' +
    '                          && nccnElement.Id !== vm.riskPropertyConstants.geneticCounselingElementId">\n' +
    '                <div class="row">\n' +
    '                  <ul class="pull-left recommendations-list">\n' +
    '                    <li ng-if="property.Type === vm.propertyTypeConstants.LABEL"\n' +
    '                        ng-repeat="property in nccnElement.Properties | orderBy:vm.riskPropertyConstants.defaultSortingColumn"\n' +
    '                        ng-class="{\'red-colored bold\': property.Important}"\n' +
    '                        ng-style="property.Level | propertyLevelLeftMargin">\n' +
    '                      <span ng-if="!property.Header" class="display-flex">&#8226;<div class="m-l-5">{{property.Caption}}</div></span>\n' +
    '                      <span ng-class="{\'is-header\': property.Header}" ng-if="property.Header">{{property.Caption}}</span>\n' +
    '                    </li>\n' +
    '                  </ul>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/selectPrintersDialog.html',
    '<div class="modal worklist-filtering-modal enabled-printers-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h1 class="title">Select printer</h1>\n' +
    '    <div class="button button-clear" ng-click="model.cancelChanges();"><span class="icon ion-close"></span></div>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="padding">\n' +
    '    <div class="row mt-25">\n' +
    '      <select ng-model="model.printerName">\n' +
    '        <option value="">Select printer</option>\n' +
    '        <option ng-repeat="printer in model.enabledPrinters" value="{{printer}}">{{printer}}</option>\n' +
    '      </select>\n' +
    '    </div>\n' +
    '    <div class="row mt-15">\n' +
    '      <div class="col">\n' +
    '        <button ng-click="model.print()" class="button button-balanced btn-print">Print Document</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/selectProblemsDialog.html',
    '<div class="modal problems-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      Select Problems\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="padding no-scroll">\n' +
    '    <div class="inner-content">\n' +
    '      <div class="item item-transparent h-100">\n' +
    '        <div class="row problems-header-container">\n' +
    '          <div class="col-35"><b>Name</b></div>\n' +
    '          <div class="col-10"><b>Unsp.</b></div>\n' +
    '          <div class="col-10"><b>Both</b></div>\n' +
    '          <div class="col-10"><b>Left</b></div>\n' +
    '          <div class="col-10"><b>Right</b></div>\n' +
    '          <div class="col-25"><b>Location</b></div>\n' +
    '        </div>\n' +
    '        <div zooming="false" direction="y" class="select-problem-items scroll">\n' +
    '          <div class="row" ng-repeat="v in model.problems">\n' +
    '            <div class="col-35 name-label problem-name-label" ng-class="{\'separator\':model.isSeparator(v)}">\n' +
    '              <label>{{ v.Value }}</label>\n' +
    '            </div>\n' +
    '            <div class="col-10" ng-hide="model.isSeparator(v)">\n' +
    '              <label class="checkbox">\n' +
    '                <input type="checkbox" ng-model="v.IsUnspecified" ng-change="model.updateProblemUnspecified(v)">\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="col-10" ng-hide="model.isSeparator(v)">\n' +
    '              <label class="checkbox">\n' +
    '                <input type="checkbox" ng-model="v.IsBoth" ng-change="model.updateProblemSide(v, true)">\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="col-10" ng-hide="model.isSeparator(v)">\n' +
    '              <label class="checkbox">\n' +
    '                <input type="checkbox" ng-model="v.IsLeft" ng-change="model.updateProblemSide(v, false)">\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="col-10" ng-hide="model.isSeparator(v)">\n' +
    '              <label class="checkbox">\n' +
    '                <input type="checkbox" ng-model="v.IsRight" ng-change="model.updateProblemSide(v, false)">\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="col-25" ng-hide="model.isSeparator(v) || !model.isSideSpecified(v)">\n' +
    '                <div ng-dropdown-multiselect=""\n' +
    '                     options="model.locations"\n' +
    '                     selected-model="v.selectedLocations"\n' +
    '                     extra-settings="model.dropdownMultiSelectSetting"\n' +
    '                     translation-texts="model.dropdownMultiSelectText"\n' +
    '                     class="angular-dropdown-multiselect-custom"></div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '    </div>\n' +
    '  </content>\n' +
    '  <footer class="bar bar-footer">\n' +
    '    <div class="row">\n' +
    '      <div class="col col-50">\n' +
    '        <button class="button button-positive button-block" ng-click="model.ok();">OK</button>\n' +
    '      </div>\n' +
    '      <div class="col col-50">\n' +
    '        <button class="button button-light button-cancel button-block" ng-click="model.cancel();">CANCEL</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </footer>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/selectReferringPhysicianDialog.html',
    '<div class="ion-autocomplete-container {{viewModel.randomCssClass}} modal" style="display: none;">\n' +
    '  <div class="bar bar-header item-input-inset">\n' +
    '    <label class="item-input-wrapper">\n' +
    '      <i class="icon ion-search placeholder-icon"></i>\n' +
    '      <input type="search" class="ion-autocomplete-search" ng-model="viewModel.searchQuery"\n' +
    '             ng-model-options="viewModel.ngModelOptions" placeholder="{{viewModel.placeholder}}"/>\n' +
    '    </label>\n' +
    '    <div class="ion-autocomplete-loading-icon" ng-if="viewModel.showLoadingIcon && viewModel.loadingIcon">\n' +
    '      <ion-spinner icon="{{viewModel.loadingIcon}}"></ion-spinner>\n' +
    '    </div>\n' +
    '    <button class="ion-autocomplete-cancel button button-clear" ng-click="viewModel.cancelClick()">\n' +
    '      {{viewModel.cancelLabel}}\n' +
    '    </button>\n' +
    '  </div>\n' +
    '  <ion-content class="has-header">\n' +
    '    <ion-item class="item-divider">{{viewModel.selectedItemsLabel}}</ion-item>\n' +
    '    <ion-item ng-if="viewModel.isArray(viewModel.selectedItems)"\n' +
    '              ng-repeat="selectedItem in viewModel.selectedItems track by $index"\n' +
    '              class="item-icon-left item-icon-right item-text-wrap">\n' +
    '      <i class="icon ion-checkmark"></i>\n' +
    '      {{viewModel.getItemValue(selectedItem, viewModel.itemViewValueKey)}}\n' +
    '      <i class="icon ion-close" style="cursor:pointer" ng-click="viewModel.removeItem($index)"></i>\n' +
    '    </ion-item>\n' +
    '    <ion-item ng-if="!viewModel.isArray(viewModel.selectedItems) && viewModel.selectedItems" class="item-icon-left item-icon-right item-text-wrap">\n' +
    '      <i class="icon ion-checkmark"></i>\n' +
    '      {{viewModel.getItemValue(viewModel.selectedItems, viewModel.itemViewValueKey)}}\n' +
    '      <i class="icon ion-close" style="cursor:pointer" ng-click="viewModel.removeItem(0)"></i>\n' +
    '    </ion-item>\n' +
    '    <ion-item class="item-divider" ng-if="viewModel.searchItems.List.length > 0">{{viewModel.selectItemsLabel}}\n' +
    '    </ion-item>\n' +
    '    <ion-item ng-repeat="item in viewModel.searchItems.List track by $index" item-height="55px" item-width="100%"\n' +
    '              ng-click="viewModel.selectItem(item)" class="item-text-wrap">\n' +
    '      {{viewModel.getItemValue(item, viewModel.itemViewValueKey)}}\n' +
    '    </ion-item>\n' +
    '    <ion-item class="getRefPhyError" ng-show="viewModel.searchItems.IsError">\n' +
    '      {{viewModel.searchItems.ErrorMessage}}\n' +
    '    </ion-item>\n' +
    '\n' +
    '    <ion-item ng-if="viewModel.templateData.showLoadMore" ng-click="viewModel.fetchSearchQuery(viewModel.searchQuery || \'\',false)" class="item-text-wrap load-more-refphys-button-container">\n' +
    '      <div class="load-more-refphys-button">Load More</div>\n' +
    '    </ion-item>\n' +
    '  </ion-content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/settingsPopover.html',
    '<ion-popover-view class="settings-popover">\n' +
    '  <ion-content scroll="false">\n' +
    '    <div class="list">\n' +
    '      <a class="item item-icon" href="javascript:void(0)" ng-click="logout()" ng-disabled="!vm.isOnline()">\n' +
    '        <i class="ion-log-out"></i>\n' +
    '        Logout\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '</ion-popover-view>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/startSurveyWindow.html',
    '<div class="modal worklist-exam-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h1 class="title">Patient - {{item.FirstName | camelize}} {{item.LastName | camelize}}</h1>\n' +
    '    <div class="button button-clear ripple" ng-click="modal.remove()"><span class="icon ion-close"></span></div>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="padding">\n' +
    '    <div class="inner-content">\n' +
    '      <div class="row">\n' +
    '        <div class="col-45">\n' +
    '\n' +
    '          <button class="button button-large button-block button-dark exam-big-btn ripple"\n' +
    '                  ng-click="model.openItem(item, false, $event); modal.remove()"\n' +
    '                  ng-disabled="!model.canOpenItem(item)">\n' +
    '            Start Survey\n' +
    '            <i class="icon ion-clipboard"></i>\n' +
    '          </button>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '      <div class="row bottom-row">\n' +
    '\n' +
    '        <div class="col-45">\n' +
    '\n' +
    '          <button class="button button-light button-block back-btn ripple" ng-click="modal.remove()">\n' +
    '            Go Back\n' +
    '          </button>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/studiesScrollTempate.html',
    '<div class="form-page p-x-15">\n' +
    '    <form>\n' +
    '      <div class="row">\n' +
    '        <div class="col col-12 pad-14">\n' +
    '          <ion-list class="list studies-list" ng-if="vm.patient.Ssn">\n' +
    '            <ion-item class="item item-icon-right repeat-animation relative documents-item studies-content"\n' +
    '              ng-repeat="study in vm.studiesToDisplay | orderBy:\'StudyDate\':\'desc\'"\n' +
    '              ng-disabled="!vm.isOnline()"\n' +
    '              ng-click="!$event.target.closest(\'button\') && vm.validateAndOpenStudy(study.SDate, $event)">\n' +
    '              <div class="row align-items-center">\n' +
    '                <div class="col w-120">{{ study.StudyDate | date:\'MM/dd/yyyy\' }}</div>\n' +
    '                <div class="col w-25p whitespace-normal l-h-30">{{ study.LocationToDisplay }}</div>\n' +
    '                <div class="col w-40p whitespace-normal l-h-30">{{ study.DescriptionToDisplay }}</div>\n' +
    '                <div class="col w-30p whitespace-normal l-h-30">{{ study.TechnologistToDisplay }}</div>\n' +
    '                <div class="col w-120">{{ study.AssessmentToDisplay }}</div>\n' +
    '                <div class="col w-130">{{ study.DStatusToDisplay }}</div>\n' +
    '                \n' +
    '                <div class="w-60">\n' +
    '                  <button class="icon ion-ios-circle-outline open-icon button button-clear no-activated-state relative studies-circle-button"\n' +
    '                        ng-if="study.IsShowViewReport"\n' +
    '                        ng-click="$event.stopPropagation(); $event.preventDefault();">\n' +
    '                    <i class="icon studies-button-image "\n' +
    '                        ng-class="{ \'ion-ios-arrow-right\' : document.isSwiped, \'ion-ios-arrow-left\': !document.isSwiped }"></i>\n' +
    '                </button>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <ion-option-button class="button-position button-positive" \n' +
    '                                ng-if="study.IsShowViewReport"\n' +
    '                                ng-disabled="!isOnline()">\n' +
    '                <ripple class="documents-button text-white" ng-click="vm.viewReport(study)">View Report</ripple>\n' +
    '              </ion-option-button>\n' +
    '            </ion-item>\n' +
    '          </ion-list>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </form>\n' +
    '  </div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/studiesTabScrollTemplate.html',
    '<ion-list class="list followups-items">\n' +
    '    <ion-item class="item text-center" ng-if="!vm.studiesToDisplay">\n' +
    '        <ion-spinner></ion-spinner>\n' +
    '        <b>Loading...</b>\n' +
    '    </ion-item>\n' +
    '    <ion-item class="item text-center" ng-if="!!vm.studiesToDisplay && !vm.studiesToDisplay.length">\n' +
    '        <b>\n' +
    '            {{ vm.getNoStudyMessage() }}\n' +
    '        </b>\n' +
    '    </ion-item>\n' +
    '    <ion-item class="item item-icon-right repeat-animation relative align-items-center studies-content" \n' +
    '              ng-repeat="study in vm.studiesToDisplay | orderBy:\'StudyDate\':\'desc\'">\n' +
    '        <div class="row align-items-center">\n' +
    '            <div class="col w-120">{{ study.StudyDate | date:\'MM/dd/yyyy\' }}</div>\n' +
    '            <div class="col w-25p whitespace-normal l-h-30">{{ study.LocationToDisplay }}</div>\n' +
    '            <div class="col w-40p whitespace-normal l-h-30">{{ study.DescriptionToDisplay }}</div>\n' +
    '            <div class="col w-30p whitespace-normal l-h-30">{{ study.TechnologistToDisplay }}</div>\n' +
    '            <div class="col w-120">{{ study.AssessmentToDisplay }}</div>\n' +
    '            <div class="col w-130">{{ study.DStatusToDisplay }}</div>\n' +
    '\n' +
    '            <div class="w-60">\n' +
    '                  <button class="icon ion-ios-circle-outline open-icon button button-clear no-activated-state relative studies-circle-button"\n' +
    '                        ng-if="study.IsShowViewReport"\n' +
    '                        ng-click="$event.stopPropagation(); $event.preventDefault();">\n' +
    '                    <i class="icon studies-button-image "\n' +
    '                        ng-class="{ \'ion-ios-arrow-right\' : document.isSwiped, \'ion-ios-arrow-left\': !document.isSwiped }"></i>\n' +
    '                </button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '            <ion-option-button class="button-position button-positive" \n' +
    '                    ng-if="study.IsShowViewReport"\n' +
    '                    ng-disabled="!isOnline()">\n' +
    '                <ripple class="documents-button text-white" ng-click="vm.viewReport(study)">View Report</ripple>\n' +
    '            </ion-option-button>\n' +
    '    </ion-item>\n' +
    '</ion-list>\n' +
    '<div class="container-with-padding">\n' +
    '    &nbsp;\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/studyDetailsTemplate.html',
    '<div class="row views-row" ng-repeat="p in vm.study.Procedures">\n' +
    '    <div class="col-40 table-label">\n' +
    '      <label simple-popover="{{p.Code}}">\n' +
    '        {{p.Code}}\n' +
    '      </label>\n' +
    '    </div>\n' +
    '    <div class="col-45">\n' +
    '      <div class="position-relative" ng-if="techpadSettings.IsStudyModificationAbilityEnabled">\n' +
    '        <dropdown-menu placeholder="Side" \n' +
    '          list="vm.sides" \n' +
    '          select-mode="true" \n' +
    '          display-property="Value"\n' +
    '          property="Value" \n' +
    '          key="Key" \n' +
    '          selected="p.Side" \n' +
    '          show-caret="true" \n' +
    '          dropdown-height="156"\n' +
    '          class="modal-dropdown" \n' +
    '          empty-value="\'U\'" \n' +
    '          hide-other-dropdown="true"></dropdown-menu>\n' +
    '        <div class="dblarrow dropdown-small"><b></b><i></i></div>\n' +
    '      </div>                    \n' +
    '      <div class="table-label" ng-if="!techpadSettings.IsStudyModificationAbilityEnabled">\n' +
    '        <label>\n' +
    '          {{vm.getFullSideByCode(p.Side)}}\n' +
    '        </label>\n' +
    '      </div>\n' +
    '      \n' +
    '    </div>\n' +
    '    <div>\n' +
    '      <button class="button button-delete button-clear icon ion-ios-close-empty delete-procedure-btn"\n' +
    '              ng-if="techpadSettings.IsStudyModificationAbilityEnabled"\n' +
    '              ng-click="vm.removeProcedure(p)"></button>\n' +
    '    </div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/studyLockedDialog.html',
    '<div class="popup">\n' +
    '  <div class="popup-head">\n' +
    '    <h3 class="popup-title ng-binding" ng-bind-html="title">\n' +
    '      Cannot perform exam\n' +
    '    </h3>\n' +
    '    <!-- ngIf: subTitle --></div>\n' +
    '  <div class="popup-body">\n' +
    '    <span>\n' +
    '      User \'JUSTIN CHASEZ 2 TECH\' on workstation \'JUSTINDESKTOP\' is currently modifying this study. You will be able to review current study information, but not change or save the study. This event was started on Today at 3:35 PM\n' +
    '    </span>\n' +
    '  </div>\n' +
    '  <div class="popup-buttons">\n' +
    '    <button ng-repeat="button in buttons" ng-click="$buttonTapped(button, $event)"\n' +
    '            class="button ng-binding button-default" ng-class="button.type || \'button-default\'"\n' +
    '            ng-bind-html="button.text">Unlock this exam\n' +
    '    </button><!-- end ngRepeat: button in buttons -->\n' +
    '    <button ng-repeat="button in buttons" ng-click="$buttonTapped(button, $event)"\n' +
    '            class="button ng-binding button-positive" ng-class="button.type || \'button-default\'"\n' +
    '            ng-bind-html="button.text">View Only\n' +
    '    </button><!-- end ngRepeat: button in buttons --></div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/ultrasoundRequestWindow.html',
    '<div class="modal worklist-exam-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h1 class="title">Patient - {{item.FirstName | camelize}} {{item.LastName | camelize}}</h1>\n' +
    '    <div class="button button-clear" ng-click="modal.remove()"><span class="icon ion-close"></span></div>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="padding">\n' +
    '    <div class="inner-content">\n' +
    '      <div class="row" ng-show="item.Status == \'UltrasoundRequested\'">\n' +
    '        <div class="col"><h3>This item requires RIS record. Will you own this item and create RIS record for it?</h3>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row" ng-show="item.Status == \'UltrasoundRequested\'">\n' +
    '        <div class="col-45">\n' +
    '\n' +
    '          <button class="button button-large button-block button-dark exam-big-btn"\n' +
    '                  ng-click="model.assignToMe(item, false, $event); modal.remove()">\n' +
    '            Own this item\n' +
    '            <i class="icon ion-clipboard"></i>\n' +
    '          </button>\n' +
    '\n' +
    '        </div>\n' +
    '        <div class="col-45 col-offset-10">\n' +
    '\n' +
    '          <button class="button button-large button-block button-stable exam-big-btn"\n' +
    '                  ng-click="model.rejectUltrasound(item, true, $event); modal.remove()">\n' +
    '            Reject Ultrasound\n' +
    '            <i class="icon ion-eye"></i>\n' +
    '          </button>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row" ng-show="item.Status == \'RISWaiting\'">\n' +
    '        <div class="col-45">\n' +
    '\n' +
    '          <button class="button button-large button-block button-dark exam-big-btn"\n' +
    '                  ng-click="model.processCreatedRIS(item, false, $event); modal.remove()">\n' +
    '            I have created RIS record\n' +
    '            <i class="icon ion-clipboard"></i>\n' +
    '          </button>\n' +
    '\n' +
    '        </div>\n' +
    '        <div class="col-45 col-offset-10">\n' +
    '\n' +
    '          <!--<button class="button button-large button-block button-stable exam-big-btn" ng-click="model.rejectUltrasound(item, true, $event); modal.remove()">\n' +
    '            Cancel\n' +
    '            <i class="icon ion-eye"></i>\n' +
    '          </button>-->\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/ultrasoundTechniqueDetailsScrollTemplate.html',
    '<div class="row" ng-repeat="config in model.ultraSoundTechniqueOptions.UTSCAN">\n' +
    '  <div class="col col-50 label" ng-if="config.Type !== \'DATE\'">\n' +
    '    <label class="item">\n' +
    '      <b>{{config.Caption}}</b>\n' +
    '    </label>\n' +
    '  </div>\n' +
    '  <div class="col ultrasound-select-item"\n' +
    '    ng-if="config.Type === model.constantStrings.LIST && config.Name !== model.constantStrings.Lfrom && config.Name !== model.constantStrings.Lto">\n' +
    '    <dropdown-menu list="config.Options" disabled=\'vm.isViewOnly\' property="Desc" key="Code"\n' +
    '      empty-value="config.Name === \'Dto\' || config.Name === \'Dfrom\' ? \'0\' : \'\'" select-mode="true"\n' +
    '      show-caret="true" dropdown-height="225" hide-other-dropdown="true"\n' +
    '      selected="model.currentUSRecord[config.Name]"></dropdown-menu>\n' +
    '  </div>\n' +
    '  <div class="col ultrasound-select-item"\n' +
    '    ng-if="config.Type === model.constantStrings.LIST && config.Name === model.constantStrings.Lfrom">\n' +
    '    <div ng-dropdown-multiselect="" options="config.Options"\n' +
    '      selected-model="model.currentUSRecord.selectedLfromLocations"\n' +
    '      extra-settings="model.dropdownMultiSelectSetting" translation-texts="model.dropdownMultiSelectText"\n' +
    '      class="modal-dropdown ultrasound-multiselect-item" id="Lfrom-dropdown-multiselect">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col ultrasound-select-item"\n' +
    '    ng-if="config.Type === model.constantStrings.LIST && config.Name === model.constantStrings.Lto">\n' +
    '    <div ng-dropdown-multiselect="" options="config.Options"\n' +
    '      selected-model="model.currentUSRecord.selectedLtoLocations"\n' +
    '      extra-settings="model.dropdownMultiSelectSetting" translation-texts="model.dropdownMultiSelectText"\n' +
    '      class="modal-dropdown ultrasound-multiselect-item" id="Lto-dropdown-multiselect">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col" ng-if="config.Type === \'YESNO\'">\n' +
    '    <label class="checkbox pull-left">\n' +
    '      <input type="checkbox" ng-model="model.currentUSRecord[config.Name]" value="True"\n' +
    '        ng-true-value="\'True\'" ng-false-value="">\n' +
    '    </label>\n' +
    '    <label class="yesno-label pull-left">Yes</label>\n' +
    '    <label class="checkbox pull-left">\n' +
    '      <input type="checkbox" ng-model="model.currentUSRecord[config.Name]" value="False"\n' +
    '        ng-true-value="\'False\'" ng-false-value="">\n' +
    '    </label>\n' +
    '    <label class="yesno-label pull-left">No</label>\n' +
    '  </div>\n' +
    '  <div data-tap-disabled="false" class="col col-50 note"\n' +
    '    ng-if="config.Type === \'TEXT\' || config.Type === \'Text\'">\n' +
    '    <textarea class="text-input editable-textarea" ng-model="model.currentUSRecord[config.Name]"\n' +
    '      rows="4"></textarea>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/ultrasoundTechniqueSelectDialog.html',
    '<div class="modal ultrasound-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      Ultrasound Scan Technique\n' +
    '      <button class="button button-cancel" ng-click="model.cancel();">&times;</button>\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="form-page padding no-scroll">\n' +
    '    <div class="row h-100">\n' +
    '      <div class="col col-40 left-panel">\n' +
    '        <h4>Ultrasound Scan Techniques</h4>\n' +
    '          <ion-item ng-click="model.createNew()" class="m-t-20 create-new-ultrasound-technique">\n' +
    '            <div class="ripple">\n' +
    '              + Create New\n' +
    '            </div>\n' +
    '          </ion-item>\n' +
    '          <ion-scroll ng-if="model.isIOSDevice" zooming="false" direction="y" class="scrolling-list scroll" overflow-scroll="false">\n' +
    '            <ng-include src="\'views/templates/ultrasoundTechniqueSelectDialogScrollTemplate.html\'"></ng-include>\n' +
    '          </ion-scroll>\n' +
    '          <div ng-if="!model.isIOSDevice" class="scroll-y scroll scroll-scan-technique">\n' +
    '            <ng-include src="\'views/templates/ultrasoundTechniqueSelectDialogScrollTemplate.html\'"></ng-include>\n' +
    '          </div>\n' +
    '      </div>\n' +
    '      <div class="col col-60">\n' +
    '        <div ng-if="model.currentUSRecord" class="h-100">\n' +
    '          <div class="row ultrasound-editor-header">\n' +
    '            <div class="row ultrasound-editor-header-buttons">\n' +
    '              <button class="button button-assertive button-outline m-l-10" ng-click="model.delete();">Delete\n' +
    '              </button>\n' +
    '              <button class="button button-balanced button-outline m-l-10" ng-disabled="!model.checkChanges()"\n' +
    '                ng-click="model.save();">Save\n' +
    '              </button>\n' +
    '              <button class="button button-assertive button-outline" ng-disabled="!model.checkChanges()"\n' +
    '                ng-click="model.cancelEditing();">Cancel\n' +
    '              </button>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div zooming="false" \n' +
    '                direction="y" \n' +
    '                overflow-scroll="false"\n' +
    '                class="ultrasound-technoque-details-scoll-container h-100 scroll container-with-padding">                  \n' +
    '            <div class="row" ng-repeat="config in model.ultraSoundTechniqueOptions.UTSCAN">\n' +
    '              <div class="col col-50 label" ng-if="config.Type !== \'DATE\'">\n' +
    '                <label class="item">\n' +
    '                  <b>{{config.Caption}}</b>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '              <div class="col ultrasound-select-item"\n' +
    '                ng-if="config.Type === model.constantStrings.LIST && config.Name !== model.constantStrings.Lfrom && config.Name !== model.constantStrings.Lto">\n' +
    '                <dropdown-menu list="config.Options" disabled=\'vm.isViewOnly\' property="Desc" key="Code"\n' +
    '                  empty-value="config.Name === \'Dto\' || config.Name === \'Dfrom\' ? \'0\' : \'\'" select-mode="true"\n' +
    '                  show-caret="true" dropdown-height="225" hide-other-dropdown="true"\n' +
    '                  selected="model.currentUSRecord[config.Name]"></dropdown-menu>\n' +
    '              </div>\n' +
    '              <div ng-if="config.Type === model.constantStrings.LIST \n' +
    '                          && config.Name === model.constantStrings.Lfrom"\n' +
    '                    class="col ultrasound-select-item">\n' +
    '                <div ng-dropdown-multiselect="" \n' +
    '                      options="config.Options"\n' +
    '                      selected-model="model.currentUSRecord.selectedLfromLocations"\n' +
    '                      extra-settings="model.dropdownMultiSelectSetting" \n' +
    '                      translation-texts="model.dropdownMultiSelectText"\n' +
    '                      class="angular-dropdown-multiselect-custom scan-technique-location">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div ng-if="config.Type === model.constantStrings.LIST \n' +
    '                          && config.Name === model.constantStrings.Lto"\n' +
    '                    class="col ultrasound-select-item">\n' +
    '                <div ng-dropdown-multiselect="" \n' +
    '                      options="config.Options"\n' +
    '                      selected-model="model.currentUSRecord.selectedLtoLocations"\n' +
    '                      extra-settings="model.dropdownMultiSelectSetting" \n' +
    '                      translation-texts="model.dropdownMultiSelectText"\n' +
    '                      class="angular-dropdown-multiselect-custom scan-technique-location">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="col" ng-if="config.Type === \'YESNO\'">\n' +
    '                <label class="checkbox pull-left">\n' +
    '                  <input type="checkbox" ng-model="model.currentUSRecord[config.Name]" value="True"\n' +
    '                    ng-true-value="\'True\'" ng-false-value="">\n' +
    '                </label>\n' +
    '                <label class="yesno-label pull-left">Yes</label>\n' +
    '                <label class="checkbox pull-left">\n' +
    '                  <input type="checkbox" ng-model="model.currentUSRecord[config.Name]" value="False"\n' +
    '                    ng-true-value="\'False\'" ng-false-value="">\n' +
    '                </label>\n' +
    '                <label class="yesno-label pull-left">No</label>\n' +
    '              </div>\n' +
    '              <div data-tap-disabled="false" class="col col-50 note"\n' +
    '                ng-if="config.Type === \'TEXT\' || config.Type === \'Text\'">\n' +
    '                <textarea class="text-input editable-textarea" ng-model="model.currentUSRecord[config.Name]"\n' +
    '                  rows="4"></textarea>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>            \n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/ultrasoundTechniqueSelectDialogScrollTemplate.html',
    '<ion-list>\n' +
    '    <ion-item ng-repeat="result in model.scanResults" ng-class="{selected: result._____selected}"\n' +
    '        class="ultrasound-item" ng-click="model.loadUltraSoundDetail(result)">\n' +
    '        {{ result.Desc }}\n' +
    '    </ion-item>\n' +
    '</ion-list>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/uploadDocumentDialog.html',
    '<div class="modal modal-form">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h3 class="title">\n' +
    '      {{ model.title }}\n' +
    '    </h3>\n' +
    '  </header>\n' +
    '  <content has-header="true">\n' +
    '    <div class="inner-content">\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col col-20 text-right section-title">\n' +
    '          <label class="bold">Date:</label>\n' +
    '        </div>\n' +
    '        <div>\n' +
    '          <label class="item item-input">\n' +
    '            <input ng-model="model.data.date"\n' +
    '                   date-input="model.data.date"\n' +
    '                   disabled>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="col col-5 relative">\n' +
    '          <button type="button"\n' +
    '                  class="icon ion-calendar date-element"\n' +
    '                  ng-click="model.changeDate(model.data, \'date\')"></button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="col col-20 text-right section-title">\n' +
    '          <label class="bold">Description:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-80 relative">\n' +
    '          <label class="item item-input">\n' +
    '            <input class="m-t-10"\n' +
    '                   maxlength="50"\n' +
    '                   ng-model="model.data.description">\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col col-20 text-right section-title">\n' +
    '          <label class="bold top-10">Comment:</label>\n' +
    '        </div>\n' +
    '        <div class="col col-80">\n' +
    '          <textarea class="history-record-notes w-100 item-input"\n' +
    '                    ng-model="model.data.comment"\n' +
    '                    rows="5"></textarea>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row">\n' +
    '        <div class="documents-container col col-100 justify-content-center">\n' +
    '          <img ng-if="model.data.file && model.data.file.originalFile"\n' +
    '               ng-src="{{model.data.file.fileURL}}"\n' +
    '               ng-click="model.onEdit()"\n' +
    '               class="upload-preview-image">\n' +
    '          <img ng-if="model.data.file && !model.data.file.originalFile"\n' +
    '               src="../images/file-image.svg"\n' +
    '               ng-click="model.onEdit()"\n' +
    '               class="upload-preview-image">\n' +
    '          <div ng-if="!model.data.file"\n' +
    '               ng-click="model.upload()"\n' +
    '               ng-on-drop="model.onFileDroped($event)"\n' +
    '               ng-on-dragover="model.onDragOver($event)"\n' +
    '               class="upload-preview-image upload-box">\n' +
    '            <div class="ion-ios-cloud-upload"></div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div ng-if="model.data.file"\n' +
    '           class="row">\n' +
    '        <div class="documents-container col col-100 justify-content-center align-items-center">\n' +
    '          <a href=""\n' +
    '             ng-click="model.fileClicked()">{{ model.fileName }}</a>\n' +
    '          <div class="ion-ios-close-empty remove-btn"\n' +
    '               ng-click="model.remove()"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row m-t-15">\n' +
    '        <div class="col-50 padding-right">\n' +
    '          <button class="button button-positive button-block"\n' +
    '                  ng-click="model.save();">\n' +
    '            Import\n' +
    '          </button>\n' +
    '        </div>\n' +
    '        <div class="col-50 padding-left">\n' +
    '          <button class="button button-stable button-block back-btn"\n' +
    '                  ng-click="model.closeWindow();">\n' +
    '            Cancel\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </content>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/worklistChangeListMessageAndResource.html',
    '<ion-popover-view class="add-list-message-button-ion-popover-view"\n' +
    '                  ng-class="{\'ion-popover-content\': vm.cannedNotesConfig.noteItems.length > 0}">\n' +
    '  <ion-content scroll="true" class="overflow-hidden list-message-ion-content">\n' +
    '    <div class="list list-message-popover">\n' +
    '      <div class="row resource-item-row-container">\n' +
    '        <div class="resource-item-container">\n' +
    '          <div class="item item-icon resource-item" href="javascript:void(0)"\n' +
    '               ng-repeat="resource in availableResources"\n' +
    '               ng-click="vm.selectResourceForWorklist(worklistItem, resource, modal, isResourcesOnly);isResourcesOnly && vm.applyListMessageAndResource(worklistItem, modal);">\n' +
    '            <div class="checkbox resource-item-checkbox">\n' +
    '              <i class="icon ion-ios-checkmark-outline green" ng-show="vm.isResourceSelected(worklistItem, resource)"></i>\n' +
    '              <i class="icon ion-ios-circle-outline" ng-show="!vm.isResourceSelected(worklistItem, resource)"></i>\n' +
    '            </div>\n' +
    '            <div class="resource-item-label">{{resource.label}}</div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="row" ng-if="!isResourcesOnly">\n' +
    '        <label class="message-label">Message:</label>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="!isResourcesOnly">\n' +
    '        <textarea placeholder="Type message here"\n' +
    '                  class="list-messages-add-message col-100"\n' +
    '                  ng-model="worklistItem.newListMessage"\n' +
    '                  rows="4"\n' +
    '                  type="text"></textarea>\n' +
    '      </div>\n' +
    '      <div class="row" ng-if="!isResourcesOnly && ((vm.authService.isRadiologist() && !!worklistItem.ListMessage) || (!vm.authService.isRadiologist() && !!worklistItem.RadListMessage))">\n' +
    '        <label ng-if="vm.authService.isRadiologist() && !!worklistItem.ListMessage" class="another-role-message-label">Tech Mssage: {{worklistItem.ListMessage}}</label>\n' +
    '        <label ng-if="!vm.authService.isRadiologist() && !!worklistItem.RadListMessage" class="another-role-message-label">Rad Message: {{worklistItem.RadListMessage}}</label>\n' +
    '      </div>\n' +
    '      <div class="canned-dropbox inner-content"\n' +
    '           ng-if="!isResourcesOnly && vm.cannedNotesConfig.noteItems.length > 0">\n' +
    '        <div class="row" ng-if="!isResourcesOnly">\n' +
    '          <label class="fs-20">Canned Messages:</label>\n' +
    '        </div>\n' +
    '        <div class="row item item-input input-dropdown-container w-auto styled-dropdown"\n' +
    '             ng-if="!isResourcesOnly">\n' +
    '          <input-dropdown class="w-100"\n' +
    '                          list="vm.cannedNotesConfig.noteItems"\n' +
    '                          model="worklistItem"\n' +
    '                          property="Name"\n' +
    '                          propertyvalue="Value"\n' +
    '                          modelproperty="newListMessage"\n' +
    '                          disableenter="true"></input-dropdown>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="row text-right display-block" \n' +
    '           ng-if="!isResourcesOnly">\n' +
    '        <div class="col-100 buttons-block">\n' +
    '          <button class="button button-default add-list-message-button" ng-click="worklistItem.alreadySaved = true; checkAndApplyListMessageAndResourceIfNeeded();">Done</button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div  ng-if="vm.cannedNotesConfig.noteItems.length > 0"\n' +
    '            ng-style="{ \'height\': (20 * vm.cannedNotesConfig.noteItems.length) + 20 + \'px\' }">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '</ion-popover-view>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/worklistChangeResource.html',
    '<ion-popover-view>\n' +
    '  <ion-content scroll="true">\n' +
    '    <div class="list">\n' +
    '      <a class="item item-icon" href="javascript:void(0)" ng-repeat="item in vm.techpadConfig.settings.Resources | filter:{IsInUse: false}"\n' +
    '        ng-click="vm.changeResource(worklistItem, item.Label);modal.remove()">\n' +
    '        {{item.Label}}\n' +
    '      </a>\n' +
    '      <a class="item item-icon red-colored" ng-if="!vm.techpadConfig.settings.Resources.length && !!item.Resource"\n' +
    '        href="javascript:void(0)" ng-click="modal.remove();">\n' +
    '        {{ item.Resource }}\n' +
    '      </a>\n' +
    '      <a class="item item-icon red-colored" ng-if="!vm.techpadConfig.settings.Resources.length && !item.Resource"\n' +
    '        href="javascript:void(0)" ng-click="modal.remove();">\n' +
    '        No resources configured\n' +
    '      </a>\n' +
    '      <a class="item item-icon red-colored" href="javascript:void(0)" ng-if="showRemoveResource"\n' +
    '        ng-click="vm.changeResource(worklistItem, \'\');modal.remove()">\n' +
    '        Remove {{vm.techpadConfig.settings.ResourcesTitle}}\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '</ion-popover-view>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/worklistChangeStatus.html',
    '<ion-popover-view class="settings-popover">\n' +
    '  <ion-content scroll="false">\n' +
    '   <div class="list">\n' +
    '      <a ng-repeat="surveyStatusItem in SurveyStatusItems" ng-if="surveyStatusItem.shouldShow" class="item item-icon" href="javascript:void(0)"\n' +
    '         ng-click="vm.changeStatus(item, surveyStatusItem.value);modal.remove()" >\n' +
    '         {{vm.statusHelpers.getStatusName(surveyStatusItem.value);}}\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '</ion-popover-view>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/worklistChangeTags.html',
    '<ion-popover-view class="settings-popover tags-popover">\n' +
    '  <ion-content scroll="false">\n' +
    '    <div class="list">\n' +
    '      <div class="item item-icon tag-item" ng-if="!vm.techpadConfig.settings.Tags || !vm.techpadConfig.settings.Tags.length">        \n' +
    '        <div class="tag-item-label no-tags-label">No Tags</div>\n' +
    '      </div>\n' +
    '      <div class="item item-icon tag-item" href="javascript:void(0)" ng-if="vm.techpadConfig.settings.Tags && vm.techpadConfig.settings.Tags.length"\n' +
    '           ng-repeat="tag in vm.techpadConfig.settings.Tags"\n' +
    '           ng-click="vm.toggleTag(item, tag);modal.remove()">\n' +
    '        <div class="checkbox tag-item-checkbox">\n' +
    '          <i class="icon ion-ios-checkmark-outline green" ng-show="isTagSelected(item, tag)"></i>\n' +
    '          <i class="icon ion-ios-circle-outline" ng-show="!isTagSelected(item, tag)"></i>\n' +
    '        </div>\n' +
    '        <div class="tag-item-label">{{tag.Label}}</div>\n' +
    '      </div>\n' +
    '      <!-- <a class="item item-icon" href="javascript:void(0)"\n' +
    '        ng-repeat="tag in vm.techpadConfig.settings.Tags"\n' +
    '         ng-click="vm.toggleTag(item);modal.remove()">\n' +
    '         {{vm.statusHelpers.getStatusName(\'SurveyFinished\');}} -->\n' +
    '         <!-- {{tag.Label}} -->\n' +
    '      <!-- </a> -->\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '</ion-popover-view>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/worklistFilters.html',
    '<div class="modal worklist-filtering-modal">\n' +
    '  <header class="bar bar-header bar-dark">\n' +
    '    <h1 class="title">Worklist Filtering</h1>\n' +
    '    <div class="button button-clear" ng-click="model.cancelChanges();"><span class="icon ion-close"></span></div>\n' +
    '  </header>\n' +
    '  <content has-header="true" class="padding">\n' +
    '    <div class="row h-100 scroll">\n' +
    '      <div class="col-50 p-r-10">\n' +
    '\n' +
    '        <div ng-if="model.showStudyDateOnWorklistPage && model.showAppointmentTime">\n' +
    '          <h4>Sorting</h4>\n' +
    '          <ion-scroll ng-if="model.isIOSDevice" class="dynamic-filter" overflow-scroll="false" zooming="false" direction="y">\n' +
    '            <ng-include src="\'views/templates/filters/worklistFiltersSortingScrollTemplate.html\'"></ng-include>\n' +
    '            </ul>\n' +
    '          </ion-scroll>\n' +
    '          <div ng-if="!model.isIOSDevice" class="scroll-y scroll dynamic-filter">\n' +
    '            <ng-include src="\'views/templates/filters/worklistFiltersSortingScrollTemplate.html\'"></ng-include>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-if="model.showStudyDateOnWorklistPage && !model.showAppointmentTime">\n' +
    '          <h4>Sorting</h4>\n' +
    '          <ion-scroll ng-if="model.isIOSDevice" class="dynamic-filter" overflow-scroll="false" zooming="false" direction="y">\n' +
    '            <ng-include src="\'views/templates/filters/worklistFiltersStudyDateTemplate.html\'"></ng-include>\n' +
    '            </ul>\n' +
    '          </ion-scroll>\n' +
    '          <div ng-if="!model.isIOSDevice" class="scroll-y scroll dynamic-filter">\n' +
    '            <ng-include src="\'views/templates/filters/worklistFiltersStudyDateTemplate.html\'"></ng-include>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-if="model.showAppointmentTime && !model.showStudyDateOnWorklistPage">\n' +
    '          <h4>Sorting</h4>\n' +
    '          <ion-scroll ng-if="model.isIOSDevice" class="dynamic-filter" overflow-scroll="false" zooming="false" direction="y">\n' +
    '            <ng-include src="\'views/templates/filters/worklistFiltersAppointmentTimeTemplate.html\'"></ng-include>\n' +
    '            </ul>\n' +
    '          </ion-scroll>\n' +
    '          <div ng-if="!model.isIOSDevice" class="scroll-y scroll dynamic-filter">\n' +
    '            <ng-include src="\'views/templates/filters/worklistFiltersAppointmentTimeTemplate.html\'"></ng-include>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <h4>Quick filter</h4>\n' +
    '        <ion-scroll ng-if="model.isIOSDevice" class="dynamic-filter" overflow-scroll="false" zooming="false" direction="y">\n' +
    '          <ng-include src="\'views/templates/filters/worklistFiltersQuickFiltersScrollTemplate.html\'"></ng-include>\n' +
    '        </ion-scroll>\n' +
    '        <div ng-if="!model.isIOSDevice" class="scroll-y scroll dynamic-filter">\n' +
    '          <ng-include src="\'views/templates/filters/worklistFiltersQuickFiltersScrollTemplate.html\'"></ng-include>\n' +
    '        </div>        \n' +
    '\n' +
    '        <h4>Visit Type</h4>\n' +
    '        <ion-scroll ng-if="model.isIOSDevice" class="dynamic-filter" overflow-scroll="false" zooming="false" direction="y">\n' +
    '          <ng-include src="\'views/templates/filters/worklistFiltersVisitTypeScrollTemplate.html\'"></ng-include>\n' +
    '        </ion-scroll>\n' +
    '        <div ng-if="!model.isIOSDevice" class="scroll-y scroll dynamic-filter">\n' +
    '          <ng-include src="\'views/templates/filters/worklistFiltersVisitTypeScrollTemplate.html\'"></ng-include>\n' +
    '        </div>      \n' +
    '\n' +
    '        <h4>Exam Type</h4>\n' +
    '        <ion-scroll ng-if="model.isIOSDevice" class="dynamic-filter examTypes" overflow-scroll="false" zooming="false" direction="y">\n' +
    '          <ng-include src="\'views/templates/filters/worklistFiltersExamTypeScrollTemplate.html\'"></ng-include>\n' +
    '        </ion-scroll>\n' +
    '        <div ng-if="!model.isIOSDevice" class="dynamic-filter scroll list examTypes scroll-y">\n' +
    '          <ng-include src="\'views/templates/filters/worklistFiltersExamTypeScrollTemplate.html\'"></ng-include>\n' +
    '        </div>\n' +
    '        <br/>\n' +
    '\n' +
    '        <ul class="list" ng-if="techpadSettings.IsTechpadDemoMode">\n' +
    '          <li class="item item-checkbox">\n' +
    '            <label class="checkbox">\n' +
    '              <input type="checkbox" \n' +
    '                     ng-model="model.filters.ShowAllExams"\n' +
    '                     ng-change="model.onShowAllExamCheckChanged()">\n' +
    '            </label>\n' +
    '            Show all exams (ignore all other filters)\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '        <br/>\n' +
    '\n' +
    '      </div>\n' +
    '      <div class="col-50 p-l-10">\n' +
    '\n' +
    '        <h4>Locations</h4>\n' +
    '\n' +
    '        <ion-scroll ng-if="model.isIOSDevice" class="dynamic-filter locations" overflow-scroll="false" zooming="false" direction="y">\n' +
    '          <ng-include src="\'views/templates/filters/worklistFiltersLocationScrollTemplate.html\'"></ng-include>\n' +
    '        </ion-scroll>\n' +
    '        <div ng-if="!model.isIOSDevice" class="scroll-y scroll dynamic-filter dynamic-filter locations">\n' +
    '          <ng-include src="\'views/templates/filters/worklistFiltersLocationScrollTemplate.html\'"></ng-include>\n' +
    '        </div>\n' +
    '        \n' +
    '        <h4>Patient steps</h4>\n' +
    '\n' +
    '        <ion-scroll ng-if="model.isIOSDevice" class="dynamic-filter" overflow-scroll="false" zooming="false" direction="y">\n' +
    '          <ng-include src="\'views/templates/filters/worklistFiltersPatientStepsScrollTemplate.html\'"></ng-include>\n' +
    '        </ion-scroll>\n' +
    '        <div ng-if="!model.isIOSDevice" class="scroll-y scroll dynamic-filter">\n' +
    '          <ng-include src="\'views/templates/filters/worklistFiltersPatientStepsScrollTemplate.html\'"></ng-include>\n' +
    '        </div>    \n' +
    '\n' +
    '        <h4>Tags</h4>\n' +
    '\n' +
    '        <ion-scroll ng-if="model.isIOSDevice" class="dynamic-filter" overflow-scroll="false" zooming="false" direction="y">\n' +
    '          <ng-include src="\'views/templates/filters/worklistFiltersTagsScrollTemplate.html\'"></ng-include>\n' +
    '        </ion-scroll>\n' +
    '        <div ng-if="!model.isIOSDevice" class="scroll-y scroll dynamic-filter">\n' +
    '          <ng-include src="\'views/templates/filters/worklistFiltersTagsScrollTemplate.html\'"></ng-include>\n' +
    '        </div> \n' +
    '\n' +
    '        <div class="padding text-right filter-buttons">\n' +
    '          <button class="button button-positive button-large" type="button" ng-click="model.saveSettings();">\n' +
    '            Save\n' +
    '          </button>\n' +
    '          <button class="button button-stable button-large" type="button" ng-click="model.cancelChanges();">\n' +
    '            Cancel\n' +
    '          </button>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </content>\n' +
    '</div>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/worklistFiltersScrollTemplate.html',
    '<ul class="list">\n' +
    '    <li class="item item-checkbox" ng-repeat="location in model.locations">\n' +
    '      <label class="checkbox">\n' +
    '        <input type="checkbox" \n' +
    '               ng-checked="model.locationsChecked(location)" \n' +
    '               ng-click="model.toggleLocations(location)">\n' +
    '      </label>\n' +
    '      {{location.Value | camelize}}\n' +
    '    </li>\n' +
    '  </ul>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/worklistListTemplate.html',
    '<ion-refresher ng-if="vm.isIOSDevice" pulling-text="Release to refresh..." on-refresh="vm.hardRefresh()">\n' +
    '</ion-refresher>\n' +
    '<ion-list id="worklist" class="list worklist-items">\n' +
    '  <ion-item class="item item-thumbnail-left item-icon-right repeat-animation"\n' +
    '            ng-repeat="item in vm.allItems"               \n' +
    '            ng-animate="\'animate\'"\n' +
    '            ng-class="{ \'item-disabled\': !vm.canOpenItem(item) }">\n' +
    '    <i class="item-image icon {{vm.getIcon(item.Status)}} icon-large"\n' +
    '       ng-style="{\'color\': vm.getColor(item.Status)}"></i>\n' +
    '    <span title="Appointment Time" ng-if="vm.ShowAppointmentTimeOnWorklist(item.AppointmentTime)" \n' +
    '          class="app-date-time">\n' +
    '      {{ item.AppointmentTime }}\n' +
    '    </span>\n' +
    '    <div class="row {{vm.getWorklistRowClass(item)}}" \n' +
    '         ng-click="vm.techpadConfig.settings.IsDashboardMode ? vm.showDashboardWindow(item) : vm.showExamWindow(item)">\n' +
    '      <div class="item-options-info">\n' +
    '        <div class="title patient-name-container" ng-class="{\'center-item\': !item.Technologist && !item.IsLinkedStudy}">\n' +
    '          {{ item.LastName + \', \' + item.FirstName | camelize }}\n' +
    '        </div>\n' +
    '        <div class="title ssn-container">\n' +
    '          <span class="ssn">{{!vm.techpadConfig.settings.UseAlternateUserIdentifier ? item.Ssn : item.ExternalId }}</span>\n' +
    '          <span ng-show="vm.techpadConfig.settings.ShowDateOfBirthOnWorklistPage"\n' +
    '                class="dob"> (DOB: {{ vm.formatDateString(item.DateOfBirth, true) }})</span>\n' +
    '          <span ng-class="{\'tag-element-with-small-margin\': !item.Technologist}"\n' +
    '          ng-show="item.Tags && item.Tags.length" class="tag-element"\n' +
    '          ng-style="{\'background-color\': !vm.darkMode ? vm.techpadConfig.settings.TagBackgroundColor : vm.techpadConfig.settings.TagBackgroundColorDarkMode, \n' +
    '                    \'color\': !vm.darkMode ? vm.techpadConfig.settings.TagColor : vm.techpadConfig.settings.TagColorDarkMode}"\n' +
    '          ng-repeat="tag in item.Tags.split(\';\')">{{tag}}</span>\n' +
    '        </div>\n' +
    '        <span class="technologist-info">\n' +
    '          <span ng-show="item.Technologist" class="tech-name-container">\n' +
    '            <div ng-show="item.Technologist" >\n' +
    '              <i class="icon ion-clipboard technologist-icon"></i>\n' +
    '            </div>\n' +
    '            <div ng-show="item.Technologist" class="tech-name-label">\n' +
    '              {{ item.Technologist.FirstName + \' \' + item.Technologist.LastName | camelize}}\n' +
    '            </div>\n' +
    '            <span ng-show="item.IsLinkedStudy" class="linked-exam">(Linked exam)</span>           \n' +
    '          </span>\n' +
    '          <span ng-show="item.IsNoStudy === true">(Study doesn\'t exist)</span>\n' +
    '          <span ng-show="item.IsMissingPatient === true">(Patient not found)</span>\n' +
    '        </span>\n' +
    '      </div>\n' +
    '      <div class="patient-info"\n' +
    '           ng-style="{\'color\': vm.getColor(item.Status)}">\n' +
    '        <div>\n' +
    '          <div class="title proc-info-container whitespace-normal">\n' +
    '            <span class="study-date"\n' +
    '              ng-if="vm.techpadConfig.settings && vm.techpadConfig.settings.ShowStudyDateOnWorklistPage">\n' +
    '                {{ item.StudyDate | date:\'shortDate\' }} - \n' +
    '            </span>\n' +
    '            {{ vm.techpadConfig.settings.IsDashboardMode ? item.VisitTypeDescription : item.ProcedureDescription }}\n' +
    '          </div>\n' +
    '          <div ng-show="vm.techpadConfig.settings.ShowAccessionOnWorklistPage"\n' +
    '               class="title accession-container">\n' +
    '            {{item.Accession}}\n' +
    '          </div>\n' +
    '          <div class="worklist-message-container relative display-flex align-items-center max-width-100" onClick="return true;" \n' +
    '               ng-click="vm.changeListMessageAndResourcePopover(item, $event)">\n' +
    '            <div class="list-message schedule-message-container display-flex" \n' +
    '                 ng-class="{\'dashboard-mode\': vm.techpadConfig.settings.IsDashboardMode}">\n' +
    '              <span class="whitespace-normal" ng-if="vm.techpadConfig.settings && vm.techpadConfig.settings.ShowAppointmentTimeOnWorklist">\n' +
    '                {{ (item.ScheduleTime | date:\'hh:mm a\') }}\n' +
    '              </span>\n' +
    '              <span class="whitespace-normal list-message-container ellipsis-overflow pl-0 pr-0"\n' +
    '                    ng-style="{color: !vm.techpadConfig.settings.IsDashboardMode ? item.ListMessageColor || \'\' : \'\'}" \n' +
    '                    ng-class="{\'dashboard-color\': vm.techpadConfig.settings.IsDashboardMode, \'red-color\': !vm.techpadConfig.settings.IsDashboardMode && !item.ListMessageColor}"\n' +
    '                    ng-if="item.RadListMessage || item.ListMessage || item.Resource">\n' +
    '                <span class="whitespace-normal resource" ng-if="item.Resource">{{item.Resource}}</span><span ng-if="item.Resource">: </span>\n' +
    '                <span class="whitespace-normal resource-divider" ng-if="item.Resource && (item.ListMessage || item.RadListMessage)">|</span>\n' +
    '                <span class="whitespace-normal" ng-if="!!item.ListMessage" class="max-200">Tech: {{ item.ListMessage }}</span>\n' +
    '                <span class="whitespace-normal resource-divider" ng-if="item.RadListMessage">|</span>\n' +
    '                <span class="whitespace-normal" ng-if="!!item.RadListMessage" class="red-color"> Rad: {{ item.RadListMessage }}</span>\n' +
    '              </span>\n' +
    '              <span ng-style="{color: !vm.techpadConfig.settings.IsDashboardMode ? item.ListMessageColor || \'\' : \'\'}"                         \n' +
    '                    ng-if="!item.ListMessage && !item.Resource"\n' +
    '                    class="list-message-container">\n' +
    '                <span ng-class="{\'dashboard-color\': vm.techpadConfig.settings.IsDashboardMode, \'red-color\': !vm.techpadConfig.settings.IsDashboardMode && !item.ListMessageColor}">\n' +
    '                  Enter Message\n' +
    '                </span>                    \n' +
    '              </span>\n' +
    '            </div>                \n' +
    '            <i class="icon ion-android-arrow-dropdown worklist-item-dropdown-icon relative-important"></i>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="item-note"\n' +
    '           ng-style="{\'color\': vm.getColor(item.Status)}">\n' +
    '        <div>\n' +
    '          <span class="status title">\n' +
    '            {{ vm.getStatusName(item.Status) }}\n' +
    '          </span>\n' +
    '          <div class="time-container" \n' +
    '                ng-if="!vm.techpadConfig.settings || !vm.techpadConfig.settings.ShowBothTotalTimeAndLastStatusTimeInWorklist">\n' +
    '            {{ !vm.displayTotalTimePatientHasBeen ? vm.formatDate(item.LastUpdate, true) : vm.formatDate(item.WorklistTimeLogs[0].StatusUpdateTime) }}\n' +
    '          </div>\n' +
    '          <div class="time-container" \n' +
    '                ng-if="vm.techpadConfig.settings && vm.techpadConfig.settings.ShowBothTotalTimeAndLastStatusTimeInWorklist">\n' +
    '            {{item.WorklistTimeLogs.length == 1 ? vm.formatDate(item.WorklistTimeLogs[0].StatusUpdateTime) : vm.formatDate(item.LastUpdate, true) }} (Total: {{vm.formatDate(item.WorklistTimeLogs[0].StatusUpdateTime)}})\n' +
    '          </div>\n' +
    '          <div ng-if="item.ArrivalStatus == \'PatientArrived\' || item.ArrivalStatus == \'ReadyForExam\'" \n' +
    '               class="white-space-pre-line imhere-message-container">\n' +
    '            <div class="error-message-container {{vm.GetImHereStatusMessageClass(item.ArrivalStatus)}}">\n' +
    '              {{ vm.GetImHereStatusMessage(item.ArrivalStatus) }}\n' +
    '            </div>\n' +
    '            <div>\n' +
    '              <i class="fas {{ vm.GetImHereStatusIconClass(item.ArrivalStatus) }} warning-icon"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div ng-if="item.Status != \'UltrasoundRequested\' && item.Status != \'RISWaiting\'">\n' +
    '      <button class="icon ion-ios-circle-outline open-icon button button-clear no-activated-state"              \n' +
    '              swipe-on-click="item.isSwiped">\n' +
    '        <i class="icon"\n' +
    '           ng-class="{ \'ion-ios-arrow-right\' : item.isSwiped, \'ion-ios-arrow-left\': !item.isSwiped }"></i>\n' +
    '      </button>\n' +
    '      <ion-option-button class="button-position button-assertive" ng-disabled="!isOnline()" \n' +
    '                         ng-if="!vm.techpadConfig.settings.IsDashboardMode && vm.userPermissions.IsAbleToRemoveWorklist">\n' +
    '        <ripple class="white-colored" ng-click="vm.deleteItem(item, modal)">Remove</ripple>\n' +
    '      </ion-option-button>\n' +
    '      <ion-option-button class="button-position button-info" ng-disabled="!isOnline()" \n' +
    '                         ng-if="vm.enableOutsideStudiesOption && !vm.techpadConfig.settings.IsDashboardMode && !item.IsMissingPatient">\n' +
    '        <ripple ng-click="vm.addOutsideStudy(item, $event)">Outside<br> studies</ripple>\n' +
    '      </ion-option-button>\n' +
    '      <ion-option-button class="button-position button-info" \n' +
    '                         ng-disabled="!isOnline()" \n' +
    '                         ng-if="vm.enableLinkExamsOption && !vm.techpadConfig.settings.IsDashboardMode && item.HasSameDateStudies && !item.IsMissingPatient">\n' +
    '        <ripple ng-click="vm.openLinkedStudies(item, $event)">Link<br> Exams</ripple>\n' +
    '      </ion-option-button>\n' +
    '      <ion-option-button class="button-position button-info" ng-if="vm.shouldShowTags && !item.IsMissingPatient" \n' +
    '                         ng-disabled="!isOnline() || !vm.canChangeStatus(item)">\n' +
    '        <ripple ng-click="vm.changeTagsPopover(item, $event)">Change<br> Tags</ripple>\n' +
    '      </ion-option-button>\n' +
    '      <ion-option-button class="button-position button-info" ng-if="!item.IsMissingPatient"\n' +
    '                         ng-disabled="!isOnline() || !vm.canChangeStatus(item)">\n' +
    '        <ripple ng-click="vm.techpadConfig.settings.IsDashboardMode ? vm.changeDashboardItemStatusPopover(item, $event) : vm.changeStatusPopover(item, $event)">\n' +
    '          Change<br> Status</ripple>\n' +
    '      </ion-option-button>\n' +
    '    </div>\n' +
    '  </ion-item>\n' +
    '  <ion-item ng-if="vm.isLoadingMore" class="text-center">\n' +
    '    <ion-spinner></ion-spinner>\n' +
    '            Loading...\n' +
    '  </ion-item>\n' +
    '  <ion-item class="text-center" ng-if="!vm.stopInfiniteLoad && !vm.isLoadingMore && !vm.isIOSDevice">\n' +
    '      <a href="javascript:void(0)" class="show-more-link" ng-click="vm.loadMore()">Show More</a>\n' +
    '  </ion-item>\n' +
    '</ion-list>\n' +
    '<ion-infinite-scroll ng-if="!vm.stopInfiniteLoad && vm.isIOSDevice" icon="ion-loading-c" on-infinite="vm.loadMore($event)"\n' +
    '                     distance="30">\n' +
    '</ion-infinite-scroll>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/worklistSettingsPopover.html',
    '<ion-popover-view class="settings-popover">\n' +
    '  <ion-content scroll="false">\n' +
    '    <div class="list">\n' +
    '      <a class="item item-icon" href="javascript:void(0)" ng-click="vm.showFilters();popover.hide()">\n' +
    '        <i class="ion-funnel"></i>\n' +
    '        Filters\n' +
    '      </a>\n' +
    '      <a class="item item-icon" href="javascript:void(0)" ng-click="logout()" ng-disabled="!vm.isOnline()">\n' +
    '        <i class="ion-log-out"></i>\n' +
    '        Logout\n' +
    '      </a>\n' +
    '    </div>\n' +
    '  </ion-content>\n' +
    '</ion-popover-view>\n' +
    '');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/worklistTabTemplate.html',
    '<div ng-class="{ \'offline-mode\': !isOnline, \'darkmode-clear\': vm.darkMode}">\n' +
    '  <ion-header-bar class="bar-texture">\n' +
    '    <div class="buttons left-buttons">\n' +
    '      <span>\n' +
    '        <button class="button button-icon button-clear ion-navicon ripple" ng-click="toggleLeft()"></button>\n' +
    '      </span>\n' +
    '    </div>\n' +
    '    <h1 class="title title-left" ng-if="!vm.techpadConfig.settings.IsDashboardMode">{{ vm.pageTitle }}</h1>\n' +
    '    <h1 class="title title-left title-without-burger" ng-if="vm.techpadConfig.settings.IsDashboardMode">Dashboard</h1>\n' +
    '    <div class="buttons right-buttons user-name-section">\n' +
    '      <div class="display-flex" ng-if="vm.enableSearchButton">\n' +
    '        <div class="search-box" ng-if="vm.isSearchInputVisiable && isOnline()">\n' +
    '          <input type="text" ng-model="vm.filterObj.search" ng-keypress="vm.searchOnKeyPress($event)">\n' +
    '          <button id="search-btn" class="button button-balanced inline-button ripple"\n' +
    '            ng-click="vm.search()">Search</button>\n' +
    '        </div>\n' +
    '        <button id="searchBox-btn" class="button button-icon ion-search button-refresh ripple"\n' +
    '          ng-if="!vm.isSearchInputVisiable || !isOnline()" ng-disabled="!isOnline()"\n' +
    '                ng-click="vm.isSearchInputVisiable = !vm.isSearchInputVisiable;"></button>\n' +
    '      </div>\n' +
    '      <button id="refresh-btn" class="button button-icon ion-refresh button-refresh ripple"\n' +
    '              ng-click="vm.hardRefresh(true)"\n' +
    '              ng-disabled="vm.shouldDisableRefreshBtn()"\n' +
    '              disable-animation\n' +
    '              ng-class="{\'ion-refresh\': vm.allItems !== null, \'ion-refreshing\': vm.allItems == null || vm.shouldDisableRefreshBtn()}"></button>\n' +
    '      <button ng-if="vm.enableFilterButton" \n' +
    '              id="funnel-btn" class="button button-icon ion-funnel button-refresh ripple"\n' +
    '              ng-click="vm.showFilters();popover.hide()"\n' +
    '              ng-disabled="!isOnline()"></button>        \n' +
    '      <button id="chat-btn" class="button button-icon ripple chat-bubble-button" ng-if="$root.techpadSettings.IsShowChatMenuItem">\n' +
    '        <chat-bubble-component ng-if="$root.techpadSettings.IsShowChatMenuItem"></chat-bubble-component>\n' +
    '      </button>\n' +
    '      <network-status-checker></network-status-checker>\n' +
    '      <p id="username-label" class="button button-clear">{{getUserName()}}</p>\n' +
    '      <button id="logout-btn" class="button button-icon ion-log-out" ng-click="logout()" ng-disabled="!vm.isOnline()"></button>\n' +
    '    </div>\n' +
    '  </ion-header-bar>\n' +
    '  <ion-scroll ng-if="vm.isIOSDevice" zooming="false" direction="y" class="scroll-y worklist-wrapper has-header"\n' +
    '              overflow-scroll="false">\n' +
    '    <ng-include src="\'views/templates/worklistListTemplate.html\'"></ng-include>\n' +
    '  </ion-scroll>\n' +
    '  <div ng-if="!vm.isIOSDevice" class="worklist-wrapper has-header">\n' +
    '    <ng-include src="\'views/templates/worklistListTemplate.html\'"></ng-include>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/filters/worklistFiltersAppointmentTimeTemplate.html',
    '<ul class="list">\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" ng-checked="model.sortingOptionsChecked(model.constantStrings.DefaultSortOption)" ng-click="model.toggleSortingOptions(model.constantStrings.DefaultSortOption)">\n' +
    '    </label>\n' +
    '    Default Sort Order\n' +
    '  </li>\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" ng-checked="model.sortingOptionsChecked(model.constantStrings.AppoinmentSortOptionDesc)" ng-click="model.toggleSortingOptions(model.constantStrings.AppoinmentSortOptionDesc)">\n' +
    '    </label>\n' +
    '    Appointment Time Desc\n' +
    '  </li>\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" ng-checked="model.sortingOptionsChecked(model.constantStrings.AppoinmentSortOptionAsc)" ng-click="model.toggleSortingOptions(model.constantStrings.AppoinmentSortOptionAsc)">\n' +
    '    </label>\n' +
    '    Appointment Time ASC\n' +
    '  </li>\n' +
    '</ul>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/filters/worklistFiltersExamTypeScrollTemplate.html',
    '<ul class="list">\n' +
    '    <li class="item item-checkbox">\n' +
    '        <label class="checkbox">\n' +
    '            <input type="checkbox" ng-checked="model.examTypeChecked(model.constantStrings.allOption)"\n' +
    '                ng-click="model.toggleExamType(model.constantStrings.allOption)">\n' +
    '        </label>\n' +
    '        All\n' +
    '    </li>\n' +
    '    <li class="item item-checkbox" ng-repeat="type in model.examTypes">\n' +
    '        <label class="checkbox">\n' +
    '            <input type="checkbox" ng-checked="model.examTypeChecked(type)" ng-click="model.toggleExamType(type)">\n' +
    '        </label>\n' +
    '        {{type}}\n' +
    '    </li>\n' +
    '</ul>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/filters/worklistFiltersLocationScrollTemplate.html',
    '<ul class="list">\n' +
    '    <li class="item item-checkbox" ng-repeat="location in model.locations">\n' +
    '        <label class="checkbox">\n' +
    '            <input type="checkbox" ng-checked="model.locationsChecked(location)"\n' +
    '                ng-click="model.toggleLocations(location)">\n' +
    '        </label>\n' +
    '        {{ location.Value }}\n' +
    '    </li>\n' +
    '</ul>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/filters/worklistFiltersPatientStepsScrollTemplate.html',
    '<ul class="list filter-statuses-list" ng-if="!model.techpadConfig.settings.IsDashboardMode">\n' +
    '    <li class="item item-checkbox" ng-repeat="status in model.statusGroups">\n' +
    '        <label class="checkbox">\n' +
    '            <input type="checkbox" ng-model="status.value">\n' +
    '        </label>\n' +
    '        {{status.name}}\n' +
    '    </li>\n' +
    '</ul>\n' +
    '<ul class="list filter-statuses-list" ng-if="model.techpadConfig.settings.IsDashboardMode">\n' +
    '    <li class="item item-checkbox" ng-repeat="status in model.statuses">\n' +
    '        <label class="checkbox">\n' +
    '            <input type="checkbox" ng-model="status.shouldFilter">\n' +
    '        </label>\n' +
    '        {{status.Label}}\n' +
    '    </li>\n' +
    '</ul>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/filters/worklistFiltersQuickFiltersScrollTemplate.html',
    '<ul class="list">\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" \n' +
    '              ng-model="model.filters.ShowMyExamsOnly" \n' +
    '              ng-change="model.onMyExamFilterCheckChanged()">\n' +
    '    </label>\n' +
    '    Show only my exams\n' +
    '  </li>\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" \n' +
    '              ng-model="model.filters.ShowTodayExamsOnly"\n' +
    '              ng-change="model.onTodayOnlyCheckChanged()">\n' +
    '    </label>\n' +
    '    Show only today\'s exams\n' +
    '  </li>  \n' +
    '  <li class="item item-checkbox filter-with-select-container">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" ng-model="model.filters.ShowNLastDaysExams"\n' +
    '        ng-change="model.onShowNLastDaysCheckChanged()">\n' +
    '    </label>\n' +
    '    Show N last days exams:\n' +
    '    <dropdown-menu class="filter-n-days-dropdown modal-dropdown"\n' +
    '                   select-mode="true"\n' +
    '                   selected="model.filters.NumberOfLastDaysToShow"\n' +
    '                   list="model.NumberOfLastDaysToShowOptions"\n' +
    '                   hide-clean-button="true"\n' +
    '                   display-property="value" \n' +
    '                   property="label" \n' +
    '                   key="value"></dropdown-menu>\n' +
    '    </dropdown-menu>\n' +
    '  </li>\n' +
    '</ul>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/filters/worklistFiltersSortingScrollTemplate.html',
    '<ul class="list">\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" ng-checked="model.sortingOptionsChecked(model.constantStrings.DefaultSortOption)" ng-click="model.toggleSortingOptions(model.constantStrings.DefaultSortOption)">\n' +
    '    </label>\n' +
    '    Default Sort Order\n' +
    '  </li>\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" ng-checked="model.sortingOptionsChecked(model.constantStrings.StudyDateSortOptionDesc)" ng-click="model.toggleSortingOptions(model.constantStrings.StudyDateSortOptionDesc)">\n' +
    '    </label>\n' +
    '    Study Date Desc\n' +
    '  </li>\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" ng-checked="model.sortingOptionsChecked(model.constantStrings.StudyDateSortOptionAsc)" ng-click="model.toggleSortingOptions(model.constantStrings.StudyDateSortOptionAsc)">\n' +
    '    </label>\n' +
    '    Study Date ASC\n' +
    '  </li>\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" ng-checked="model.sortingOptionsChecked(model.constantStrings.AppoinmentSortOptionDesc)" ng-click="model.toggleSortingOptions(model.constantStrings.AppoinmentSortOptionDesc)">\n' +
    '    </label>\n' +
    '    Appointment Time Desc\n' +
    '  </li>\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" ng-checked="model.sortingOptionsChecked(model.constantStrings.AppoinmentSortOptionAsc)" ng-click="model.toggleSortingOptions(model.constantStrings.AppoinmentSortOptionAsc)">\n' +
    '    </label>\n' +
    '    Appointment Time ASC\n' +
    '  </li>\n' +
    '</ul>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/filters/worklistFiltersStudyDateTemplate.html',
    '<ul class="list">\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" ng-checked="model.sortingOptionsChecked(model.constantStrings.DefaultSortOption)" ng-click="model.toggleSortingOptions(model.constantStrings.DefaultSortOption)">\n' +
    '    </label>\n' +
    '    Default Sort Order\n' +
    '  </li>\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" ng-checked="model.sortingOptionsChecked(model.constantStrings.StudyDateSortOptionDesc)" ng-click="model.toggleSortingOptions(model.constantStrings.StudyDateSortOptionDesc)">\n' +
    '    </label>\n' +
    '    Study Date Desc\n' +
    '  </li>\n' +
    '  <li class="item item-checkbox">\n' +
    '    <label class="checkbox">\n' +
    '      <input type="checkbox" ng-checked="model.sortingOptionsChecked(model.constantStrings.StudyDateSortOptionAsc)" ng-click="model.toggleSortingOptions(model.constantStrings.StudyDateSortOptionAsc)">\n' +
    '    </label>\n' +
    '    Study Date ASC\n' +
    '  </li>\n' +
    '</ul>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/filters/worklistFiltersTagsScrollTemplate.html',
    '<ul class="list tags-list">\n' +
    '	<li class="item item-checkbox">\n' +
    '		<label class="checkbox">\n' +
    '			<input type="checkbox" ng-checked="model.filters.ShowAllTags"\n' +
    '				ng-click="model.toggleTags(model.constantStrings.allOption)">\n' +
    '		</label>\n' +
    '		All\n' +
    '	</li>\n' +
    '	<li class="item item-checkbox">\n' +
    '		<label class="checkbox">\n' +
    '			<input type="checkbox" ng-checked="model.filters.ShowNoTags"\n' +
    '				ng-click="model.toggleNoTags()">\n' +
    '		</label>\n' +
    '		No Tags\n' +
    '	</li>\n' +
    '	<li class="item item-checkbox" ng-repeat="tag in model.tags">\n' +
    '		<label class="checkbox">\n' +
    '			<input type="checkbox" ng-checked="model.tagsChecked(tag)" ng-click="model.toggleTags(tag)">\n' +
    '		</label>\n' +
    '		{{tag}}\n' +
    '	</li>\n' +
    '</ul>');
}]);

angular.module('techpad').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/templates/filters/worklistFiltersVisitTypeScrollTemplate.html',
    '<ul class="list">\n' +
    '    <li class="item item-checkbox" ng-repeat="type in model.visitTypes">\n' +
    '        <label class="checkbox">\n' +
    '            <input type="checkbox" ng-checked="model.visitTypeChecked(type.code)"\n' +
    '                ng-click="model.toggleVisitTypes(type.code)">\n' +
    '        </label>\n' +
    '        {{type.label}}\n' +
    '    </li>\n' +
    '</ul>');
}]);



// WEBPACK FOOTER //
// ./src/scripts/partials.js